import * as t from "react";
import _e, { useState as x, useEffect as O, useRef as K, createContext as ms, useCallback as ce, useId as nl, useMemo as is, useLayoutEffect as bs, useContext as rl } from "react";
import { CalciteAction as ds, CalciteFlow as cl, CalciteFlowItem as $t, CalciteSlider as ha, CalciteInputNumber as Ha, CalciteButton as ol, CalcitePopover as ml, CalciteColorPicker as ys, CalciteLabel as le, CalciteSelect as Fa, CalciteOption as be, CalciteSegmentedControl as gs, CalciteSegmentedControlItem as Xe, CalciteSwitch as fs, CalciteBlock as _a, CalciteNotice as Dt, CalciteAccordion as il, CalciteAccordionItem as bl, CalciteLoader as dl, CalciteCardGroup as yl, CalciteCard as gl } from "@esri/calcite-components-react";
import { useSelector as Ht, useDispatch as fl } from "react-redux";
import { createSlice as $a, createAsyncThunk as Qe, combineReducers as pl } from "@reduxjs/toolkit";
import * as Bt from "@arcgis/core/intl";
import { useTranslation as Pe } from "react-i18next";
import { CalciteNavigation as hl, CalciteAction as Za, CalciteNavigationLogo as ul, CalciteDropdown as Al, CalciteNavigationUser as Sl, CalciteDropdownGroup as it, CalciteDropdownItem as bt, CalciteTooltip as zt, CalciteShellPanel as Nl, CalciteActionBar as wl, CalciteFlow as Ul, CalciteFlowItem as vl } from "@esri/calcite-components-react/dist";
import _l from "@arcgis/core/widgets/LayerList";
import * as ps from "@arcgis/core/core/reactiveUtils";
import { useMapViewContext as He, MapMode as Ye, basemaps as xl, useMapState as Ll } from "@origo/map-context";
import { Checkbox as Cl, Tree as kl, Tooltip as xa, ToolbarItem as ua, Button as hs, Slider as Zt, NumberInput as El, Select as Da, ColorPicker as Va, Combobox as Ml, Switch as Gt, SegmentedControl as jl, IconButton as us, Toolbar as Tl, Notice as As, Loader as Hl, TextInput as Zl, ListCard as Rl, Dialog as Il, Alert as Ss } from "@origo/origo-ui";
import Vl from "@arcgis/core/widgets/BasemapGallery";
import Pl from "@arcgis/core/widgets/BasemapGallery/support/LocalBasemapsSource";
import Ol from "@arcgis/core/widgets/Print";
import Fl from "@arcgis/core/widgets/Legend";
import $l from "@arcgis/core/widgets/Sketch";
import Sa from "@arcgis/core/layers/GraphicsLayer";
import Dl from "@arcgis/core/layers/FeatureLayer";
import { renderPreviewHTML as Rt } from "@arcgis/core/symbols/support/symbolUtils";
import It from "@arcgis/core/symbols/CIMSymbol";
import * as Bl from "@arcgis/core/geometry/operators/areaOperator";
import * as Wt from "@arcgis/core/geometry/operators/lengthOperator";
import dt from "@arcgis/core/Graphic";
import Ra from "@arcgis/core/geometry/Point";
import zl from "@arcgis/core/geometry/Polyline";
import Gl from "@arcgis/core/Color";
import { scaleCIMSymbolTo as Wl, applyCIMSymbolColor as Kl, getCIMSymbolSize as ql, getCIMSymbolColor as Yl } from "@arcgis/core/symbols/support/cimSymbolUtils";
import Jl from "@arcgis/core/symbols/WebStyleSymbol";
import Xl from "@arcgis/core/symbols/SimpleMarkerSymbol";
import Kt from "@arcgis/core/widgets/Sketch/SketchViewModel";
import * as Ql from "@arcgis/core/geometry/operators/intersectsOperator";
import en from "@arcgis/core/views/interactive/snapping/SnappingOptions";
import an from "@arcgis/core/views/interactive/snapping/FeatureSnappingLayerSource";
import Ns from "@arcgis/core/portal/Portal";
import tn from "@arcgis/core/layers/Layer";
import ws from "@arcgis/core/portal/PortalGroup";
import Us from "@arcgis/core/portal/PortalItem";
import sn from "@arcgis/core/WebMap";
import { createPortal as vs } from "react-dom";
import La from "@arcgis/core/geometry/Point.js";
import ln from "@arcgis/core/geometry/Extent.js";
import nn from "@arcgis/core/Graphic.js";
var kt = { exports: {} }, da = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qt;
function rn() {
  if (qt)
    return da;
  qt = 1;
  var a = _e, e = Symbol.for("react.element"), l = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, c = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function b(i, d, m) {
    var g, h = {}, f = null, u = null;
    m !== void 0 && (f = "" + m), d.key !== void 0 && (f = "" + d.key), d.ref !== void 0 && (u = d.ref);
    for (g in d)
      r.call(d, g) && !o.hasOwnProperty(g) && (h[g] = d[g]);
    if (i && i.defaultProps)
      for (g in d = i.defaultProps, d)
        h[g] === void 0 && (h[g] = d[g]);
    return { $$typeof: e, type: i, key: f, ref: u, props: h, _owner: c.current };
  }
  return da.Fragment = l, da.jsx = b, da.jsxs = b, da;
}
var ya = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yt;
function cn() {
  return Yt || (Yt = 1, process.env.NODE_ENV !== "production" && function() {
    var a = _e, e = Symbol.for("react.element"), l = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), b = Symbol.for("react.provider"), i = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), u = Symbol.for("react.offscreen"), v = Symbol.iterator, A = "@@iterator";
    function p(s) {
      if (s === null || typeof s != "object")
        return null;
      var y = v && s[v] || s[A];
      return typeof y == "function" ? y : null;
    }
    var S = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function U(s) {
      {
        for (var y = arguments.length, N = new Array(y > 1 ? y - 1 : 0), _ = 1; _ < y; _++)
          N[_ - 1] = arguments[_];
        w("error", s, N);
      }
    }
    function w(s, y, N) {
      {
        var _ = S.ReactDebugCurrentFrame, j = _.getStackAddendum();
        j !== "" && (y += "%s", N = N.concat([j]));
        var R = N.map(function(k) {
          return String(k);
        });
        R.unshift("Warning: " + y), Function.prototype.apply.call(console[s], console, R);
      }
    }
    var V = !1, J = !1, M = !1, X = !1, Z = !1, T;
    T = Symbol.for("react.module.reference");
    function P(s) {
      return !!(typeof s == "string" || typeof s == "function" || s === r || s === o || Z || s === c || s === m || s === g || X || s === u || V || J || M || typeof s == "object" && s !== null && (s.$$typeof === f || s.$$typeof === h || s.$$typeof === b || s.$$typeof === i || s.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      s.$$typeof === T || s.getModuleId !== void 0));
    }
    function E(s, y, N) {
      var _ = s.displayName;
      if (_)
        return _;
      var j = y.displayName || y.name || "";
      return j !== "" ? N + "(" + j + ")" : N;
    }
    function I(s) {
      return s.displayName || "Context";
    }
    function F(s) {
      if (s == null)
        return null;
      if (typeof s.tag == "number" && U("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof s == "function")
        return s.displayName || s.name || null;
      if (typeof s == "string")
        return s;
      switch (s) {
        case r:
          return "Fragment";
        case l:
          return "Portal";
        case o:
          return "Profiler";
        case c:
          return "StrictMode";
        case m:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case i:
            var y = s;
            return I(y) + ".Consumer";
          case b:
            var N = s;
            return I(N._context) + ".Provider";
          case d:
            return E(s, s.render, "ForwardRef");
          case h:
            var _ = s.displayName || null;
            return _ !== null ? _ : F(s.type) || "Memo";
          case f: {
            var j = s, R = j._payload, k = j._init;
            try {
              return F(k(R));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ne = 0, z, W, ie, ue, Ze, je, H;
    function ge() {
    }
    ge.__reactDisabledLog = !0;
    function Re() {
      {
        if (ne === 0) {
          z = console.log, W = console.info, ie = console.warn, ue = console.error, Ze = console.group, je = console.groupCollapsed, H = console.groupEnd;
          var s = {
            configurable: !0,
            enumerable: !0,
            value: ge,
            writable: !0
          };
          Object.defineProperties(console, {
            info: s,
            log: s,
            warn: s,
            error: s,
            group: s,
            groupCollapsed: s,
            groupEnd: s
          });
        }
        ne++;
      }
    }
    function Oe() {
      {
        if (ne--, ne === 0) {
          var s = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, s, {
              value: z
            }),
            info: q({}, s, {
              value: W
            }),
            warn: q({}, s, {
              value: ie
            }),
            error: q({}, s, {
              value: ue
            }),
            group: q({}, s, {
              value: Ze
            }),
            groupCollapsed: q({}, s, {
              value: je
            }),
            groupEnd: q({}, s, {
              value: H
            })
          });
        }
        ne < 0 && U("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var xe = S.ReactCurrentDispatcher, Le;
    function Ce(s, y, N) {
      {
        if (Le === void 0)
          try {
            throw Error();
          } catch (j) {
            var _ = j.stack.trim().match(/\n( *(at )?)/);
            Le = _ && _[1] || "";
          }
        return `
` + Le + s;
      }
    }
    var Ie = !1, ke;
    {
      var ea = typeof WeakMap == "function" ? WeakMap : Map;
      ke = new ea();
    }
    function C(s, y) {
      if (!s || Ie)
        return "";
      {
        var N = ke.get(s);
        if (N !== void 0)
          return N;
      }
      var _;
      Ie = !0;
      var j = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var R;
      R = xe.current, xe.current = null, Re();
      try {
        if (y) {
          var k = function() {
            throw Error();
          };
          if (Object.defineProperty(k.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(k, []);
            } catch (se) {
              _ = se;
            }
            Reflect.construct(s, [], k);
          } else {
            try {
              k.call();
            } catch (se) {
              _ = se;
            }
            s.call(k.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (se) {
            _ = se;
          }
          s();
        }
      } catch (se) {
        if (se && _ && typeof se.stack == "string") {
          for (var L = se.stack.split(`
`), ae = _.stack.split(`
`), $ = L.length - 1, B = ae.length - 1; $ >= 1 && B >= 0 && L[$] !== ae[B]; )
            B--;
          for (; $ >= 1 && B >= 0; $--, B--)
            if (L[$] !== ae[B]) {
              if ($ !== 1 || B !== 1)
                do
                  if ($--, B--, B < 0 || L[$] !== ae[B]) {
                    var re = `
` + L[$].replace(" at new ", " at ");
                    return s.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", s.displayName)), typeof s == "function" && ke.set(s, re), re;
                  }
                while ($ >= 1 && B >= 0);
              break;
            }
        }
      } finally {
        Ie = !1, xe.current = R, Oe(), Error.prepareStackTrace = j;
      }
      var we = s ? s.displayName || s.name : "", fe = we ? Ce(we) : "";
      return typeof s == "function" && ke.set(s, fe), fe;
    }
    function Y(s, y, N) {
      return C(s, !1);
    }
    function te(s) {
      var y = s.prototype;
      return !!(y && y.isReactComponent);
    }
    function Q(s, y, N) {
      if (s == null)
        return "";
      if (typeof s == "function")
        return C(s, te(s));
      if (typeof s == "string")
        return Ce(s);
      switch (s) {
        case m:
          return Ce("Suspense");
        case g:
          return Ce("SuspenseList");
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case d:
            return Y(s.render);
          case h:
            return Q(s.type, y, N);
          case f: {
            var _ = s, j = _._payload, R = _._init;
            try {
              return Q(R(j), y, N);
            } catch {
            }
          }
        }
      return "";
    }
    var ee = Object.prototype.hasOwnProperty, oe = {}, Ae = S.ReactDebugCurrentFrame;
    function Se(s) {
      if (s) {
        var y = s._owner, N = Q(s.type, s._source, y ? y.type : null);
        Ae.setExtraStackFrame(N);
      } else
        Ae.setExtraStackFrame(null);
    }
    function aa(s, y, N, _, j) {
      {
        var R = Function.call.bind(ee);
        for (var k in s)
          if (R(s, k)) {
            var L = void 0;
            try {
              if (typeof s[k] != "function") {
                var ae = Error((_ || "React class") + ": " + N + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ae.name = "Invariant Violation", ae;
              }
              L = s[k](y, k, _, N, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch ($) {
              L = $;
            }
            L && !(L instanceof Error) && (Se(j), U("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", _ || "React class", N, k, typeof L), Se(null)), L instanceof Error && !(L.message in oe) && (oe[L.message] = !0, Se(j), U("Failed %s type: %s", N, L.message), Se(null));
          }
      }
    }
    var D = Array.isArray;
    function ye(s) {
      return D(s);
    }
    function G(s) {
      {
        var y = typeof Symbol == "function" && Symbol.toStringTag, N = y && s[Symbol.toStringTag] || s.constructor.name || "Object";
        return N;
      }
    }
    function Ue(s) {
      try {
        return Fe(s), !1;
      } catch {
        return !0;
      }
    }
    function Fe(s) {
      return "" + s;
    }
    function ta(s) {
      if (Ue(s))
        return U("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", G(s)), Fe(s);
    }
    var Ee = S.ReactCurrentOwner, Ga = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, sa, la, ze;
    ze = {};
    function Wa(s) {
      if (ee.call(s, "ref")) {
        var y = Object.getOwnPropertyDescriptor(s, "ref").get;
        if (y && y.isReactWarning)
          return !1;
      }
      return s.ref !== void 0;
    }
    function Ka(s) {
      if (ee.call(s, "key")) {
        var y = Object.getOwnPropertyDescriptor(s, "key").get;
        if (y && y.isReactWarning)
          return !1;
      }
      return s.key !== void 0;
    }
    function qa(s, y) {
      if (typeof s.ref == "string" && Ee.current && y && Ee.current.stateNode !== y) {
        var N = F(Ee.current.type);
        ze[N] || (U('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', F(Ee.current.type), s.ref), ze[N] = !0);
      }
    }
    function Ya(s, y) {
      {
        var N = function() {
          sa || (sa = !0, U("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", y));
        };
        N.isReactWarning = !0, Object.defineProperty(s, "key", {
          get: N,
          configurable: !0
        });
      }
    }
    function Ja(s, y) {
      {
        var N = function() {
          la || (la = !0, U("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", y));
        };
        N.isReactWarning = !0, Object.defineProperty(s, "ref", {
          get: N,
          configurable: !0
        });
      }
    }
    var Xa = function(s, y, N, _, j, R, k) {
      var L = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: s,
        key: y,
        ref: N,
        props: k,
        // Record the component responsible for creating this element.
        _owner: R
      };
      return L._store = {}, Object.defineProperty(L._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(L, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: _
      }), Object.defineProperty(L, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: j
      }), Object.freeze && (Object.freeze(L.props), Object.freeze(L)), L;
    };
    function Qa(s, y, N, _, j) {
      {
        var R, k = {}, L = null, ae = null;
        N !== void 0 && (ta(N), L = "" + N), Ka(y) && (ta(y.key), L = "" + y.key), Wa(y) && (ae = y.ref, qa(y, j));
        for (R in y)
          ee.call(y, R) && !Ga.hasOwnProperty(R) && (k[R] = y[R]);
        if (s && s.defaultProps) {
          var $ = s.defaultProps;
          for (R in $)
            k[R] === void 0 && (k[R] = $[R]);
        }
        if (L || ae) {
          var B = typeof s == "function" ? s.displayName || s.name || "Unknown" : s;
          L && Ya(k, B), ae && Ja(k, B);
        }
        return Xa(s, L, ae, j, _, Ee.current, k);
      }
    }
    var Ge = S.ReactCurrentOwner, na = S.ReactDebugCurrentFrame;
    function Ne(s) {
      if (s) {
        var y = s._owner, N = Q(s.type, s._source, y ? y.type : null);
        na.setExtraStackFrame(N);
      } else
        na.setExtraStackFrame(null);
    }
    var We;
    We = !1;
    function Ke(s) {
      return typeof s == "object" && s !== null && s.$$typeof === e;
    }
    function ra() {
      {
        if (Ge.current) {
          var s = F(Ge.current.type);
          if (s)
            return `

Check the render method of \`` + s + "`.";
        }
        return "";
      }
    }
    function et(s) {
      {
        if (s !== void 0) {
          var y = s.fileName.replace(/^.*[\\\/]/, ""), N = s.lineNumber;
          return `

Check your code at ` + y + ":" + N + ".";
        }
        return "";
      }
    }
    var ca = {};
    function at(s) {
      {
        var y = ra();
        if (!y) {
          var N = typeof s == "string" ? s : s.displayName || s.name;
          N && (y = `

Check the top-level render call using <` + N + ">.");
        }
        return y;
      }
    }
    function oa(s, y) {
      {
        if (!s._store || s._store.validated || s.key != null)
          return;
        s._store.validated = !0;
        var N = at(y);
        if (ca[N])
          return;
        ca[N] = !0;
        var _ = "";
        s && s._owner && s._owner !== Ge.current && (_ = " It was passed a child from " + F(s._owner.type) + "."), Ne(s), U('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', N, _), Ne(null);
      }
    }
    function ma(s, y) {
      {
        if (typeof s != "object")
          return;
        if (ye(s))
          for (var N = 0; N < s.length; N++) {
            var _ = s[N];
            Ke(_) && oa(_, y);
          }
        else if (Ke(s))
          s._store && (s._store.validated = !0);
        else if (s) {
          var j = p(s);
          if (typeof j == "function" && j !== s.entries)
            for (var R = j.call(s), k; !(k = R.next()).done; )
              Ke(k.value) && oa(k.value, y);
        }
      }
    }
    function tt(s) {
      {
        var y = s.type;
        if (y == null || typeof y == "string")
          return;
        var N;
        if (typeof y == "function")
          N = y.propTypes;
        else if (typeof y == "object" && (y.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        y.$$typeof === h))
          N = y.propTypes;
        else
          return;
        if (N) {
          var _ = F(y);
          aa(N, s.props, "prop", _, s);
        } else if (y.PropTypes !== void 0 && !We) {
          We = !0;
          var j = F(y);
          U("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", j || "Unknown");
        }
        typeof y.getDefaultProps == "function" && !y.getDefaultProps.isReactClassApproved && U("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function st(s) {
      {
        for (var y = Object.keys(s.props), N = 0; N < y.length; N++) {
          var _ = y[N];
          if (_ !== "children" && _ !== "key") {
            Ne(s), U("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", _), Ne(null);
            break;
          }
        }
        s.ref !== null && (Ne(s), U("Invalid attribute `ref` supplied to `React.Fragment`."), Ne(null));
      }
    }
    var ia = {};
    function ba(s, y, N, _, j, R) {
      {
        var k = P(s);
        if (!k) {
          var L = "";
          (s === void 0 || typeof s == "object" && s !== null && Object.keys(s).length === 0) && (L += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ae = et(j);
          ae ? L += ae : L += ra();
          var $;
          s === null ? $ = "null" : ye(s) ? $ = "array" : s !== void 0 && s.$$typeof === e ? ($ = "<" + (F(s.type) || "Unknown") + " />", L = " Did you accidentally export a JSX literal instead of a component?") : $ = typeof s, U("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", $, L);
        }
        var B = Qa(s, y, N, j, R);
        if (B == null)
          return B;
        if (k) {
          var re = y.children;
          if (re !== void 0)
            if (_)
              if (ye(re)) {
                for (var we = 0; we < re.length; we++)
                  ma(re[we], s);
                Object.freeze && Object.freeze(re);
              } else
                U("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ma(re, s);
        }
        if (ee.call(y, "key")) {
          var fe = F(s), se = Object.keys(y).filter(function(mt) {
            return mt !== "key";
          }), qe = se.length > 0 ? "{key: someKey, " + se.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ia[fe + qe]) {
            var ot = se.length > 0 ? "{" + se.join(": ..., ") + ": ...}" : "{}";
            U(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, qe, fe, ot, fe), ia[fe + qe] = !0;
          }
        }
        return s === r ? st(B) : tt(B), B;
      }
    }
    function lt(s, y, N) {
      return ba(s, y, N, !0);
    }
    function nt(s, y, N) {
      return ba(s, y, N, !1);
    }
    var rt = nt, ct = lt;
    ya.Fragment = r, ya.jsx = rt, ya.jsxs = ct;
  }()), ya;
}
process.env.NODE_ENV === "production" ? kt.exports = rn() : kt.exports = cn();
var n = kt.exports;
const on = ({
  panels: a,
  side: e,
  activePanel: l,
  onPanelChange: r
}) => /* @__PURE__ */ n.jsx(n.Fragment, { children: Object.entries(a).map(([c, o]) => /* @__PURE__ */ n.jsx(
  ds,
  {
    icon: o.icon,
    text: o.label,
    onClick: () => r?.(l === c ? null : c),
    active: l === c
  },
  c
)) }), mn = {
  left: null,
  right: null
  // panelene er lukket ved oppstart
}, _s = $a({
  name: "panel",
  initialState: mn,
  reducers: {
    setActiveLeftPanel(a, e) {
      a.left = e.payload;
    },
    setActiveRightPanel(a, e) {
      a.right = e.payload;
    }
  }
}), { setActiveLeftPanel: d0, setActiveRightPanel: y0 } = _s.actions, g0 = _s.reducer, f0 = () => Ht((a) => a.panel.left), p0 = () => Ht((a) => a.panel.right), h0 = () => fl();
function u0({
  title: a,
  description: e,
  logo: l = "geodata-logo.png",
  user: r,
  onSignOut: c,
  onShowInfo: o,
  onToggleMenu: b,
  showMenuButton: i = !1,
  showInfoButton: d = !1
}) {
  const { t: m, i18n: g } = Pe("uiComponents"), [h, f] = x(!1);
  return O(() => {
    Bt.setLocale(g.language);
  }, []), /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    /* @__PURE__ */ n.jsxs(hl, { slot: "header", children: [
      i && /* @__PURE__ */ n.jsx(
        Za,
        {
          slot: "navigation-action",
          icon: "hamburger",
          text: "Toggle menu",
          onClick: b
        }
      ),
      /* @__PURE__ */ n.jsx(
        ul,
        {
          slot: "logo",
          heading: a || m("header.title"),
          description: e || m("header.description"),
          thumbnail: l
        }
      ),
      d && /* @__PURE__ */ n.jsx(
        Za,
        {
          slot: "content-end",
          id: "header-information",
          icon: "question",
          text: m("header.showInfoLabel"),
          scale: "l",
          onClick: o
        }
      ),
      /* @__PURE__ */ n.jsxs(
        Al,
        {
          slot: "user",
          id: "header-user-dropdown",
          onCalciteDropdownOpen: () => f(!0),
          onCalciteDropdownClose: () => f(!1),
          open: h ? !0 : void 0,
          onCalciteDropdownSelect: () => f(!1),
          widthScale: "m",
          children: [
            /* @__PURE__ */ n.jsx(
              Za,
              {
                slot: "trigger",
                id: "header-settings",
                icon: "gear",
                text: m("header.showInfoLabel"),
                scale: "l"
              }
            ),
            r && /* @__PURE__ */ n.jsx(
              Sl,
              {
                slot: "trigger",
                active: h ? !0 : void 0,
                fullName: r.fullName,
                username: r.username,
                thumbnail: r.thumbnailUrl
              }
            ),
            /* @__PURE__ */ n.jsx(it, { selectionMode: "none", children: /* @__PURE__ */ n.jsx(bt, { iconStart: "language-translate", onCalciteDropdownItemSelect: () => {
              const u = g.language == "nb" ? "en" : "nb";
              g.changeLanguage(u), Bt.setLocale(u);
            }, children: m("header.languageToggleLabel") }) }),
            /* @__PURE__ */ n.jsx(it, { selectionMode: "none", children: r?.orgUrl && /* @__PURE__ */ n.jsx(bt, { iconStart: "arcgis-online", onCalciteDropdownItemSelect: () => {
              window.open(r.orgUrl, "_blank");
            }, children: m("header.arcgisOnlineLabel") }) }),
            c && /* @__PURE__ */ n.jsx(it, { selectionMode: "none", children: /* @__PURE__ */ n.jsx(bt, { iconStart: "sign-out", onCalciteDropdownItemSelect: c, children: m("header.signoutLabel") }) })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ n.jsx(zt, { placement: "bottom-end", closeOnClick: !0, referenceElement: "header-information", children: m("header.showInfoTooltip") }),
    /* @__PURE__ */ n.jsx(zt, { placement: "bottom-end", closeOnClick: !0, referenceElement: "header-user-dropdown", open: void 0, children: m("header.userDropdownTooltip") })
  ] });
}
const A0 = ({ panels: a, activePanel: e }) => {
  if (!e || !a[e])
    return null;
  console.log("Rendering LeftPanel with activePanel:", e);
  const l = a[e].component;
  return /* @__PURE__ */ n.jsx("div", { className: "left-panel", children: /* @__PURE__ */ n.jsx(l, {}) });
}, S0 = ({ panels: a, activePanel: e }) => !e || !a[e] ? null : /* @__PURE__ */ n.jsx("div", { className: "right-panel", children: a[e].panel }), bn = ({
  panels: a,
  activePanel: e,
  className: l,
  onHeadingChange: r,
  onDescriptionChange: c
}) => {
  if (!e || !a[e])
    return null;
  const b = a[e].component;
  return /* @__PURE__ */ n.jsx("div", { className: l, children: /* @__PURE__ */ n.jsx(
    b,
    {
      onHeadingChange: r,
      onDescriptionChange: c
    }
  ) });
}, xs = ({
  panels: a,
  activePanel: e,
  onPanelChange: l,
  onPanelClose: r,
  side: c,
  expanded: o,
  initialWidth: b,
  onPanelInfo: i
}) => {
  const [d, m] = x(""), [g, h] = x(void 0);
  if (O(() => {
    if (e && a[e]) {
      const A = a[e];
      m(A.heading || A.label), h(A.description);
    } else
      m(""), h(void 0);
  }, [e, a]), !a)
    return null;
  const f = c === "left", u = c === "left" ? "start" : "end", v = c === "left" ? "panel-start" : "panel-end";
  return /* @__PURE__ */ n.jsxs(
    Nl,
    {
      position: u,
      slot: v,
      resizable: !0,
      collapsed: !e,
      style: {
        "--calcite-shell-panel-width": b || "400px",
        "--calcite-shell-panel-max-width": "70vw"
      },
      ...f && { layout: "vertical" },
      children: [
        /* @__PURE__ */ n.jsx(wl, { id: "main_toolbar", slot: "action-bar", expanded: o, children: /* @__PURE__ */ n.jsx(
          on,
          {
            panels: a,
            side: c,
            activePanel: e,
            onPanelChange: l
          }
        ) }),
        /* @__PURE__ */ n.jsx(Ul, { children: /* @__PURE__ */ n.jsxs(
          vl,
          {
            heading: d,
            collapsible: !0,
            closable: !0,
            closed: !e,
            description: g,
            onCalciteFlowItemClose: r,
            children: [
              e && /* @__PURE__ */ n.jsx(
                Za,
                {
                  slot: "header-actions-end",
                  id: "panel-information",
                  icon: "question",
                  text: "Show panel info",
                  scale: "l",
                  onClick: () => i?.(e)
                }
              ),
              /* @__PURE__ */ n.jsx(
                bn,
                {
                  panels: a,
                  activePanel: e,
                  className: f ? "left-panel" : "right-panel",
                  onHeadingChange: m,
                  onDescriptionChange: h
                }
              )
            ]
          }
        ) })
      ]
    }
  );
}, N0 = (a) => /* @__PURE__ */ n.jsx(
  xs,
  {
    ...a,
    side: "left",
    expanded: !0
  }
), w0 = (a) => /* @__PURE__ */ n.jsx(
  xs,
  {
    ...a,
    side: "right"
  }
);
function U0() {
  const { t: a } = Pe("map"), e = K(null), l = K(), { mapView: r, sceneView: c, mapMode: o } = He();
  O(() => () => {
    l.current?.removeHandles("location-analytics");
  }, []), O(() => {
    if (!l.current) {
      const d = o === Ye.ThreeD ? c : r;
      d && (l.current = b(d));
    }
  }, [o, r, c]), O(() => {
    if (!l.current)
      return;
    const d = o === Ye.ThreeD ? c : r;
    d && l.current.view !== d && (console.log(`Switching LayerList to ${o === Ye.ThreeD ? "3D" : "2D"} view`), l.current.view = d);
  }, [o, r, c]);
  const b = (d) => {
    console.log("Creating LayerList widget with view:", d.type);
    const m = new _l({
      view: d,
      // Bruk den passede view'et
      container: e.current,
      filterPlaceholder: a("layerlist.filterPlaceholder"),
      dragEnabled: !0,
      visibleElements: {
        filter: !0,
        statusIndicators: !0
      },
      listItemCreatedFunction: function(f) {
        const u = f.item;
        u.actionsSections = [
          [
            {
              title: "Delete",
              icon: "trash",
              id: "delete"
            },
            {
              title: "Layer information",
              icon: "information",
              id: "information"
            }
          ]
        ];
      }
    }), g = m.on("trigger-action", (f) => {
      console.log(f), f.action.id === "delete" && l.current?.view?.map && l.current.view.map.remove(f.item.layer);
    }), h = ps.watch(() => l.current?.viewModel.state, (f) => {
      console.log("LayerList state", f);
    });
    return m.addHandles([g, h], "location-analytics"), m;
  }, i = {
    display: "unset"
  };
  return /* @__PURE__ */ n.jsx("div", { children: /* @__PURE__ */ n.jsx("div", { id: "esri-layer-list", style: i, className: "widget-container", ref: e }) });
}
const dn = "LayerListCustom-module__item___qrsm5", yn = "LayerListCustom-module__row___07KOG", gn = "LayerListCustom-module__dragHandle___-70p3", fn = "LayerListCustom-module__dragging___JoSbZ", pn = "LayerListCustom-module__dropAbove___4kUlw", hn = "LayerListCustom-module__dropBelow___JIlJ9", un = "LayerListCustom-module__expandBtn___WsMcW", An = "LayerListCustom-module__spacer___mSQAU", Sn = "LayerListCustom-module__children___cKm0l", Nn = "LayerListCustom-module__container___6-8QZ", wn = "LayerListCustom-module__searchInput___dCQFL", ve = {
  item: dn,
  row: yn,
  dragHandle: gn,
  dragging: fn,
  dropAbove: pn,
  dropBelow: hn,
  expandBtn: un,
  spacer: An,
  children: Sn,
  container: Nn,
  searchInput: wn
}, Un = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M236,184a12,12,0,0,1-24,0A84,84,0,0,0,68.6,124.6L53.11,140H88a12,12,0,0,1,0,24H24a12,12,0,0,1-12-12V88a12,12,0,0,1,24,0v35.16l15.66-15.55A108,108,0,0,1,236,184Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M88,152H24V88Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M201.54,110.46a104,104,0,0,0-145.4-1.63L29.66,82.34A8,8,0,0,0,16,88v64a8,8,0,0,0,8,8H88a8,8,0,0,0,5.66-13.66L67.47,120.16A88,88,0,0,1,216,184a8,8,0,0,0,16,0A103.33,103.33,0,0,0,201.54,110.46ZM32,144V107.31L68.69,144Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M232,184a8,8,0,0,1-16,0A88,88,0,0,0,67.47,120.16l26.19,26.18A8,8,0,0,1,88,160H24a8,8,0,0,1-8-8V88a8,8,0,0,1,13.66-5.66l26.48,26.48A104,104,0,0,1,232,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M230,184a6,6,0,0,1-12,0A90,90,0,0,0,64.36,120.36L38.55,146H88a6,6,0,0,1,0,12H24a6,6,0,0,1-6-6V88a6,6,0,0,1,12,0v49.58l25.89-25.72A102,102,0,0,1,230,184Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M232,184a8,8,0,0,1-16,0A88,88,0,0,0,65.78,121.78L43.4,144H88a8,8,0,0,1,0,16H24a8,8,0,0,1-8-8V88a8,8,0,0,1,16,0v44.77l22.48-22.33A104,104,0,0,1,232,184Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M228,184a4,4,0,0,1-8,0A92,92,0,0,0,63,119L33.7,148H88a4,4,0,0,1,0,8H24a4,4,0,0,1-4-4V88a4,4,0,0,1,8,0v54.39l29.3-29.11A100,100,0,0,1,228,184Z" }))
  ]
]), vn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M244,88v64a12,12,0,0,1-12,12H168a12,12,0,0,1,0-24h34.9l-15.48-15.37A84,84,0,0,0,44,184a12,12,0,0,1-24,0,108,108,0,0,1,184.37-76.37L220,123.16V88a12,12,0,0,1,24,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M232,88v64H168Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M235.06,80.61a8,8,0,0,0-8.72,1.73l-26.48,26.49A104,104,0,0,0,24,184a8,8,0,0,0,16,0,88,88,0,0,1,148.53-63.84l-26.19,26.18A8,8,0,0,0,168,160h64a8,8,0,0,0,8-8V88A8,8,0,0,0,235.06,80.61ZM224,144H187.31L224,107.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M240,88v64a8,8,0,0,1-8,8H168a8,8,0,0,1-5.66-13.66l26.19-26.18A88,88,0,0,0,40,184a8,8,0,0,1-16,0,104,104,0,0,1,175.86-75.18l26.48-26.48A8,8,0,0,1,240,88Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M238,88v64a6,6,0,0,1-6,6H168a6,6,0,0,1,0-12h49.45l-25.8-25.63A90,90,0,0,0,38,184a6,6,0,0,1-12,0,102,102,0,0,1,174.12-72.12L226,137.58V88a6,6,0,0,1,12,0Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M240,88v64a8,8,0,0,1-8,8H168a8,8,0,0,1,0-16h44.6l-22.36-22.21A88,88,0,0,0,40,184a8,8,0,0,1-16,0,104,104,0,0,1,177.54-73.54L224,132.77V88a8,8,0,0,1,16,0Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M236,88v64a4,4,0,0,1-4,4H168a4,4,0,0,1,0-8h54.3l-29.24-29A92,92,0,0,0,36,184a4,4,0,0,1-8,0,100,100,0,0,1,170.71-70.71L228,142.39V88a4,4,0,0,1,8,0Z" }))
  ]
]), _n = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M208,96l-80,80L48,96Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M215.39,92.94A8,8,0,0,0,208,88H48a8,8,0,0,0-5.66,13.66l80,80a8,8,0,0,0,11.32,0l80-80A8,8,0,0,0,215.39,92.94ZM128,164.69,67.31,104H188.69Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,48,88H208a8,8,0,0,1,5.66,13.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M210.83,98.83l-80,80a4,4,0,0,1-5.66,0l-80-80a4,4,0,0,1,5.66-5.66L128,170.34l77.17-77.17a4,4,0,1,1,5.66,5.66Z" }))
  ]
]), xn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M176,128,96,208V48Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M181.66,122.34l-80-80A8,8,0,0,0,88,48V208a8,8,0,0,0,13.66,5.66l80-80A8,8,0,0,0,181.66,122.34ZM104,188.69V67.31L164.69,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M178.83,130.83l-80,80a4,4,0,0,1-5.66-5.66L170.34,128,93.17,50.83a4,4,0,0,1,5.66-5.66l80,80A4,4,0,0,1,178.83,130.83Z" }))
  ]
]), Ln = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M176.49,95.51a12,12,0,0,1,0,17l-56,56a12,12,0,0,1-17,0l-24-24a12,12,0,1,1,17-17L112,143l47.51-47.52A12,12,0,0,1,176.49,95.51ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,85.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76ZM230,128A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M170.83,101.17a4,4,0,0,1,0,5.66l-56,56a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L112,154.34l53.17-53.17A4,4,0,0,1,170.83,101.17ZM228,128A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))
  ]
]), Cn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M232,128A104,104,0,1,1,128,24,104.13,104.13,0,0,1,232,128Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Z" }))
  ]
]), kn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M224.15,179.17l-46.83-46.82,37.93-13.51.76-.3a20,20,0,0,0-1.76-37.27L54.16,29A20,20,0,0,0,29,54.16L81.27,214.24A20,20,0,0,0,118.54,216c.11-.25.21-.5.3-.76l13.51-37.92,46.83,46.82a20,20,0,0,0,28.28,0l16.69-16.68A20,20,0,0,0,224.15,179.17Zm-30.83,25.17-48.48-48.48A20,20,0,0,0,130.7,150a20.66,20.66,0,0,0-3.74.35A20,20,0,0,0,112.35,162c-.11.25-.21.5-.3.76L100.4,195.5,54.29,54.29l141.21,46.1-32.71,11.66c-.26.09-.51.19-.76.3a20,20,0,0,0-6.17,32.48h0l48.49,48.48Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M213.66,201,201,213.66a8,8,0,0,1-11.31,0l-51.31-51.31a8,8,0,0,0-13,2.46l-17.82,46.41a8,8,0,0,1-14.85-.71L40.41,50.44a8,8,0,0,1,10-10L210.51,92.68a8,8,0,0,1,.71,14.85l-46.41,17.82a8,8,0,0,0-2.46,13l51.31,51.31A8,8,0,0,1,213.66,201Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M168,132.69,214.08,115l.33-.13A16,16,0,0,0,213,85.07L52.92,32.8A15.95,15.95,0,0,0,32.8,52.92L85.07,213a15.82,15.82,0,0,0,14.41,11l.78,0a15.84,15.84,0,0,0,14.61-9.59l.13-.33L132.69,168,184,219.31a16,16,0,0,0,22.63,0l12.68-12.68a16,16,0,0,0,0-22.63ZM195.31,208,144,156.69a16,16,0,0,0-26,4.93c0,.11-.09.22-.13.32l-17.65,46L48,48l159.85,52.2-45.95,17.64-.32.13a16,16,0,0,0-4.93,26h0L208,195.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M220.49,207.8,207.8,220.49a12,12,0,0,1-17,0l-56.57-56.57L115,214.08l-.13.33A15.84,15.84,0,0,1,100.26,224l-.78,0a15.82,15.82,0,0,1-14.41-11L32.8,52.92A15.95,15.95,0,0,1,52.92,32.8L213,85.07a16,16,0,0,1,1.41,29.8l-.33.13-50.16,19.27,56.57,56.56A12,12,0,0,1,220.49,207.8Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M166.59,134.1a1.91,1.91,0,0,1-.55-1.79,2,2,0,0,1,1.08-1.42l46.25-17.76.24-.1A14,14,0,0,0,212.38,87L52.29,34.7A13.95,13.95,0,0,0,34.7,52.29L87,212.38a13.82,13.82,0,0,0,12.6,9.6c.23,0,.46,0,.69,0A13.84,13.84,0,0,0,113,213.61a2.44,2.44,0,0,0,.1-.24l17.76-46.25a2,2,0,0,1,3.21-.53l51.31,51.31a14,14,0,0,0,19.8,0l12.69-12.69a14,14,0,0,0,0-19.8Zm42.82,62.63-12.68,12.68a2,2,0,0,1-2.83,0L142.59,158.1a14,14,0,0,0-22.74,4.32,2.44,2.44,0,0,0-.1.24L102,208.91a2,2,0,0,1-3.61-.26L46.11,48.57a1.87,1.87,0,0,1,.47-2A1.92,1.92,0,0,1,47.93,46a2.22,2.22,0,0,1,.64.1L208.65,98.38a2,2,0,0,1,.26,3.61l-46.25,17.76-.24.1a14,14,0,0,0-4.32,22.74h0l51.31,51.31A2,2,0,0,1,209.41,196.73Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M168,132.69,214.08,115l.33-.13A16,16,0,0,0,213,85.07L52.92,32.8A15.95,15.95,0,0,0,32.8,52.92L85.07,213a15.82,15.82,0,0,0,14.41,11l.78,0a15.84,15.84,0,0,0,14.61-9.59l.13-.33L132.69,168,184,219.31a16,16,0,0,0,22.63,0l12.68-12.68a16,16,0,0,0,0-22.63ZM195.31,208,144,156.69a16,16,0,0,0-26,4.93c0,.11-.09.22-.13.32l-17.65,46L48,48l159.85,52.2-45.95,17.64-.32.13a16,16,0,0,0-4.93,26h0L208,195.31Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M165.17,135.51a4,4,0,0,1,1.17-6.46l46.31-17.79.16-.06a12,12,0,0,0-1.05-22.33L51.67,36.6A12,12,0,0,0,36.6,51.67L88.87,211.76A11.86,11.86,0,0,0,99.67,220h.58a11.86,11.86,0,0,0,11-7.19l.06-.16,17.79-46.31a4,4,0,0,1,6.47-1.17l51.31,51.32a12,12,0,0,0,17,0l12.69-12.69a12,12,0,0,0,0-17Zm45.66,62.63-12.69,12.69a4,4,0,0,1-5.66,0l-51.31-51.31a12,12,0,0,0-8.48-3.52,12.13,12.13,0,0,0-2.24.21,12,12,0,0,0-8.77,7l-.06.16-17.79,46.31a4,4,0,0,1-7.36-.42L44.2,49.19a4,4,0,0,1,5-5L209.27,96.47a4,4,0,0,1,.42,7.36l-46.31,17.78-.16.07a12,12,0,0,0-3.71,19.49l51.32,51.31A4,4,0,0,1,210.83,198.14Z" }))
  ]
]), En = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M108,60A16,16,0,1,1,92,44,16,16,0,0,1,108,60Zm56,16a16,16,0,1,0-16-16A16,16,0,0,0,164,76ZM92,112a16,16,0,1,0,16,16A16,16,0,0,0,92,112Zm72,0a16,16,0,1,0,16,16A16,16,0,0,0,164,112ZM92,180a16,16,0,1,0,16,16A16,16,0,0,0,92,180Zm72,0a16,16,0,1,0,16,16A16,16,0,0,0,164,180Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M208,32V224a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V32A16,16,0,0,1,64,16H192A16,16,0,0,1,208,32Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M192,16H64A16,16,0,0,0,48,32V224a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V32A16,16,0,0,0,192,16ZM100,200a12,12,0,1,1,12-12A12,12,0,0,1,100,200Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,100,140Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,100,80Zm56,120a12,12,0,1,1,12-12A12,12,0,0,1,156,200Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,156,140Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,156,80Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M102,60A10,10,0,1,1,92,50,10,10,0,0,1,102,60Zm62,10a10,10,0,1,0-10-10A10,10,0,0,0,164,70ZM92,118a10,10,0,1,0,10,10A10,10,0,0,0,92,118Zm72,0a10,10,0,1,0,10,10A10,10,0,0,0,164,118ZM92,186a10,10,0,1,0,10,10A10,10,0,0,0,92,186Zm72,0a10,10,0,1,0,10,10A10,10,0,0,0,164,186Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M100,60a8,8,0,1,1-8-8A8,8,0,0,1,100,60Zm64,8a8,8,0,1,0-8-8A8,8,0,0,0,164,68ZM92,120a8,8,0,1,0,8,8A8,8,0,0,0,92,120Zm72,0a8,8,0,1,0,8,8A8,8,0,0,0,164,120ZM92,188a8,8,0,1,0,8,8A8,8,0,0,0,92,188Zm72,0a8,8,0,1,0,8,8A8,8,0,0,0,164,188Z" }))
  ]
]), Mn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M251,123.13c-.37-.81-9.13-20.26-28.48-39.61C196.63,57.67,164,44,128,44S59.37,57.67,33.51,83.52C14.16,102.87,5.4,122.32,5,123.13a12.08,12.08,0,0,0,0,9.75c.37.82,9.13,20.26,28.49,39.61C59.37,198.34,92,212,128,212s68.63-13.66,94.48-39.51c19.36-19.35,28.12-38.79,28.49-39.61A12.08,12.08,0,0,0,251,123.13Zm-46.06,33C183.47,177.27,157.59,188,128,188s-55.47-10.73-76.91-31.88A130.36,130.36,0,0,1,29.52,128,130.45,130.45,0,0,1,51.09,99.89C72.54,78.73,98.41,68,128,68s55.46,10.73,76.91,31.89A130.36,130.36,0,0,1,226.48,128,130.45,130.45,0,0,1,204.91,156.12ZM128,84a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,84Zm0,64a20,20,0,1,1,20-20A20,20,0,0,1,128,148Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Zm0,112a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M245.48,125.57c-.34-.78-8.66-19.23-27.24-37.81C201,70.54,171.38,50,128,50S55,70.54,37.76,87.76c-18.58,18.58-26.9,37-27.24,37.81a6,6,0,0,0,0,4.88c.34.77,8.66,19.22,27.24,37.8C55,185.47,84.62,206,128,206s73-20.53,90.24-37.75c18.58-18.58,26.9-37,27.24-37.8A6,6,0,0,0,245.48,125.57ZM128,194c-31.38,0-58.78-11.42-81.45-33.93A134.77,134.77,0,0,1,22.69,128,134.56,134.56,0,0,1,46.55,95.94C69.22,73.42,96.62,62,128,62s58.78,11.42,81.45,33.94A134.56,134.56,0,0,1,233.31,128C226.94,140.21,195,194,128,194Zm0-112a46,46,0,1,0,46,46A46.06,46.06,0,0,0,128,82Zm0,80a34,34,0,1,1,34-34A34,34,0,0,1,128,162Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M243.66,126.38c-.34-.76-8.52-18.89-26.83-37.2C199.87,72.22,170.7,52,128,52S56.13,72.22,39.17,89.18c-18.31,18.31-26.49,36.44-26.83,37.2a4.08,4.08,0,0,0,0,3.25c.34.77,8.52,18.89,26.83,37.2,17,17,46.14,37.17,88.83,37.17s71.87-20.21,88.83-37.17c18.31-18.31,26.49-36.43,26.83-37.2A4.08,4.08,0,0,0,243.66,126.38Zm-32.7,35c-23.07,23-51,34.62-83,34.62s-59.89-11.65-83-34.62A135.71,135.71,0,0,1,20.44,128,135.69,135.69,0,0,1,45,94.62C68.11,71.65,96,60,128,60s59.89,11.65,83,34.62A135.79,135.79,0,0,1,235.56,128,135.71,135.71,0,0,1,211,161.38ZM128,84a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,84Zm0,80a36,36,0,1,1,36-36A36,36,0,0,1,128,164Z" }))
  ]
]), jn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M108,84a16,16,0,1,1,16,16A16,16,0,0,1,108,84Zm128,44A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Zm-72,36.68V132a20,20,0,0,0-20-20,12,12,0,0,0-4,23.32V168a20,20,0,0,0,20,20,12,12,0,0,0,4-23.32Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M144,176a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176Zm88-48A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128ZM124,96a12,12,0,1,0-12-12A12,12,0,0,0,124,96Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-4,48a12,12,0,1,1-12,12A12,12,0,0,1,124,72Zm12,112a16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M142,176a6,6,0,0,1-6,6,14,14,0,0,1-14-14V128a2,2,0,0,0-2-2,6,6,0,0,1,0-12,14,14,0,0,1,14,14v40a2,2,0,0,0,2,2A6,6,0,0,1,142,176ZM124,94a10,10,0,1,0-10-10A10,10,0,0,0,124,94Zm106,34A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M140,176a4,4,0,0,1-4,4,12,12,0,0,1-12-12V128a4,4,0,0,0-4-4,4,4,0,0,1,0-8,12,12,0,0,1,12,12v40a4,4,0,0,0,4,4A4,4,0,0,1,140,176ZM124,92a8,8,0,1,0-8-8A8,8,0,0,0,124,92Zm104,36A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))
  ]
]), Tn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M207.83,56.53C186.32,43.29,158,36,128,36S69.68,43.29,48.17,56.53C24.85,70.89,12,90.6,12,112s12.85,41.14,36.17,55.5c18.48,11.37,42,18.34,67.29,20.08-2,11.07-9.09,17.75-15.22,21.54-13.48,8.31-32.75,9.18-46.86,2.1A12,12,0,1,0,42.62,232.7a71.76,71.76,0,0,0,32,7.3,73.2,73.2,0,0,0,38.18-10.43c15.45-9.54,25-24.58,26.83-41.9,25.6-1.64,49.47-8.65,68.16-20.15C231.15,153.16,244,133.45,244,112S231.15,70.89,207.83,56.53Zm-134.44,97a21,21,0,0,1,20.16-9.35c10.36,1.39,16.54,9.43,19.72,19.13A135.3,135.3,0,0,1,73.39,153.56Zm64.87,10.14a61.84,61.84,0,0,0-10.76-24.82,46.08,46.08,0,0,0-30.75-18.46c-18-2.41-34.52,5.89-44.1,21C42.2,133,36,122.84,36,112c0-28.19,42.13-52,92-52s92,23.82,92,52C220,138.26,183.51,160.71,138.26,163.7Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M232,112c0,35.35-46.56,64-104,64S24,147.35,24,112,70.56,48,128,48,232,76.65,232,112Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M205.73,59.93C184.85,47.08,157.24,40,128,40S71.15,47.08,50.27,59.93C28.17,73.52,16,92,16,112S28.17,150.44,50.27,164c19,11.67,43.49,18.56,69.73,19.73v0a37.35,37.35,0,0,1-18.58,33c-14.64,8.86-34.62,9.52-49.72,1.64a8,8,0,1,0-7.4,14.18A66.4,66.4,0,0,0,75,240a67.31,67.31,0,0,0,34.74-9.5c17-10.27,26.29-26.86,26.29-46.7v0c26.24-1.17,50.76-8.06,69.73-19.73C227.83,150.44,240,132,240,112S227.83,73.52,205.73,59.93ZM67.41,155.18c5.24-9.55,15.45-12,23.53-11,10.9,1.42,21.86,9.13,26.61,23.42C99.11,166.45,81.85,162.16,67.41,155.18Zm129.94-4.77c-16.95,10.43-39.17,16.53-63.13,17.43a54.37,54.37,0,0,0-11.39-23.07A47.17,47.17,0,0,0,93,128.35c-17-2.2-31.72,5.11-39.38,18.7C39.64,137,32,124.73,32,112c0-14.21,9.47-27.86,26.65-38.43C77.05,62.23,101.68,56,128,56S179,62.23,197.35,73.55C214.53,84.12,224,97.77,224,112S214.53,139.84,197.35,150.41Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M93.43,136.11a17.14,17.14,0,0,0-15.35,6.1c9.31,6.56,22.51,11.33,37.43,13.07C110.41,143.33,101.72,137,93.43,136.11Z" }), /* @__PURE__ */ t.createElement("path", { d: "M224,48V208a16,16,0,0,1-16,16H127.65a4,4,0,0,1-3.23-6.34c7.5-10.23,11.58-23.24,11.58-37.84,0-2.79-.13-5.46-.35-8.05C176.79,169.33,208,147.47,208,120c0-29.15-35.14-52-80-52S48,90.84,48,120c0,27.31,30.82,49.07,71.58,51.73a77,77,0,0,1,.42,8.09c0,17.62-7.65,31.95-21,39.32A38.77,38.77,0,0,1,79.27,224H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48Zm-32,72c0-19.51-29.31-36-64-36s-64,16.48-64,36a21.29,21.29,0,0,0,3,10.63A33.65,33.65,0,0,1,95.16,120.2c15,1.63,30.84,13.4,37.54,35.68C165.3,154.47,192,138.62,192,120Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M204.68,61.63C184.11,49,156.88,42,128,42S71.89,49,51.32,61.63C29.83,74.85,18,92.73,18,112s11.83,37.13,33.32,50.35C70.45,174.1,95.35,181,122,181.85c0,.64,0,1.28,0,1.94,0,14.76-6.94,27.1-19.54,34.73-15.22,9.22-36,9.9-51.68,1.71a6,6,0,1,0-5.56,10.63A64.45,64.45,0,0,0,75,238a65.24,65.24,0,0,0,33.7-9.22c16.34-9.89,25.33-25.87,25.33-45,0-.65,0-1.29,0-1.94,26.65-.89,51.57-7.74,70.72-19.52C226.17,149.11,238,131.23,238,112S226.17,74.85,204.68,61.63Zm-140,94.46c5.32-12,17.2-15.07,26.48-13.87,12.28,1.6,24.64,10.67,29.08,27.55C99.73,168.81,80.48,164.08,64.72,156.09Zm133.67-4c-17.62,10.85-40.83,17.1-65.77,17.79a52.77,52.77,0,0,0-11.31-23.84,45.24,45.24,0,0,0-28.56-15.73c-16.89-2.2-31.49,5.54-38.41,19.68C38.61,139.37,30,126,30,112c0-14.93,9.8-29.18,27.61-40.13C76.32,60.34,101.32,54,128,54s51.68,6.34,70.39,17.85C216.2,82.8,226,97.05,226,112S216.2,141.16,198.39,152.11Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M205.73,59.93C184.85,47.08,157.24,40,128,40S71.15,47.08,50.27,59.93C28.17,73.52,16,92,16,112S28.17,150.44,50.27,164c19,11.67,43.49,18.56,69.73,19.73v0a37.35,37.35,0,0,1-18.58,33c-14.64,8.86-34.62,9.52-49.72,1.64a8,8,0,1,0-7.4,14.18A66.4,66.4,0,0,0,75,240a67.31,67.31,0,0,0,34.74-9.5c17-10.27,26.29-26.86,26.29-46.7v0c26.24-1.17,50.76-8.06,69.73-19.73C227.83,150.44,240,132,240,112S227.83,73.52,205.73,59.93ZM67.41,155.18c5.24-9.55,15.44-12,23.53-11,10.9,1.42,21.86,9.13,26.61,23.42C99.11,166.45,81.85,162.16,67.41,155.18Zm129.94-4.77c-16.95,10.43-39.17,16.53-63.13,17.43a54.37,54.37,0,0,0-11.39-23.07A47.17,47.17,0,0,0,93,128.35c-17-2.2-31.72,5.11-39.38,18.7C39.64,137,32,124.73,32,112c0-14.21,9.47-27.86,26.65-38.43C77.05,62.23,101.68,56,128,56S179,62.23,197.35,73.55C214.53,84.12,224,97.77,224,112S214.53,139.84,197.35,150.41Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M203.64,63.34C183.37,50.87,156.51,44,128,44S72.63,50.87,52.36,63.34C31.49,76.19,20,93.48,20,112s11.49,35.83,32.36,48.68c19.29,11.87,44.55,18.65,71.51,19.28.08,1.27.13,2.56.13,3.9,0,15.49-7.28,28.44-20.51,36.46-15.79,9.57-37.34,10.28-53.64,1.77a4,4,0,1,0-3.7,7.09A62.32,62.32,0,0,0,74.91,236a63.56,63.56,0,0,0,32.73-8.82c15.71-9.52,24.36-24.9,24.36-43.3,0-1.32-.05-2.61-.12-3.9,27.06-.59,52.41-7.38,71.76-19.28C224.51,147.85,236,130.56,236,112S224.51,76.19,203.64,63.34ZM62.16,157.15c5.3-14.49,18.83-18.22,29.3-16.85,13.64,1.78,27.38,12.19,31.38,31.66C99.66,171.25,78.55,165.78,62.16,157.15ZM131,172a51.35,51.35,0,0,0-11.18-24.59,43.28,43.28,0,0,0-27.3-15.06c-16.82-2.19-31.24,6-37.33,20.74C38.33,142.35,28,127.9,28,112c0-33.09,44.86-60,100-60s100,26.93,100,60C228,144.52,184.74,171.06,131,172Z" }))
  ]
]), Hn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M217.47,38.53a36,36,0,0,0-57.95,41l-80,80a36.07,36.07,0,0,0-41,7h0a36,36,0,1,0,58,9.95l80-80a36,36,0,0,0,41-57.95Zm-145,162a12,12,0,1,1,0-17A12,12,0,0,1,72.48,200.5Zm128-128a12,12,0,0,1-17,0h0a12,12,0,1,1,17,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M81,175A24,24,0,1,1,47,175,24,24,0,0,1,81,175ZM209,47A24,24,0,1,0,209,81,24,24,0,0,0,209,47Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M214.64,41.36a32,32,0,0,0-50.2,38.89L80.25,164.44a32.06,32.06,0,0,0-38.89,4.94h0a32,32,0,1,0,50.2,6.37l84.19-84.19a32,32,0,0,0,38.89-50.2Zm-139.33,162a16,16,0,0,1-22.64-22.64h0a16,16,0,0,1,22.63,0h0A16,16,0,0,1,75.31,203.33Zm128-128a16,16,0,1,1,0-22.63A16,16,0,0,1,203.33,75.3Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M211.81,83.79a28,28,0,0,1-33.12,4.83L88.62,178.69a28,28,0,1,1-44.43-6.48h0a28,28,0,0,1,33.12-4.83l90.07-90.07a28,28,0,1,1,44.43,6.48Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M213.23,42.77A30,30,0,0,0,167,80.54L80.54,167a30.07,30.07,0,0,0-37.77,3.81h0A30,30,0,1,0,89,175.46L175.46,89a30,30,0,0,0,37.77-46.25Zm-136.51,162a18,18,0,1,1,0-25.46A18,18,0,0,1,76.72,204.74Zm128-128a18,18,0,0,1-25.46,0h0a18,18,0,1,1,25.46,0Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M214.64,41.36a32,32,0,0,0-50.2,38.89L80.25,164.44a32.06,32.06,0,0,0-38.89,4.94h0a32,32,0,1,0,50.2,6.37l84.19-84.19a32,32,0,0,0,38.89-50.2Zm-139.33,162a16,16,0,0,1-22.64-22.64h0a16,16,0,0,1,22.63,0h0A16,16,0,0,1,75.31,203.33Zm128-128a16,16,0,1,1,0-22.63A16,16,0,0,1,203.33,75.3Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M211.81,44.19a28,28,0,0,0-42.23,36.57L80.76,169.58a28,28,0,0,0-36.57,2.63h0a28,28,0,1,0,42.23,3l88.82-88.82a28,28,0,0,0,36.57-42.23Zm-133.67,162a20,20,0,1,1,0-28.28A20,20,0,0,1,78.14,206.15Zm128-128a20,20,0,0,1-28.28,0h0a20,20,0,1,1,28.28,0Z" }))
  ]
]), Zn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M200,36H160a20,20,0,0,0-20,20v88a12,12,0,0,1-24,0V56A20,20,0,0,0,96,36H56A20,20,0,0,0,36,56v88a92,92,0,0,0,92,92h.71c50.34-.38,91.3-42.1,91.3-93V56A20,20,0,0,0,200,36Zm-4,24V84H164V60ZM92,60V84H60V60Zm36.52,152H128a68,68,0,0,1-68-68V108H92v36a36,36,0,0,0,72,0V108h32v35C196,180.77,165.73,211.72,128.52,212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M104,56V96H48V56a8,8,0,0,1,8-8H96A8,8,0,0,1,104,56Zm96-8H160a8,8,0,0,0-8,8V96h56V56A8,8,0,0,0,200,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M200,40H160a16,16,0,0,0-16,16v88a16,16,0,0,1-32,0V56A16,16,0,0,0,96,40H56A16,16,0,0,0,40,56v88a88,88,0,0,0,88,88h.67c48.15-.36,87.33-40.29,87.33-89V56A16,16,0,0,0,200,40Zm0,16V88H160V56ZM96,56V88H56V56Zm32.55,160A72,72,0,0,1,56,144V104H96v40a32,32,0,0,0,64,0V104h40v39C200,183,168,215.71,128.55,216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M200,40H160a16,16,0,0,0-16,16v88a16,16,0,0,1-32,0V56A16,16,0,0,0,96,40H56A16,16,0,0,0,40,56v88a88,88,0,0,0,88,88h.67c48.15-.36,87.33-40.29,87.33-89V56A16,16,0,0,0,200,40Zm0,16V96H160V56ZM96,56V96H56V56Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M200,42H160a14,14,0,0,0-14,14v88a18,18,0,0,1-36,0V56A14,14,0,0,0,96,42H56A14,14,0,0,0,42,56v88a86,86,0,0,0,86,86h.65c47.06-.35,85.35-39.38,85.35-87V56A14,14,0,0,0,200,42ZM160,54h40a2,2,0,0,1,2,2V90H158V56A2,2,0,0,1,160,54ZM56,54H96a2,2,0,0,1,2,2V90H54V56A2,2,0,0,1,56,54Zm72.56,164H128a74,74,0,0,1-74-74V102H98v42a30,30,0,0,0,60,0V102h44v41C202,184.05,169.06,217.7,128.56,218Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M200,40H160a16,16,0,0,0-16,16v88a16,16,0,0,1-32,0V56A16,16,0,0,0,96,40H56A16,16,0,0,0,40,56v88a88,88,0,0,0,88,88h.67c48.15-.36,87.33-40.29,87.33-89V56A16,16,0,0,0,200,40Zm0,16V88H160V56ZM96,56V88H56V56Zm32.55,160A72,72,0,0,1,56,144V104H96v40a32,32,0,0,0,64,0V104h40v39C200,183,168,215.71,128.55,216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M200,44H160a12,12,0,0,0-12,12v88a20,20,0,0,1-40,0V56A12,12,0,0,0,96,44H56A12,12,0,0,0,44,56v88a84,84,0,0,0,84,84h.64c46-.34,83.36-38.47,83.36-85V56A12,12,0,0,0,200,44Zm-40,8h40a4,4,0,0,1,4,4V92H156V56A4,4,0,0,1,160,52ZM56,52H96a4,4,0,0,1,4,4V92H52V56A4,4,0,0,1,56,52Zm72.58,168H128a76,76,0,0,1-76-76V100h48v44a28,28,0,0,0,56,0V100h48v43C204,185.15,170.17,219.69,128.58,220Z" }))
  ]
]), Rn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M232.49,215.51,185,168a92.12,92.12,0,1,0-17,17l47.53,47.54a12,12,0,0,0,17-17ZM44,112a68,68,0,1,1,68,68A68.07,68.07,0,0,1,44,112Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M192,112a80,80,0,1,1-80-80A80,80,0,0,1,192,112Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M168,112a56,56,0,1,1-56-56A56,56,0,0,1,168,112Zm61.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88,88,0,1,1,11.32-11.31l50.06,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M228.24,219.76l-51.38-51.38a86.15,86.15,0,1,0-8.48,8.48l51.38,51.38a6,6,0,0,0,8.48-8.48ZM38,112a74,74,0,1,1,74,74A74.09,74.09,0,0,1,38,112Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M226.83,221.17l-52.7-52.7a84.1,84.1,0,1,0-5.66,5.66l52.7,52.7a4,4,0,0,0,5.66-5.66ZM36,112a76,76,0,1,1,76,76A76.08,76.08,0,0,1,36,112Z" }))
  ]
]), In = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,60a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,60Zm0,64a20,20,0,1,1,20-20A20,20,0,0,1,128,124Zm0-112a92.1,92.1,0,0,0-92,92c0,77.36,81.64,135.4,85.12,137.83a12,12,0,0,0,13.76,0,259,259,0,0,0,42.18-39C205.15,170.57,220,136.37,220,104A92.1,92.1,0,0,0,128,12Zm31.3,174.71A249.35,249.35,0,0,1,128,216.89a249.35,249.35,0,0,1-31.3-30.18C80,167.37,60,137.31,60,104a68,68,0,0,1,136,0C196,137.31,176,167.37,159.3,186.71Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M128,24a80,80,0,0,0-80,80c0,72,80,128,80,128s80-56,80-128A80,80,0,0,0,128,24Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,128,136Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,16a88.1,88.1,0,0,0-88,88c0,75.3,80,132.17,83.41,134.55a8,8,0,0,0,9.18,0C136,236.17,216,179.3,216,104A88.1,88.1,0,0,0,128,16Zm0,56a32,32,0,1,1-32,32A32,32,0,0,1,128,72Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,66a38,38,0,1,0,38,38A38,38,0,0,0,128,66Zm0,64a26,26,0,1,1,26-26A26,26,0,0,1,128,130Zm0-112a86.1,86.1,0,0,0-86,86c0,30.91,14.34,63.74,41.47,94.94a252.32,252.32,0,0,0,41.09,38,6,6,0,0,0,6.88,0,252.32,252.32,0,0,0,41.09-38c27.13-31.2,41.47-64,41.47-94.94A86.1,86.1,0,0,0,128,18Zm0,206.51C113,212.93,54,163.62,54,104a74,74,0,0,1,148,0C202,163.62,143,212.93,128,224.51Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,68a36,36,0,1,0,36,36A36,36,0,0,0,128,68Zm0,64a28,28,0,1,1,28-28A28,28,0,0,1,128,132Zm0-112a84.09,84.09,0,0,0-84,84c0,30.42,14.17,62.79,41,93.62a250,250,0,0,0,40.73,37.66,4,4,0,0,0,4.58,0A250,250,0,0,0,171,197.62c26.81-30.83,41-63.2,41-93.62A84.09,84.09,0,0,0,128,20Zm37.1,172.23A254.62,254.62,0,0,1,128,227a254.62,254.62,0,0,1-37.1-34.81C73.15,171.8,52,139.9,52,104a76,76,0,0,1,152,0C204,139.9,182.85,171.8,165.1,192.23Z" }))
  ]
]), Vn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M233.47,97.45a36,36,0,0,0-50.92-50.92h0a36.18,36.18,0,0,0-4.12,4.95l-22.55-6.15a36,36,0,0,0-61.34-22.8h0a36.05,36.05,0,0,0-7.8,39.24L57.19,88.37a36.08,36.08,0,0,0-42.66,6.17h0a36,36,0,0,0,45.73,55.21l65.28,47.87A36,36,0,1,0,182.62,180L208,108A35.91,35.91,0,0,0,233.47,97.45Zm-93.74,80.81L74.45,130.39a36.19,36.19,0,0,0-1.21-24.17L102.8,79.61a36,36,0,0,0,42.66-6.16,35.47,35.47,0,0,0,4.12-5l22.55,6.15a35.86,35.86,0,0,0,10.42,22.8A38.06,38.06,0,0,0,185.4,100L160,172A36,36,0,0,0,139.73,178.26ZM216.5,63.5a12,12,0,1,1-17,0A12,12,0,0,1,216.5,63.5Zm-105-24a12,12,0,1,1,0,17A12,12,0,0,1,111.51,39.5Zm-80,89a12,12,0,1,1,17,0A12,12,0,0,1,31.5,128.49Zm137,88a12,12,0,1,1,0-17A12,12,0,0,1,168.49,216.5Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M137,65A24,24,0,1,1,137,31,24,24,0,0,1,137,65ZM23,103A24,24,0,1,0,57,103,24,24,0,0,0,23,103Zm120,88A24,24,0,1,0,177,191,24,24,0,0,0,143,191ZM225,55A24,24,0,1,0,225,89,24,24,0,0,0,225,55Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M230.64,49.36a32,32,0,0,0-45.26,0h0a31.9,31.9,0,0,0-5.16,6.76L152,48.42A32,32,0,0,0,97.37,25.36h0a32.06,32.06,0,0,0-5.76,37.41L57.67,93.32a32.05,32.05,0,0,0-40.31,4.05h0a32,32,0,0,0,42.89,47.41l70,51.36a32,32,0,1,0,47.57-14.69l27.39-77.59q1.38.12,2.76.12a32,32,0,0,0,22.63-54.62Zm-122-12.69h0a16,16,0,1,1,0,22.64A16,16,0,0,1,108.68,36.67Zm-80,94.65a16,16,0,0,1,0-22.64h0a16,16,0,1,1,0,22.64Zm142.65,88a16,16,0,0,1-22.63-22.63h0a16,16,0,1,1,22.63,22.63Zm-8.55-43.18a32,32,0,0,0-23,7.08l-70-51.36a32.17,32.17,0,0,0-1.34-26.65l33.95-30.55a32,32,0,0,0,45.47-10.81L176,71.56a32,32,0,0,0,14.12,27Zm56.56-92.84A16,16,0,1,1,196.7,60.68h0a16,16,0,0,1,22.63,22.63Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M227.81,52.19a28,28,0,0,0-39.6,0h0a28.14,28.14,0,0,0-4,5L148,47.33A28,28,0,0,0,100.2,28.19h0A28,28,0,0,0,94.7,60L54.58,96.1a28,28,0,0,0-34.39,4.1h0a28,28,0,0,0,36.7,42.12l76.75,56.28a28,28,0,1,0,46.17-10.39,27.66,27.66,0,0,0-3.33-2.84L206.63,100q.69,0,1.38,0a28,28,0,0,0,19.8-47.79ZM161.39,180.05a28,28,0,0,0-18.29,5.64L66.36,129.41A28.15,28.15,0,0,0,65.29,108l40.12-36.11a28,28,0,0,0,38.37-9.12L180,72.66a27.88,27.88,0,0,0,8.17,19.13,28.61,28.61,0,0,0,3.32,2.85Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M229.23,50.78a30,30,0,0,0-42.44,0h0a29.82,29.82,0,0,0-5.56,7.69l-31.31-8.54A30,30,0,0,0,98.78,26.77h0A30.09,30.09,0,0,0,94.13,63.2L57.83,95.87a30.07,30.07,0,0,0-39.06,2.91h0a30,30,0,0,0,41.38,43.44l72.6,53.25a30,30,0,1,0,48.47-8.68,29.65,29.65,0,0,0-5.77-4.5l28.44-80.59A31.57,31.57,0,0,0,208,102a30,30,0,0,0,21.22-51.2Zm-122-15.52a18,18,0,1,1,0,25.46A18,18,0,0,1,107.27,35.26Zm-80,97.47a18,18,0,1,1,25.46,0A18,18,0,0,1,27.26,132.73Zm145.47,88a18,18,0,1,1,0-25.46A18,18,0,0,1,172.73,220.74Zm-8.61-42.43a30,30,0,0,0-24.27,7.48L67.24,132.54a30.14,30.14,0,0,0-1.38-27.75l36.3-32.67a30,30,0,0,0,44.62-10.61l31.31,8.54a30,30,0,0,0,8.7,23.16,30.47,30.47,0,0,0,5.78,4.51Zm56.62-93.59a18,18,0,1,1,0-25.46A18,18,0,0,1,220.74,84.72Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M230.64,49.36a32,32,0,0,0-45.26,0h0a31.9,31.9,0,0,0-5.16,6.76L152,48.42A32,32,0,0,0,97.37,25.36h0a32.06,32.06,0,0,0-5.76,37.41L57.67,93.32a32.05,32.05,0,0,0-40.31,4.05h0a32,32,0,0,0,42.89,47.41l70,51.36a32,32,0,1,0,47.57-14.69l27.39-77.59q1.38.12,2.76.12a32,32,0,0,0,22.63-54.62Zm-122-12.69h0a16,16,0,1,1,0,22.64A16,16,0,0,1,108.68,36.67Zm-80,94.65a16,16,0,0,1,0-22.64h0a16,16,0,1,1,0,22.64Zm142.65,88a16,16,0,0,1-22.63-22.63h0a16,16,0,1,1,22.63,22.63Zm-8.55-43.18a32,32,0,0,0-23,7.08l-70-51.36a32.17,32.17,0,0,0-1.34-26.65l33.95-30.55a32,32,0,0,0,45.47-10.81L176,71.56a32,32,0,0,0,14.12,27Zm56.56-92.84A16,16,0,1,1,196.7,60.68h0a16,16,0,0,1,22.63,22.63Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M227.81,52.19a28,28,0,0,0-39.6,0h0a27.84,27.84,0,0,0-5.88,8.65l-34.56-9.42A28,28,0,0,0,100.2,28.19h0a28.05,28.05,0,0,0-3.48,35.37L57.91,98.49a28,28,0,0,0-37.72,1.71h0a28,28,0,0,0,39.6,39.6l.18-.19,75.32,55.24A28,28,0,1,0,173,183.2l29.56-83.75A28.52,28.52,0,0,0,208,100a28,28,0,0,0,19.8-47.79ZM105.86,33.85a20,20,0,1,1,0,28.29A20,20,0,0,1,105.86,33.85Zm-80,100.29a20,20,0,1,1,28.28,0A20,20,0,0,1,25.85,134.14Zm148.3,88a20,20,0,1,1,0-28.28A20,20,0,0,1,174.15,222.15Zm-8.7-41.6a28,28,0,0,0-25.25,7.66h0l-.18.19L64.71,133.16a28.13,28.13,0,0,0-1.44-28.73L102.08,69.5a28,28,0,0,0,43.6-10.36l34.56,9.43a28,28,0,0,0,8,23.22,27.64,27.64,0,0,0,6.8,5Zm56.7-94.41a20,20,0,1,1,0-28.29A20,20,0,0,1,222.15,86.14Z" }))
  ]
]), Pn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,36H40A20,20,0,0,0,20,56V200a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A20,20,0,0,0,216,36Zm-4,160H44V60H212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M224,56V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216A8,8,0,0,1,224,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M232,56V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,42H40A14,14,0,0,0,26,56V200a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A14,14,0,0,0,216,42Zm2,158a2,2,0,0,1-2,2H40a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2H216a2,2,0,0,1,2,2Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,44H40A12,12,0,0,0,28,56V200a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V56A12,12,0,0,0,216,44Zm4,156a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4H216a4,4,0,0,1,4,4Z" }))
  ]
]), On = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M100,40a12,12,0,0,1,12-12h32a12,12,0,0,1,0,24H112A12,12,0,0,1,100,40Zm44,164H112a12,12,0,0,0,0,24h32a12,12,0,0,0,0-24ZM208,28H184a12,12,0,0,0,0,24h20V72a12,12,0,0,0,24,0V48A20,20,0,0,0,208,28Zm8,72a12,12,0,0,0-12,12v32a12,12,0,0,0,24,0V112A12,12,0,0,0,216,100Zm0,72a12,12,0,0,0-12,12v20H184a12,12,0,0,0,0,24h24a20,20,0,0,0,20-20V184A12,12,0,0,0,216,172ZM40,156a12,12,0,0,0,12-12V112a12,12,0,0,0-24,0v32A12,12,0,0,0,40,156Zm32,48H52V184a12,12,0,0,0-24,0v24a20,20,0,0,0,20,20H72a12,12,0,0,0,0-24ZM40,84A12,12,0,0,0,52,72V52H72a12,12,0,0,0,0-24H48A20,20,0,0,0,28,48V72A12,12,0,0,0,40,84ZM80,68h96a12,12,0,0,1,12,12v96a12,12,0,0,1-12,12H80a12,12,0,0,1-12-12V80A12,12,0,0,1,80,68Zm12,96h72V92H92Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M176,80v96H80V80Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8,8,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V72A8,8,0,0,0,40,80ZM176,184H80a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v96A8,8,0,0,1,176,184Zm-8-96H88v80h80Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8,8,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V72A8,8,0,0,0,40,80Zm144,96V80a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8v96a8,8,0,0,0,8,8h96A8,8,0,0,0,184,176Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M106,40a6,6,0,0,1,6-6h32a6,6,0,0,1,0,12H112A6,6,0,0,1,106,40Zm38,170H112a6,6,0,0,0,0,12h32a6,6,0,0,0,0-12ZM208,34H184a6,6,0,0,0,0,12h24a2,2,0,0,1,2,2V72a6,6,0,0,0,12,0V48A14,14,0,0,0,208,34Zm8,72a6,6,0,0,0-6,6v32a6,6,0,0,0,12,0V112A6,6,0,0,0,216,106Zm0,72a6,6,0,0,0-6,6v24a2,2,0,0,1-2,2H184a6,6,0,0,0,0,12h24a14,14,0,0,0,14-14V184A6,6,0,0,0,216,178ZM40,150a6,6,0,0,0,6-6V112a6,6,0,0,0-12,0v32A6,6,0,0,0,40,150Zm32,60H48a2,2,0,0,1-2-2V184a6,6,0,0,0-12,0v24a14,14,0,0,0,14,14H72a6,6,0,0,0,0-12ZM40,78a6,6,0,0,0,6-6V48a2,2,0,0,1,2-2H72a6,6,0,0,0,0-12H48A14,14,0,0,0,34,48V72A6,6,0,0,0,40,78ZM176,182H80a6,6,0,0,1-6-6V80a6,6,0,0,1,6-6h96a6,6,0,0,1,6,6v96A6,6,0,0,1,176,182Zm-6-96H86v84h84Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8,8,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V72A8,8,0,0,0,40,80ZM176,184H80a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v96A8,8,0,0,1,176,184Zm-8-96H88v80h80Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M108,40a4,4,0,0,1,4-4h32a4,4,0,0,1,0,8H112A4,4,0,0,1,108,40Zm36,172H112a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8ZM208,36H184a4,4,0,0,0,0,8h24a4,4,0,0,1,4,4V72a4,4,0,0,0,8,0V48A12,12,0,0,0,208,36Zm8,72a4,4,0,0,0-4,4v32a4,4,0,0,0,8,0V112A4,4,0,0,0,216,108Zm0,72a4,4,0,0,0-4,4v24a4,4,0,0,1-4,4H184a4,4,0,0,0,0,8h24a12,12,0,0,0,12-12V184A4,4,0,0,0,216,180ZM40,148a4,4,0,0,0,4-4V112a4,4,0,0,0-8,0v32A4,4,0,0,0,40,148Zm32,64H48a4,4,0,0,1-4-4V184a4,4,0,0,0-8,0v24a12,12,0,0,0,12,12H72a4,4,0,0,0,0-8ZM40,76a4,4,0,0,0,4-4V48a4,4,0,0,1,4-4H72a4,4,0,0,0,0-8H48A12,12,0,0,0,36,48V72A4,4,0,0,0,40,76ZM180,176a4,4,0,0,1-4,4H80a4,4,0,0,1-4-4V80a4,4,0,0,1,4-4h96a4,4,0,0,1,4,4Zm-8-92H84v88h88Z" }))
  ]
]), Fn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,48H180V36A28,28,0,0,0,152,8H104A28,28,0,0,0,76,36V48H40a12,12,0,0,0,0,24h4V208a20,20,0,0,0,20,20H192a20,20,0,0,0,20-20V72h4a12,12,0,0,0,0-24ZM100,36a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4V48H100Zm88,168H68V72H188ZM116,104v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Zm48,0v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM112,168a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm0-120H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,50H174V40a22,22,0,0,0-22-22H104A22,22,0,0,0,82,40V50H40a6,6,0,0,0,0,12H50V208a14,14,0,0,0,14,14H192a14,14,0,0,0,14-14V62h10a6,6,0,0,0,0-12ZM94,40a10,10,0,0,1,10-10h48a10,10,0,0,1,10,10V50H94ZM194,208a2,2,0,0,1-2,2H64a2,2,0,0,1-2-2V62H194ZM110,104v64a6,6,0,0,1-12,0V104a6,6,0,0,1,12,0Zm48,0v64a6,6,0,0,1-12,0V104a6,6,0,0,1,12,0Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,52H172V40a20,20,0,0,0-20-20H104A20,20,0,0,0,84,40V52H40a4,4,0,0,0,0,8H52V208a12,12,0,0,0,12,12H192a12,12,0,0,0,12-12V60h12a4,4,0,0,0,0-8ZM92,40a12,12,0,0,1,12-12h48a12,12,0,0,1,12,12V52H92ZM196,208a4,4,0,0,1-4,4H64a4,4,0,0,1-4-4V60H196ZM108,104v64a4,4,0,0,1-8,0V104a4,4,0,0,1,8,0Zm48,0v64a4,4,0,0,1-8,0V104a4,4,0,0,1,8,0Z" }))
  ]
]), $n = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M240.26,186.1,152.81,34.23h0a28.74,28.74,0,0,0-49.62,0L15.74,186.1a27.45,27.45,0,0,0,0,27.71A28.31,28.31,0,0,0,40.55,228h174.9a28.31,28.31,0,0,0,24.79-14.19A27.45,27.45,0,0,0,240.26,186.1Zm-20.8,15.7a4.46,4.46,0,0,1-4,2.2H40.55a4.46,4.46,0,0,1-4-2.2,3.56,3.56,0,0,1,0-3.73L124,46.2a4.77,4.77,0,0,1,8,0l87.44,151.87A3.56,3.56,0,0,1,219.46,201.8ZM116,136V104a12,12,0,0,1,24,0v32a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,176Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M215.46,216H40.54C27.92,216,20,202.79,26.13,192.09L113.59,40.22c6.3-11,22.52-11,28.82,0l87.46,151.87C236,202.79,228.08,216,215.46,216Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M235.07,189.09,147.61,37.22h0a22.75,22.75,0,0,0-39.22,0L20.93,189.09a21.53,21.53,0,0,0,0,21.72A22.35,22.35,0,0,0,40.55,222h174.9a22.35,22.35,0,0,0,19.6-11.19A21.53,21.53,0,0,0,235.07,189.09ZM224.66,204.8a10.46,10.46,0,0,1-9.21,5.2H40.55a10.46,10.46,0,0,1-9.21-5.2,9.51,9.51,0,0,1,0-9.72L118.79,43.21a10.75,10.75,0,0,1,18.42,0l87.46,151.87A9.51,9.51,0,0,1,224.66,204.8ZM122,144V104a6,6,0,0,1,12,0v40a6,6,0,0,1-12,0Zm16,36a10,10,0,1,1-10-10A10,10,0,0,1,138,180Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M233.34,190.09,145.88,38.22h0a20.75,20.75,0,0,0-35.76,0L22.66,190.09a19.52,19.52,0,0,0,0,19.71A20.36,20.36,0,0,0,40.54,220H215.46a20.36,20.36,0,0,0,17.86-10.2A19.52,19.52,0,0,0,233.34,190.09ZM226.4,205.8a12.47,12.47,0,0,1-10.94,6.2H40.54a12.47,12.47,0,0,1-10.94-6.2,11.45,11.45,0,0,1,0-11.72L117.05,42.21a12.76,12.76,0,0,1,21.9,0L226.4,194.08A11.45,11.45,0,0,1,226.4,205.8ZM124,144V104a4,4,0,0,1,8,0v40a4,4,0,0,1-8,0Zm12,36a8,8,0,1,1-8-8A8,8,0,0,1,136,180Z" }))
  ]
]), Dn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm-12-80V80a12,12,0,0,1,24,0v52a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,172Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-8,56a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm-6-82V80a6,6,0,0,1,12,0v56a6,6,0,0,1-12,0Zm16,36a10,10,0,1,1-10-10A10,10,0,0,1,138,172Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm-4-84V80a4,4,0,0,1,8,0v56a4,4,0,0,1-8,0Zm12,36a8,8,0,1,1-8-8A8,8,0,0,1,136,172Z" }))
  ]
]), Bn = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z" }))
  ]
]), Et = ms({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
}), me = t.forwardRef(
  (a, e) => {
    const {
      alt: l,
      color: r,
      size: c,
      weight: o,
      mirrored: b,
      children: i,
      weights: d,
      ...m
    } = a, {
      color: g = "currentColor",
      size: h,
      weight: f = "regular",
      mirrored: u = !1,
      ...v
    } = t.useContext(Et);
    return /* @__PURE__ */ t.createElement(
      "svg",
      {
        ref: e,
        xmlns: "http://www.w3.org/2000/svg",
        width: c ?? h,
        height: c ?? h,
        fill: r ?? g,
        viewBox: "0 0 256 256",
        transform: b || u ? "scale(-1, 1)" : void 0,
        ...v,
        ...m
      },
      !!l && /* @__PURE__ */ t.createElement("title", null, l),
      i,
      d.get(o ?? f)
    );
  }
);
me.displayName = "IconBase";
const Ls = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: Un }));
Ls.displayName = "ArrowArcLeftIcon";
const Cs = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: vn }));
Cs.displayName = "ArrowArcRightIcon";
const Vt = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: _n }));
Vt.displayName = "CaretDownIcon";
const Pt = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: xn }));
Pt.displayName = "CaretRightIcon";
const ks = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: Ln }));
ks.displayName = "CheckCircleIcon";
const Es = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: Cn }));
Es.displayName = "CircleIcon";
const Ms = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: kn }));
Ms.displayName = "CursorIcon";
const js = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: En }));
js.displayName = "DotsSixVerticalIcon";
const Mt = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: Mn }));
Mt.displayName = "EyeIcon";
const Ba = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: jn }));
Ba.displayName = "InfoIcon";
const Ts = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: Tn }));
Ts.displayName = "LassoIcon";
const Hs = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: Hn }));
Hs.displayName = "LineSegmentIcon";
const Zs = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: Zn }));
Zs.displayName = "MagnetStraightIcon";
const Rs = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: Rn }));
Rs.displayName = "MagnifyingGlassIcon";
const Is = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: In }));
Is.displayName = "MapPinIcon";
const Vs = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: Vn }));
Vs.displayName = "PolygonIcon";
const Ps = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: Pn }));
Ps.displayName = "RectangleIcon";
const Os = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: On }));
Os.displayName = "SelectionAllIcon";
const Ot = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: Fn }));
Ot.displayName = "TrashIcon";
const Fs = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: $n }));
Fs.displayName = "WarningIcon";
const $s = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: Dn }));
$s.displayName = "WarningCircleIcon";
const Ds = t.forwardRef((a, e) => /* @__PURE__ */ t.createElement(me, { ref: e, ...a, weights: Bn }));
Ds.displayName = "XIcon";
function zn(a, e) {
  a.visible = e;
}
function Bs({
  layer: a,
  depth: e = 0,
  search: l = "",
  defaultExpanded: r = !1,
  dragIndex: c,
  dragFrom: o,
  dragOver: b,
  layerCount: i,
  onDragStart: d,
  onDragEnter: m,
  onDrop: g,
  onDragEnd: h,
  onReorder: f
}) {
  const [u, v] = x(r), [A, p] = x(a.visible), S = K(null), U = a.type === "group", [w, V] = x(
    () => U ? [...a.layers] : []
  ), J = [...w].reverse(), M = l.trim() ? J.filter((H) => Pa(H, l)) : J, [X, Z] = x(null), [T, P] = x(null), E = l.trim() && J.some(
    (H) => Pa(H, l)
  );
  O(() => {
    E && v(!0);
  }, [E]), O(() => {
    const H = ps.watch(
      () => a.visible,
      (ge) => p(ge)
    );
    return () => H.remove();
  }, [a]), O(() => {
    if (!U)
      return;
    const H = a, ge = H.layers.on(
      "change",
      () => V([...H.layers])
    );
    return () => ge.remove();
  }, [U, a]);
  const I = ce(
    (H) => {
      zn(a, H.target.checked);
    },
    [a]
  ), F = ce(
    (H, ge) => {
      if (!U || H === ge)
        return;
      const Re = a, Oe = [...Re.layers].reverse(), xe = Oe[H], Le = Oe[ge];
      Re.layers.reorder(xe, Re.layers.indexOf(Le));
    },
    [U, a]
  ), q = ce(
    (H) => {
      X !== null && H !== X && F(X, H), Z(null), P(null);
    },
    [X, F]
  ), ne = ce(() => {
    Z(null), P(null);
  }, []), z = c !== void 0 && d !== void 0, W = z && o === c, ie = z && b === c && o !== null && o !== c, ue = ie && (o ?? 0) > c, Ze = ie && (o ?? 0) < c, je = [
    ve.row,
    W ? ve.dragging : "",
    ue ? ve.dropAbove : "",
    Ze ? ve.dropBelow : ""
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.jsxs(
    "div",
    {
      role: "treeitem",
      "aria-expanded": U ? u : void 0,
      className: ve.item,
      children: [
        /* @__PURE__ */ n.jsxs(
          "div",
          {
            ref: S,
            className: je,
            style: { "--depth": e },
            onDragOver: z ? (H) => {
              H.preventDefault(), H.dataTransfer.dropEffect = "move", m?.(c);
            } : void 0,
            onDrop: z ? (H) => {
              H.preventDefault(), g?.(c);
            } : void 0,
            onDragEnd: z ? () => h?.() : void 0,
            children: [
              z && /* @__PURE__ */ n.jsx(
                "button",
                {
                  type: "button",
                  className: ve.dragHandle,
                  draggable: !0,
                  "aria-label": `Flytt ${a.title || a.id}. Bruk piltast opp eller ned for å endre rekkefølge.`,
                  onDragStart: (H) => {
                    H.dataTransfer.effectAllowed = "move", S.current && H.dataTransfer.setDragImage(S.current, 10, 10), d?.(c);
                  },
                  onKeyDown: (H) => {
                    !f || i === void 0 || (H.key === "ArrowUp" && c > 0 ? (H.preventDefault(), f(c, c - 1)) : H.key === "ArrowDown" && c < i - 1 && (H.preventDefault(), f(c, c + 1)));
                  },
                  children: /* @__PURE__ */ n.jsx(js, { size: 16, weight: "bold" })
                }
              ),
              U ? /* @__PURE__ */ n.jsx(
                "button",
                {
                  type: "button",
                  className: ve.expandBtn,
                  onClick: () => v((H) => !H),
                  "aria-label": u ? "Lukk" : "Utvid",
                  children: u ? /* @__PURE__ */ n.jsx(Vt, { size: 16, weight: "light" }) : /* @__PURE__ */ n.jsx(Pt, { size: 16, weight: "light" })
                }
              ) : /* @__PURE__ */ n.jsx("span", { className: ve.spacer, "aria-hidden": !0 }),
              /* @__PURE__ */ n.jsx(
                Cl,
                {
                  label: a.title || a.id,
                  checked: A,
                  onChange: I
                }
              )
            ]
          }
        ),
        U && u && /* @__PURE__ */ n.jsx("div", { role: "group", className: ve.children, children: M.map((H, ge) => /* @__PURE__ */ n.jsx(
          Bs,
          {
            layer: H,
            depth: e + 1,
            search: l,
            dragIndex: l.trim() ? void 0 : ge,
            dragFrom: l.trim() ? null : X,
            dragOver: l.trim() ? null : T,
            layerCount: M.length,
            onDragStart: l.trim() ? void 0 : Z,
            onDragEnter: l.trim() ? void 0 : P,
            onDrop: l.trim() ? void 0 : q,
            onDragEnd: l.trim() ? void 0 : ne,
            onReorder: l.trim() ? void 0 : F
          },
          H.id
        )) })
      ]
    }
  );
}
function Pa(a, e) {
  const l = e.toLowerCase();
  return (a.title || a.id).toLowerCase().includes(l) ? !0 : a.type === "group" ? a.layers.some(
    (r) => Pa(r, l)
  ) : !1;
}
function v0({ visibleLayerTitle: a } = {}) {
  const { mapView: e } = He(), [l, r] = x([]), [c, o] = x(""), [b, i] = x(null), [d, m] = x(null), g = K(null), h = ce(
    (S) => [...S].reverse().filter((U) => U.listMode !== "hide").filter((U) => !a || U.title === a),
    [a]
  );
  O(() => {
    g.current = e?.map ?? null;
  }, [e]), O(() => {
    if (!e?.map)
      return;
    const S = e.map, U = () => r(h(S.layers));
    U();
    const w = S.layers.on("change", U);
    return () => w.remove();
  }, [e, h]);
  const f = ce((S, U) => {
    const w = g.current;
    if (!w || S === U)
      return;
    const V = h(w.layers), J = V[S], M = V[U];
    w.layers.reorder(J, w.layers.indexOf(M));
  }, [h]), u = ce(
    (S) => {
      b !== null && S !== b && f(b, S), i(null), m(null);
    },
    [b, f]
  ), v = ce(() => {
    i(null), m(null);
  }, []), A = c.trim() === "", p = c.trim() ? l.filter((S) => Pa(S, c)) : l;
  return /* @__PURE__ */ n.jsxs("div", { id: "layer-list-custom", className: ve.container, children: [
    !a && /* @__PURE__ */ n.jsx("div", { className: ve.search, children: /* @__PURE__ */ n.jsx(
      "input",
      {
        type: "search",
        className: ve.searchInput,
        placeholder: "Søk etter kartlag",
        value: c,
        onChange: (S) => o(S.target.value),
        "aria-label": "Søk etter kartlag"
      }
    ) }),
    /* @__PURE__ */ n.jsx(kl, { children: p.map((S, U) => /* @__PURE__ */ n.jsx(
      Bs,
      {
        layer: S,
        search: c,
        defaultExpanded: !!a && S.title === a,
        dragIndex: A ? U : void 0,
        dragFrom: A ? b : null,
        dragOver: A ? d : null,
        layerCount: p.length,
        onDragStart: A ? i : void 0,
        onDragEnter: A ? m : void 0,
        onDrop: A ? u : void 0,
        onDragEnd: A ? v : void 0,
        onReorder: A ? f : void 0
      },
      S.id
    )) })
  ] });
}
const Gn = "https://labs.geodataonline.no/bakgrunnskart/";
function _0() {
  const a = K(null), e = K(), { mapView: l, sceneView: r, mapMode: c } = He(), { t: o, i18n: b } = Pe("map"), i = () => {
    const d = xl.basemaps.map((m) => {
      const g = m.clone();
      if (g.title = o(m.title), m.thumbnailUrl && !m.thumbnailUrl.startsWith("http") && !m.thumbnailUrl.startsWith("data:")) {
        const h = new URL(m.thumbnailUrl, Gn);
        g.thumbnailUrl = h.href;
      }
      return g;
    });
    return new Pl({
      basemaps: d
    });
  };
  return O(() => {
    a.current && l && !e.current && (e.current = new Vl({
      view: l,
      source: i(),
      container: a.current
    }));
  }, [l]), O(() => {
    const d = () => {
      e.current && (e.current.source = i());
    };
    return b.on("languageChanged", d), () => {
      b.off("languageChanged", d);
    };
  }, [b]), O(() => {
    e.current && (c == Ye.TwoD && l ? e.current.view = l : c == Ye.ThreeD && r && (e.current.view = r));
  }, [c, l, r]), /* @__PURE__ */ n.jsx("div", { id: "esri-basemap-gallery", className: "widget-container", ref: a });
}
function x0() {
  const a = K(null), e = K(), { mapView: l } = He();
  return O(() => (a?.current && l && (e.current = new Ol({
    view: l,
    container: a.current,
    // specify your own print service
    printServiceUrl: "https://services.geodataonline.no/arcgis/rest/services/Georapport/Kartutskrift/GPServer/Standard"
  })), () => {
  }), []), /* @__PURE__ */ n.jsx("div", { id: "print-details", className: "widget-container", ref: a });
}
function L0() {
  const a = K(null), e = K(), { mapView: l, sceneView: r, mapMode: c } = He();
  return O(() => (a?.current && l && (e.current = new Fl({
    view: l,
    container: a.current
  })), () => {
  }), []), O(() => {
    e.current && (c == Ye.TwoD && l ? e.current.view = l : c == Ye.ThreeD && r && (e.current.view = r));
  }, [c, l, r]), /* @__PURE__ */ n.jsx("div", { className: "widget-container", ref: a });
}
const C0 = ({ children: a }) => {
  const [e, l] = x([]), r = (o, b, i) => {
    const d = i || `flow-item-${Date.now()}`;
    l((m) => [...m, { content: o, heading: b, id: d }]);
  }, c = (o) => new Promise((b) => {
    l((i) => i.slice(0, o)), setTimeout(() => b(), 50);
  });
  return /* @__PURE__ */ n.jsxs(cl, { children: [
    /* @__PURE__ */ n.jsx($t, { heading: "", children: a(r) }),
    e.map((o, b) => /* @__PURE__ */ n.jsx(
      $t,
      {
        heading: o.heading,
        beforeBack: () => c(b),
        children: o.content
      },
      o.id
    ))
  ] });
}, Wn = "NumberInput-module__controlGroup___9vmMM", Kn = "NumberInput-module__slider___KzgW5", qn = "NumberInput-module__numberInput___0mrur", yt = {
  controlGroup: Wn,
  slider: Kn,
  numberInput: qn
}, Be = ({ value: a, onChange: e, min: l, max: r, step: c = 1, suffix: o }) => /* @__PURE__ */ n.jsxs("div", { className: yt.controlGroup, children: [
  /* @__PURE__ */ n.jsx(
    ha,
    {
      min: l ?? 0,
      max: r ?? 100,
      value: a,
      step: c,
      className: yt.slider,
      onCalciteSliderChange: (b) => {
        e(b.target.value);
      }
    }
  ),
  /* @__PURE__ */ n.jsx(
    Ha,
    {
      value: a.toString(),
      scale: "s",
      numberButtonType: "vertical",
      className: yt.numberInput,
      suffixText: o,
      min: l,
      max: r,
      step: c,
      onCalciteInputNumberChange: (b) => {
        const i = Number(b.target.value);
        if (!isNaN(i)) {
          const d = Math.min(r ?? 1 / 0, Math.max(l ?? -1 / 0, i));
          e(d);
        }
      }
    }
  )
] }), Yn = "ColorControl-module__colorControl___rEpEZ", Jn = "ColorControl-module__colorSwatchContainer___s8Q-J", Xn = "ColorControl-module__colorSwatch___98gCl", Qn = "ColorControl-module__colorPickerPopover___-tUEA", Ca = {
  colorControl: Yn,
  colorSwatchContainer: Jn,
  colorSwatch: Xn,
  colorPickerPopover: Qn
}, Na = ({ color: a, opacity: e = 100, onChange: l, buttonId: r }) => {
  const { t: c } = Pe(["drawing", "common"]);
  return /* @__PURE__ */ n.jsxs("div", { className: Ca.colorControl, children: [
    /* @__PURE__ */ n.jsxs("div", { className: Ca.colorSwatchContainer, children: [
      /* @__PURE__ */ n.jsx(
        "div",
        {
          className: Ca.colorSwatch,
          style: { "--swatch-color": a, "--swatch-opacity": e / 100 }
        }
      ),
      /* @__PURE__ */ n.jsx(
        ol,
        {
          id: r,
          appearance: "transparent",
          iconStart: "pencil",
          title: c("drawing:colorControl.clickToSelectColor"),
          "aria-label": c("drawing:colorControl.openColorPicker"),
          scale: "s"
        }
      )
    ] }),
    /* @__PURE__ */ n.jsx(
      ml,
      {
        placement: "bottom-start",
        referenceElement: r,
        overlayPositioning: "fixed",
        autoClose: !0,
        className: Ca.colorPickerPopover,
        children: /* @__PURE__ */ n.jsx(
          ys,
          {
            value: a,
            onCalciteColorPickerChange: (o) => l(o.target.value)
          }
        )
      }
    )
  ] });
}, er = ({ sketchVM: a }) => {
  const e = () => {
    const f = a.polylineSymbol;
    if (f) {
      const u = (A) => A ? Array.isArray(A) ? `#${A[0].toString(16).padStart(2, "0")}${A[1].toString(16).padStart(2, "0")}${A[2].toString(16).padStart(2, "0")}` : `#${A.r.toString(16).padStart(2, "0")}${A.g.toString(16).padStart(2, "0")}${A.b.toString(16).padStart(2, "0")}` : "#00ff00", v = (A) => {
        if (!A)
          return 25;
        let p;
        return Array.isArray(A) ? p = A[3] / 255 : p = A.a ?? 1, 100 - p * 100;
      };
      return {
        color: u(f.color),
        opacity: v(f.color),
        width: f.width || 1,
        style: f.style || "solid"
      };
    }
    return { color: "#00ff00", opacity: 100, width: 2, style: "solid" };
  };
  O(() => {
    const f = e();
    c(f.color), b(f.opacity), d(f.width), g(f.style);
  }, [a.polylineSymbol]);
  const l = e(), [r, c] = x(l.color), [o, b] = x(l.opacity), [i, d] = x(l.width), [m, g] = x(l.style), h = (f = m, u = o, v = i, A = r) => {
    console.log("PolylineSymbolSettings.updateSymbol called");
    const S = {
      type: "simple-line",
      color: (() => {
        const U = parseInt(A.slice(1, 3), 16), w = parseInt(A.slice(3, 5), 16), V = parseInt(A.slice(5, 7), 16);
        return [U, w, V, (100 - u) / 100];
      })(),
      width: v,
      style: f
    };
    console.log("Setting polylineSymbol:", S), a.polylineSymbol = S, console.log("After setting polylineSymbol:", a.polylineSymbol);
  };
  return /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Stil",
      /* @__PURE__ */ n.jsxs(
        Fa,
        {
          scale: "s",
          value: m,
          onCalciteSelectChange: (f) => {
            const u = f.target.value;
            g(u), h(u, o, i, r);
          },
          children: [
            /* @__PURE__ */ n.jsx(be, { value: "solid", children: "Heltrukket" }),
            /* @__PURE__ */ n.jsx(be, { value: "dash", children: "Stiplet" }),
            /* @__PURE__ */ n.jsx(be, { value: "dot", children: "Prikket" }),
            /* @__PURE__ */ n.jsx(be, { value: "dash-dot", children: "Strek-prikk" }),
            /* @__PURE__ */ n.jsx(be, { value: "dash-dot-dot", children: "Strek-prikk-prikk" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Farge",
      /* @__PURE__ */ n.jsx(
        Na,
        {
          color: r,
          opacity: 100 - o,
          onChange: (f) => {
            c(f), h(m, o, i, f);
          },
          buttonId: "lineColorBtn"
        }
      )
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Gjennomsiktighet",
      /* @__PURE__ */ n.jsx(
        Be,
        {
          value: o,
          onChange: (f) => {
            b(f), h(m, f, i, r);
          },
          min: 0,
          max: 100,
          step: 1,
          suffix: "%"
        }
      )
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Bredde",
      /* @__PURE__ */ n.jsx(
        Be,
        {
          value: i,
          onChange: (f) => {
            d(f), h(m, o, f, r);
          },
          min: 0,
          max: 10,
          step: 0.5,
          suffix: "piksler"
        }
      )
    ] })
  ] });
}, ar = ({ sketchVM: a }) => {
  const l = (() => {
    const p = a.polygonSymbol;
    if (p) {
      const S = (w) => w ? Array.isArray(w) ? `#${w[0].toString(16).padStart(2, "0")}${w[1].toString(16).padStart(2, "0")}${w[2].toString(16).padStart(2, "0")}` : `#${w.r.toString(16).padStart(2, "0")}${w.g.toString(16).padStart(2, "0")}${w.b.toString(16).padStart(2, "0")}` : "#000000", U = (w) => {
        if (!w)
          return 25;
        let V;
        return Array.isArray(w) ? V = w[3] / 255 : V = w.a ?? 1, 100 - V * 100;
      };
      return {
        fillColor: S(p.color),
        fillOpacity: U(p.color),
        outlineColor: p.outline ? S(p.outline.color) : "#000000",
        outlineOpacity: p.outline ? U(p.outline.color) : 0,
        // 0% transparency = fully opaque
        outlineWidth: p.outline && p.outline.width ? p.outline.width : 1,
        fillStyle: p.style || "solid"
      };
    }
    return {
      fillColor: "#000000",
      fillOpacity: 100,
      outlineColor: "#000000",
      outlineOpacity: 100,
      outlineWidth: 1,
      fillStyle: "solid"
    };
  })(), [r, c] = x(l.fillColor), [o, b] = x(l.fillOpacity), [i, d] = x(l.outlineColor), [m, g] = x(l.outlineOpacity), [h, f] = x(l.outlineWidth), [u, v] = x(l.fillStyle), A = (p = u, S = o, U = m, w = r, V = i, J = h) => {
    console.log("PolygonSymbolSettings.updateSymbol called");
    const M = () => {
      const T = parseInt(w.slice(1, 3), 16), P = parseInt(w.slice(3, 5), 16), E = parseInt(w.slice(5, 7), 16);
      return [T, P, E, (100 - S) / 100];
    }, X = () => {
      const T = parseInt(V.slice(1, 3), 16), P = parseInt(V.slice(3, 5), 16), E = parseInt(V.slice(5, 7), 16);
      return [T, P, E, (100 - U) / 100];
    }, Z = {
      type: "simple-fill",
      color: M(),
      style: p,
      outline: {
        color: X(),
        width: J
      }
    };
    console.log("Setting polygonSymbol:", Z), a.polygonSymbol = Z, console.log("After setting polygonSymbol:", a.polygonSymbol);
  };
  return /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Fyllfarge",
      /* @__PURE__ */ n.jsx(
        Na,
        {
          color: r,
          opacity: 100 - o,
          onChange: (p) => {
            c(p), A(u, o, m, p, i, h);
          },
          buttonId: "fillColorBtn"
        }
      )
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Fyllgjennomsiktighet",
      /* @__PURE__ */ n.jsx(
        Be,
        {
          value: o,
          onChange: (p) => {
            b(p), A(u, p, m, r, i, h);
          },
          min: 0,
          max: 100,
          step: 1,
          suffix: "%"
        }
      )
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Omrissfarge",
      /* @__PURE__ */ n.jsx(
        Na,
        {
          color: i,
          opacity: 100 - m,
          onChange: (p) => {
            d(p), A(u, o, m, r, p, h);
          },
          buttonId: "outlineColorBtn"
        }
      )
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Omrissgjennomsiktighet",
      /* @__PURE__ */ n.jsx(
        Be,
        {
          value: m,
          onChange: (p) => {
            g(p), A(u, o, p, r, i, h);
          },
          min: 0,
          max: 100,
          step: 1,
          suffix: "%"
        }
      )
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Omrissbredde",
      /* @__PURE__ */ n.jsx(
        Be,
        {
          value: h,
          onChange: (p) => {
            f(p), A(u, o, m, r, i, p);
          },
          min: 0,
          max: 10,
          step: 0.5,
          suffix: "piksler"
        }
      )
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Mønster",
      /* @__PURE__ */ n.jsxs(
        Fa,
        {
          scale: "s",
          value: u,
          onCalciteSelectChange: (p) => {
            const S = p.target.value;
            v(S), A(S, o, m, r, i, h);
          },
          children: [
            /* @__PURE__ */ n.jsx(be, { value: "solid", children: "Heldekkende" }),
            /* @__PURE__ */ n.jsx(be, { value: "horizontal", children: "Horisontale linjer" }),
            /* @__PURE__ */ n.jsx(be, { value: "vertical", children: "Vertikale linjer" }),
            /* @__PURE__ */ n.jsx(be, { value: "diagonal", children: "Skrå linjer" }),
            /* @__PURE__ */ n.jsx(be, { value: "cross", children: "Kryss" }),
            /* @__PURE__ */ n.jsx(be, { value: "diagonal-cross", children: "Kryss skrå" }),
            /* @__PURE__ */ n.jsx(be, { value: "none", children: "Ingen fyll" })
          ]
        }
      )
    ] })
  ] });
}, gt = [
  {
    name: "Sirkel",
    cimJSON: {
      type: "CIMPointSymbol",
      symbolLayers: [
        {
          type: "CIMVectorMarker",
          enable: !0,
          anchorPoint: {
            x: 0,
            y: 0,
            z: 0
          },
          anchorPointUnits: "Relative",
          dominantSizeAxis3D: "Y",
          size: 10,
          billboardMode3D: "FaceNearPlane",
          frame: {
            xmin: -5,
            ymin: -5,
            xmax: 5,
            ymax: 5
          },
          markerGraphics: [
            {
              type: "CIMMarkerGraphic",
              geometry: {
                rings: [
                  [
                    [
                      0,
                      5
                    ],
                    [
                      0.87,
                      4.92
                    ],
                    [
                      1.71,
                      4.7
                    ],
                    [
                      2.5,
                      4.33
                    ],
                    [
                      3.21,
                      3.83
                    ],
                    [
                      3.83,
                      3.21
                    ],
                    [
                      4.33,
                      2.5
                    ],
                    [
                      4.7,
                      1.71
                    ],
                    [
                      4.92,
                      0.87
                    ],
                    [
                      5,
                      0
                    ],
                    [
                      4.92,
                      -0.87
                    ],
                    [
                      4.7,
                      -1.71
                    ],
                    [
                      4.33,
                      -2.5
                    ],
                    [
                      3.83,
                      -3.21
                    ],
                    [
                      3.21,
                      -3.83
                    ],
                    [
                      2.5,
                      -4.33
                    ],
                    [
                      1.71,
                      -4.7
                    ],
                    [
                      0.87,
                      -4.92
                    ],
                    [
                      0,
                      -5
                    ],
                    [
                      -0.87,
                      -4.92
                    ],
                    [
                      -1.71,
                      -4.7
                    ],
                    [
                      -2.5,
                      -4.33
                    ],
                    [
                      -3.21,
                      -3.83
                    ],
                    [
                      -3.83,
                      -3.21
                    ],
                    [
                      -4.33,
                      -2.5
                    ],
                    [
                      -4.7,
                      -1.71
                    ],
                    [
                      -4.92,
                      -0.87
                    ],
                    [
                      -5,
                      -0
                    ],
                    [
                      -4.92,
                      0.87
                    ],
                    [
                      -4.7,
                      1.71
                    ],
                    [
                      -4.33,
                      2.5
                    ],
                    [
                      -3.83,
                      3.21
                    ],
                    [
                      -3.21,
                      3.83
                    ],
                    [
                      -2.5,
                      4.33
                    ],
                    [
                      -1.71,
                      4.7
                    ],
                    [
                      -0.87,
                      4.92
                    ],
                    [
                      0,
                      5
                    ]
                  ]
                ]
              },
              symbol: {
                type: "CIMPolygonSymbol",
                symbolLayers: [
                  {
                    type: "CIMSolidStroke",
                    enable: !0,
                    capStyle: "Round",
                    joinStyle: "Round",
                    lineStyle3D: "Strip",
                    miterLimit: 10,
                    width: 0.2,
                    color: [
                      0,
                      0,
                      128,
                      217
                    ]
                  },
                  {
                    type: "CIMSolidFill",
                    enable: !0,
                    color: [
                      121,
                      121,
                      186,
                      217
                    ]
                  }
                ],
                angleAlignment: "Map"
              }
            }
          ],
          respectFrame: !0
        }
      ],
      haloSize: 1,
      scaleX: 1,
      angleAlignment: "Display"
    }
  },
  {
    name: "Kvadrat",
    cimJSON: {
      type: "CIMPointSymbol",
      symbolLayers: [
        {
          type: "CIMVectorMarker",
          enable: !0,
          size: 12,
          colorLocked: !1,
          frame: { xmin: -5, ymin: -5, xmax: 5, ymax: 5 },
          markerGraphics: [
            {
              type: "CIMMarkerGraphic",
              geometry: { rings: [[[-5, -5], [5, -5], [5, 5], [-5, 5], [-5, -5]]] },
              symbol: {
                type: "CIMPolygonSymbol",
                symbolLayers: [
                  {
                    type: "CIMSolidFill",
                    enable: !0,
                    color: [255, 0, 0, 255]
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  },
  {
    name: "Trekant",
    cimJSON: {
      type: "CIMPointSymbol",
      symbolLayers: [
        {
          type: "CIMVectorMarker",
          enable: !0,
          size: 12,
          colorLocked: !1,
          frame: { xmin: -5, ymin: -5, xmax: 5, ymax: 5 },
          markerGraphics: [
            {
              type: "CIMMarkerGraphic",
              geometry: { rings: [[[0, -5], [5, 5], [-5, 5], [0, -5]]] },
              symbol: {
                type: "CIMPolygonSymbol",
                symbolLayers: [
                  {
                    type: "CIMSolidFill",
                    enable: !0,
                    color: [255, 0, 0, 255]
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  },
  {
    name: "Diamant",
    cimJSON: {
      type: "CIMPointSymbol",
      symbolLayers: [
        {
          type: "CIMVectorMarker",
          enable: !0,
          size: 12,
          colorLocked: !1,
          frame: { xmin: -5, ymin: -5, xmax: 5, ymax: 5 },
          markerGraphics: [
            {
              type: "CIMMarkerGraphic",
              geometry: { rings: [[[0, -5], [5, 0], [0, 5], [-5, 0], [0, -5]]] },
              symbol: {
                type: "CIMPolygonSymbol",
                symbolLayers: [
                  {
                    type: "CIMSolidFill",
                    enable: !0,
                    color: [255, 0, 0, 255]
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  },
  {
    name: "Kryss",
    cimJSON: {
      type: "CIMPointSymbol",
      symbolLayers: [
        {
          type: "CIMVectorMarker",
          enable: !0,
          size: 12,
          colorLocked: !1,
          frame: { xmin: -5, ymin: -5, xmax: 5, ymax: 5 },
          markerGraphics: [
            {
              type: "CIMMarkerGraphic",
              geometry: {
                paths: [
                  [[-5, -5], [5, 5]],
                  [[5, -5], [-5, 5]]
                ]
              },
              symbol: {
                type: "CIMLineSymbol",
                symbolLayers: [
                  {
                    type: "CIMSolidStroke",
                    enable: !0,
                    width: 2,
                    color: [255, 0, 0, 255]
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  },
  {
    name: "Pil",
    cimJSON: {
      type: "CIMPointSymbol",
      symbolLayers: [
        {
          type: "CIMVectorMarker",
          enable: !0,
          size: 12,
          colorLocked: !1,
          frame: { xmin: -5, ymin: -5, xmax: 5, ymax: 5 },
          markerGraphics: [
            {
              type: "CIMMarkerGraphic",
              geometry: { rings: [[[0, -5], [5, 5], [0, 2], [-5, 5], [0, -5]]] },
              symbol: {
                type: "CIMPolygonSymbol",
                symbolLayers: [
                  {
                    type: "CIMSolidFill",
                    enable: !0,
                    color: [255, 0, 0, 255]
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  }
], tr = ({ symbol: a }) => {
  const e = K(null);
  return O(() => {
    if (!e.current || !a)
      return;
    (async () => {
      try {
        e.current.innerHTML = "";
        const r = await Rt(a, { size: 40 });
        r && e.current && e.current.appendChild(r);
      } catch (r) {
        console.error("Feil ved lasting av symbolforhåndsvisning:", r);
      }
    })();
  }, [a]), /* @__PURE__ */ n.jsx("div", { ref: e });
}, sr = ({
  symbolDef: a,
  isSelected: e,
  onClick: l,
  color: r,
  size: c
}) => {
  const [o, b] = x(null);
  return O(() => {
    const i = async () => {
      try {
        const m = JSON.parse(JSON.stringify(a.cimJSON));
        m.symbolLayers && m.symbolLayers.length > 0 && (m.symbolLayers[0].size = c);
        const g = jt(r);
        if (m.symbolLayers && m.symbolLayers.length > 0 && m.symbolLayers[0].markerGraphics && m.symbolLayers[0].markerGraphics.length > 0) {
          const u = m.symbolLayers[0].markerGraphics[0];
          u.symbol.type === "CIMPolygonSymbol" ? u.symbol.symbolLayers && u.symbol.symbolLayers.length > 0 && (u.symbol.symbolLayers[0].color = g) : u.symbol.type === "CIMLineSymbol" && u.symbol.symbolLayers && u.symbol.symbolLayers.length > 0 && (u.symbol.symbolLayers[0].color = g);
        }
        const h = new It({
          data: {
            type: "CIMSymbolReference",
            symbol: m
          }
        }), f = await Rt(h, { size: 30 });
        f && b(f);
      } catch (m) {
        console.error("Feil ved lasting av symbolforhåndsvisning:", m), d();
      }
    }, d = () => {
      const m = document.createElement("div");
      m.textContent = a.name.substring(0, 2), m.style.width = "30px", m.style.height = "30px", m.style.display = "flex", m.style.justifyContent = "center", m.style.alignItems = "center", m.style.backgroundColor = "#f0f0f0", m.style.borderRadius = "4px", m.style.fontSize = "12px", b(m);
    };
    i();
  }, [a, r, c]), /* @__PURE__ */ n.jsx(
    "button",
    {
      onClick: l,
      title: a.name,
      style: {
        border: e ? "2px solid #007ac2" : "1px solid #ccc",
        padding: 4,
        borderRadius: 4,
        background: "white",
        cursor: "pointer",
        minWidth: "40px",
        minHeight: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      },
      children: o ? /* @__PURE__ */ n.jsx("div", { ref: (i) => i && !i.hasChildNodes() && i.appendChild(o) }) : /* @__PURE__ */ n.jsx("div", { style: { fontSize: "0.8rem" }, children: a.name })
    }
  );
}, jt = (a, e = 0) => {
  const l = parseInt(a.slice(1, 3), 16), r = parseInt(a.slice(3, 5), 16), c = parseInt(a.slice(5, 7), 16);
  return [l, r, c, Math.round((100 - e) / 100 * 255)];
}, lr = ({ sketchVM: a }) => {
  const { t: e } = Pe(["drawing", "common"]), r = (() => {
    const w = a.pointSymbol;
    if (w && w.type === "cim")
      try {
        const V = (M) => M ? Array.isArray(M) ? `#${M[0].toString(16).padStart(2, "0")}${M[1].toString(16).padStart(2, "0")}${M[2].toString(16).padStart(2, "0")}` : `#${M.r.toString(16).padStart(2, "0")}${M.g.toString(16).padStart(2, "0")}${M.b.toString(16).padStart(2, "0")}` : "#ff0000", J = w;
        if (J.data && J.data.symbol) {
          const M = J.data.symbol;
          let X = 0, Z = -1;
          gt.forEach((q, ne) => {
            let z = 0;
            if (M.type === q.cimJSON.type && (z += 5), M.symbolLayers && M.symbolLayers[0] && M.symbolLayers[0].markerGraphics && M.symbolLayers[0].markerGraphics[0] && M.symbolLayers[0].markerGraphics[0].geometry) {
              const W = M.symbolLayers[0].markerGraphics[0].geometry, ie = q.cimJSON.symbolLayers[0].markerGraphics[0].geometry;
              JSON.stringify(W) === JSON.stringify(ie) && (z += 10);
            }
            z > Z && (Z = z, X = ne);
          });
          let T = "#ff0000", P = 12, E = 0, I = "#000000", F = 0;
          if (M.symbolLayers && M.symbolLayers.length > 0 && (P = M.symbolLayers[0].size || 12, F = M.symbolLayers[0].rotation || 0, M.symbolLayers[0].markerGraphics && M.symbolLayers[0].markerGraphics[0] && M.symbolLayers[0].markerGraphics[0].symbol && M.symbolLayers[0].markerGraphics[0].symbol.symbolLayers)) {
            const q = M.symbolLayers[0].markerGraphics[0].symbol.symbolLayers, ne = q.find((W) => W.type === "CIMSolidFill");
            ne && ne.color && (T = V(ne.color));
            const z = q.find((W) => W.type === "CIMSolidStroke");
            z && (E = z.width || 0, z.color && (I = V(z.color)));
          }
          return {
            selectedTemplate: X,
            color: T,
            size: P,
            outlineWidth: E,
            outlineColor: I,
            rotation: F
          };
        }
      } catch (V) {
        console.error("Feil ved initialisering fra symbol:", V);
      }
    return {
      selectedTemplate: 0,
      color: "#ff0000",
      size: 12,
      outlineWidth: 0,
      outlineColor: "#000000",
      rotation: 0
    };
  })(), [c, o] = x(r.selectedTemplate), [b, i] = x(r.color), [d, m] = x(r.size), [g, h] = x(r.outlineWidth), [f, u] = x(r.outlineColor), [v, A] = x(r.rotation), [p, S] = x(null), U = () => {
    try {
      const w = JSON.parse(JSON.stringify(gt[c].cimJSON));
      w.symbolLayers && w.symbolLayers.length > 0 && (w.symbolLayers[0].size = d), w.symbolLayers && w.symbolLayers.length > 0 && (w.symbolLayers[0].rotation = v);
      const V = jt(b);
      if (w.symbolLayers && w.symbolLayers.length > 0 && w.symbolLayers[0].markerGraphics && w.symbolLayers[0].markerGraphics.length > 0) {
        const M = w.symbolLayers[0].markerGraphics[0];
        if (M.symbol.type === "CIMPolygonSymbol")
          if (M.symbol.symbolLayers && M.symbol.symbolLayers.length > 0 && (M.symbol.symbolLayers[0].color = V), g > 0) {
            const X = jt(f);
            if (M.symbol.symbolLayers.some((T) => T.type === "CIMSolidStroke")) {
              const T = M.symbol.symbolLayers.find((P) => P.type === "CIMSolidStroke");
              T && (T.width = g, T.color = X);
            } else
              M.symbol.symbolLayers.push({
                type: "CIMSolidStroke",
                enable: !0,
                width: g,
                color: X
              });
          } else
            M.symbol.symbolLayers = M.symbol.symbolLayers.filter(
              (X) => X.type !== "CIMSolidStroke"
            );
        else
          M.symbol.type === "CIMLineSymbol" && M.symbol.symbolLayers && M.symbol.symbolLayers.length > 0 && (M.symbol.symbolLayers[0].color = V, M.symbol.symbolLayers[0].width = Math.max(1, g > 0 ? g : 2));
      }
      const J = new It({
        data: {
          type: "CIMSymbolReference",
          symbol: w
        }
      });
      a.pointSymbol = J, S(J);
    } catch (w) {
      console.error("Feil ved oppdatering av CIM symbol:", w);
    }
  };
  return O(() => {
    U();
  }, [c, b, d, g, f, v]), /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    /* @__PURE__ */ n.jsxs("div", { style: { marginBottom: "1rem" }, children: [
      /* @__PURE__ */ n.jsx(le, { children: e("drawing:symbolSettings.shape") }),
      /* @__PURE__ */ n.jsx("div", { style: {
        display: "flex",
        flexWrap: "wrap",
        gap: "0.5rem",
        marginBottom: "1rem",
        maxHeight: "200px",
        overflowY: "auto"
      }, children: gt.map((w, V) => /* @__PURE__ */ n.jsx(
        sr,
        {
          symbolDef: w,
          isSelected: c === V,
          onClick: () => o(V),
          color: b,
          size: d
        },
        V
      )) })
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      e("drawing:symbolSettings.color"),
      /* @__PURE__ */ n.jsx(
        Na,
        {
          color: b,
          onChange: (w) => {
            i(w);
          },
          buttonId: "cimColorBtn"
        }
      )
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      e("drawing:symbolSettings.size"),
      /* @__PURE__ */ n.jsx(
        Be,
        {
          value: d,
          onChange: (w) => {
            m(w), U();
          },
          min: 0,
          max: 48,
          suffix: e("drawing:symbolSettings.pixels")
        }
      )
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      e("drawing:symbolSettings.rotation"),
      /* @__PURE__ */ n.jsx(
        Be,
        {
          min: 0,
          max: 360,
          step: 5,
          value: v,
          suffix: "°",
          onChange: (w) => A(w)
        }
      )
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      e("drawing:symbolSettings.outlineWidth"),
      /* @__PURE__ */ n.jsx(
        Be,
        {
          value: g,
          onChange: (w) => h(w),
          min: 0,
          max: 10,
          step: 0.5,
          suffix: e("drawing:symbolSettings.pixels")
        }
      )
    ] }),
    g > 0 && /* @__PURE__ */ n.jsxs(le, { children: [
      e("drawing:symbolSettings.outlineColor"),
      /* @__PURE__ */ n.jsx(
        Na,
        {
          color: f,
          onChange: (w) => {
            u(w);
          },
          buttonId: "cimOutlineColorBtn"
        }
      )
    ] }),
    /* @__PURE__ */ n.jsxs("div", { style: { marginTop: "1rem" }, children: [
      /* @__PURE__ */ n.jsx(le, { children: e("drawing:symbolSettings.preview") }),
      /* @__PURE__ */ n.jsx(
        "div",
        {
          style: {
            width: "100%",
            height: "60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "1px solid #ccc",
            borderRadius: "4px",
            backgroundColor: "#f8f8f8"
          },
          children: /* @__PURE__ */ n.jsx(tr, { symbol: p })
        }
      )
    ] })
  ] });
}, nr = "TextSymbolSettings-module__controlGroup___Yk6df", rr = "TextSymbolSettings-module__textSizeControl___21mYq", cr = "TextSymbolSettings-module__slider___KthKX", or = "TextSymbolSettings-module__numberInput___DyJCZ", mr = "TextSymbolSettings-module__colorControl___RGsRV", ir = "TextSymbolSettings-module__colorInputGroup___RG6TL", br = "TextSymbolSettings-module__colorSwatch___1N1OE", dr = "TextSymbolSettings-module__colorValue___U7-YB", pe = {
  controlGroup: nr,
  textSizeControl: rr,
  slider: cr,
  numberInput: or,
  colorControl: mr,
  colorInputGroup: ir,
  colorSwatch: br,
  colorValue: dr
}, yr = {
  small: 12,
  medium: 18,
  large: 24
}, gr = ({ sketchVM: a }) => {
  const l = (() => {
    const p = a.textSymbol;
    if (p) {
      const S = (w) => w ? Array.isArray(w) ? `#${w[0].toString(16).padStart(2, "0")}${w[1].toString(16).padStart(2, "0")}${w[2].toString(16).padStart(2, "0")}` : `#${w.r.toString(16).padStart(2, "0")}${w.g.toString(16).padStart(2, "0")}${w.b.toString(16).padStart(2, "0")}` : "#000000", U = (w) => w ? Array.isArray(w) ? w[3] / 255 * 100 : (w.a ?? 1) * 100 : 100;
      return {
        fontFamily: p.font ? p.font.family : "Arial",
        fontSize: p.font ? p.font.size : 12,
        color: S(p.color),
        opacity: U(p.color),
        rotation: p.angle || 0
      };
    }
    return {
      fontFamily: "Arial",
      fontSize: 12,
      color: "#000000",
      opacity: 100,
      rotation: 0
    };
  })(), [r, c] = x(l.fontFamily), [o, b] = x(l.fontSize), [i, d] = x(() => l.fontSize <= 12 ? "small" : l.fontSize >= 24 ? "large" : "medium"), [m, g] = x(l.color), [h, f] = x(l.opacity), [u, v] = x(l.rotation);
  O(() => {
    const p = yr[i];
    b(p), A(p);
  }, [i]);
  const A = (p) => {
    const S = {
      type: "text",
      text: "",
      // This will be set by the SketchViewModel
      font: {
        family: r,
        size: p || o,
        style: "normal",
        weight: "normal"
      },
      // Convert transparency to opacity (opacity = 100 - transparency)
      color: [
        parseInt(m.slice(1, 3), 16),
        parseInt(m.slice(3, 5), 16),
        parseInt(m.slice(5, 7), 16),
        (100 - h) / 100
      ],
      haloSize: 1,
      haloColor: [255, 255, 255, 0.5],
      angle: u
    };
    a.textSymbol = S;
  };
  return /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Font",
      /* @__PURE__ */ n.jsxs(
        Fa,
        {
          scale: "s",
          value: r,
          onCalciteSelectChange: (p) => {
            c(p.target.value), A();
          },
          children: [
            /* @__PURE__ */ n.jsx(be, { value: "Arial", children: "Arial" }),
            /* @__PURE__ */ n.jsx(be, { value: "Arial Black", children: "Arial Black" }),
            /* @__PURE__ */ n.jsx(be, { value: "Helvetica", children: "Helvetica" }),
            /* @__PURE__ */ n.jsx(be, { value: "Times New Roman", children: "Times New Roman" }),
            /* @__PURE__ */ n.jsx(be, { value: "Courier New", children: "Courier New" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Størrelse",
      /* @__PURE__ */ n.jsx("div", { className: pe.textSizeControl, children: /* @__PURE__ */ n.jsxs(
        gs,
        {
          width: "full",
          scale: "s",
          value: i,
          onCalciteSegmentedControlChange: (p) => {
            d(p.target.value);
          },
          children: [
            /* @__PURE__ */ n.jsx(Xe, { value: "small", checked: i === "small", children: "Liten" }),
            /* @__PURE__ */ n.jsx(Xe, { value: "medium", checked: i === "medium", children: "Medium" }),
            /* @__PURE__ */ n.jsx(Xe, { value: "large", checked: i === "large", children: "Stor" })
          ]
        }
      ) })
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Egendefinert størrelse",
      /* @__PURE__ */ n.jsxs("div", { className: pe.controlGroup, children: [
        /* @__PURE__ */ n.jsx(
          ha,
          {
            min: 8,
            max: 48,
            value: o,
            step: 1,
            className: pe.slider,
            onCalciteSliderChange: (p) => {
              const S = Number(p.target.value);
              b(S), S <= 12 ? d("small") : S >= 24 ? d("large") : d("medium"), A(S);
            }
          }
        ),
        /* @__PURE__ */ n.jsx(
          Ha,
          {
            value: o.toString(),
            scale: "s",
            numberButtonType: "horizontal",
            className: pe.numberInput,
            suffixText: "pt",
            min: 8,
            max: 48,
            step: 1,
            onCalciteInputNumberChange: (p) => {
              const S = Math.min(48, Math.max(8, Number(p.target.value)));
              b(S), S <= 12 ? d("small") : S >= 24 ? d("large") : d("medium"), A(S);
            }
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Farge",
      /* @__PURE__ */ n.jsx("div", { className: pe.colorControl, children: /* @__PURE__ */ n.jsxs("div", { className: pe.colorInputGroup, children: [
        /* @__PURE__ */ n.jsx(
          "div",
          {
            className: pe.colorSwatch,
            style: { "--swatch-color": m, "--swatch-opacity": h / 100 }
          }
        ),
        /* @__PURE__ */ n.jsx("span", { className: pe.colorValue, children: m }),
        /* @__PURE__ */ n.jsx(
          ys,
          {
            value: m,
            onCalciteColorPickerChange: (p) => {
              g(p.target.value), A();
            }
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Gjennomsiktighet",
      /* @__PURE__ */ n.jsxs("div", { className: pe.controlGroup, children: [
        /* @__PURE__ */ n.jsx(
          ha,
          {
            min: 0,
            max: 100,
            value: h,
            step: 1,
            className: pe.slider,
            onCalciteSliderChange: (p) => {
              f(Number(p.target.value)), A();
            }
          }
        ),
        /* @__PURE__ */ n.jsx(
          Ha,
          {
            value: h.toString(),
            scale: "s",
            numberButtonType: "horizontal",
            className: pe.numberInput,
            suffixText: "%",
            min: 0,
            max: 100,
            step: 1,
            onCalciteInputNumberChange: (p) => {
              const S = Math.min(100, Math.max(0, Number(p.target.value)));
              f(S), A();
            }
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Rotasjon",
      /* @__PURE__ */ n.jsxs("div", { className: pe.controlGroup, children: [
        /* @__PURE__ */ n.jsx(
          ha,
          {
            min: 0,
            max: 360,
            value: u,
            step: 5,
            className: pe.slider,
            onCalciteSliderChange: (p) => {
              v(Number(p.target.value)), A();
            }
          }
        ),
        /* @__PURE__ */ n.jsx(
          Ha,
          {
            value: u.toString(),
            scale: "s",
            numberButtonType: "horizontal",
            className: pe.numberInput,
            suffixText: "°",
            min: 0,
            max: 360,
            step: 5,
            onCalciteInputNumberChange: (p) => {
              const S = Number(p.target.value) % 360;
              v(S), A();
            }
          }
        )
      ] })
    ] })
  ] });
}, fr = ({
  options: a,
  onChange: e,
  geometryType: l,
  selectedGraphic: r
}) => {
  const [c, o] = x(a?.precision ?? 2), [b, i] = x(a?.labelStyle ?? "simple"), [d, m] = x(a?.showSegmentLengths ?? !0), [g, h] = x(a?.textSize ?? "medium");
  O(() => {
    if (r && r.attributes) {
      if ("measurementPrecision" in r.attributes) {
        const u = r.getAttribute("measurementPrecision");
        u !== void 0 && o(u);
      }
      if ("measurementLabelStyle" in r.attributes) {
        const u = r.getAttribute("measurementLabelStyle");
        u !== void 0 && u !== b && i(u);
      }
      if ("measurementShowSegmentLengths" in r.attributes) {
        const u = r.getAttribute("measurementShowSegmentLengths");
        u !== void 0 && u !== d && m(u);
      }
      if ("measurementTextSize" in r.attributes) {
        const u = r.getAttribute("measurementTextSize");
        u !== void 0 && u !== g && h(u);
      }
    }
  }, [r, b, d, g]);
  const f = (u) => {
    e && e(u, r);
  };
  return /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    l !== "point" && /* @__PURE__ */ n.jsxs(le, { layout: "inline", children: [
      "Vis delsegmenter / radius",
      /* @__PURE__ */ n.jsx(
        fs,
        {
          checked: d,
          onCalciteSwitchChange: (u) => {
            const v = u.target.checked;
            m(v), f({ showSegmentLengths: v });
          }
        }
      )
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Etikettstil",
      /* @__PURE__ */ n.jsxs(
        Fa,
        {
          value: b,
          onCalciteSelectChange: (u) => {
            const v = u.target.value;
            i(v), f({ labelStyle: v });
          },
          children: [
            /* @__PURE__ */ n.jsx(be, { value: "simple", children: "Enkel" }),
            /* @__PURE__ */ n.jsx(be, { value: "boxed", children: "Med bakgrunn" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ n.jsxs(le, { children: [
      "Tekststørrelse",
      /* @__PURE__ */ n.jsxs(
        gs,
        {
          width: "full",
          scale: "s",
          value: g,
          onCalciteSegmentedControlChange: (u) => {
            const v = u.target.value;
            h(v), f({ textSize: v });
          },
          children: [
            /* @__PURE__ */ n.jsx(Xe, { value: "small", children: "Liten" }),
            /* @__PURE__ */ n.jsx(Xe, { value: "medium", children: "Medium" }),
            /* @__PURE__ */ n.jsx(Xe, { value: "large", children: "Stor" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ n.jsx(le, { children: "Presisjon (desimaler)" }),
    /* @__PURE__ */ n.jsx(
      ha,
      {
        min: 0,
        max: 6,
        step: 1,
        value: c,
        labelHandles: !0,
        labelTicks: !0,
        onCalciteSliderChange: (u) => {
          const v = u.target.value;
          o(v), f({ precision: v });
        }
      }
    )
  ] });
}, pr = ({
  sketchVM: a,
  measurementOptions: e,
  onMeasurementOptionsChange: l,
  measurementManager: r
}) => {
  const { t: c } = Pe(["drawing", "common"]), [o, b] = x(null), i = K([]), d = (m) => {
    if (m.length === 0)
      return null;
    const g = m[0]?.geometry?.type;
    return g ? m.every(
      (f) => f.geometry?.type === g
    ) ? g : "multiple" : null;
  };
  return O(() => {
    if (!a)
      return;
    if (a.activeTool) {
      const S = a.activeTool;
      S.includes("point") ? b("point") : S.includes("polyline") ? b("polyline") : S.includes("polygon") || S.includes("rectangle") || S.includes("circle") ? b("polygon") : S.includes("text") && b("text");
    }
    const m = a.watch("polygonSymbol", (S) => {
      i.current.length > 0 && i.current.forEach((U) => {
        U.geometry?.type === "polygon" && (U.symbol = S);
      });
    }), g = a.watch("pointSymbol", (S) => {
      i.current.length > 0 && i.current.forEach((U) => {
        U.geometry?.type === "point" && (U.symbol = S);
      });
    }), h = a.watch("polylineSymbol", (S) => {
      console.log("polylineSymbol changed:", S), i.current.length > 0 && (console.log("Updating polyline graphics:", i.current.length), i.current.forEach((U) => {
        U.geometry?.type === "polyline" && (console.log("Updating polyline graphic with new symbol"), U.symbol = S);
      }));
    }), f = a.watch("textSymbol", (S) => {
      i.current.length > 0 && i.current.forEach((U) => {
        U.geometry?.type === "point" && U.symbol?.type === "text" && (U.symbol = S);
      });
    }), u = a.watch("activeTool", (S) => {
      S && (S.includes("point") ? b("point") : S.includes("polyline") ? b("polyline") : S.includes("polygon") || S.includes("rectangle") || S.includes("circle") ? b("polygon") : S.includes("text") && b("text"));
    }), v = a.on("create", (S) => {
      if (S.graphic && (i.current = [S.graphic], r && r.updateMeasurement(S.graphic)), S.state === "start") {
        const U = a.activeTool;
        U && (U.includes("point") ? b("point") : U.includes("polyline") ? b("polyline") : U.includes("polygon") || U.includes("rectangle") || U.includes("circle") ? b("polygon") : U.includes("text") && b("text"));
      }
      S.state === "cancel" && (r?.removeMeasurement(S.graphic), i.current = [], b(null));
    }), A = a.on("delete", (S) => {
      r && S.graphics.length > 0 && S.graphics.forEach((U) => {
        r.removeMeasurement(U);
      }), b(null);
    }), p = a.on("update", (S) => {
      if (S.state === "complete") {
        i.current = [], b(null);
        return;
      }
      i.current = S.graphics || [];
      const U = d(i.current);
      if (b(U), U && i.current.length > 0) {
        const w = i.current[0];
        if (w.symbol)
          switch (U) {
            case "point":
              a.pointSymbol = w.symbol;
              break;
            case "polyline":
              a.polylineSymbol = w.symbol;
              break;
            case "polygon":
              a.polygonSymbol = w.symbol;
              break;
            case "text":
              a.textSymbol = w.symbol;
              break;
          }
      }
      r && S.graphics.length > 0 && S.graphics.forEach((w) => {
        r.updateMeasurement(w);
      });
    });
    return () => {
      v.remove(), u.remove(), A.remove(), p.remove(), m.remove(), g.remove(), h.remove(), f.remove();
    };
  }, [a, r]), a ? /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    o === null && /* @__PURE__ */ n.jsx(_a, { open: !0, children: /* @__PURE__ */ n.jsxs(Dt, { open: !0, kind: "info", icon: !0, children: [
      /* @__PURE__ */ n.jsx("div", { slot: "title", children: "Velg tegne- eller utvalgsverktøy" }),
      /* @__PURE__ */ n.jsx("div", { slot: "message", children: "Velg et tegneverktøy i verktøylinjen for å tegne i kartet og definere tilhørende symbol eller bruk utvalgsverktøy for å endre på eksisterende tegneobjekter" })
    ] }) }),
    o === "multiple" && /* @__PURE__ */ n.jsx(_a, { open: !0, children: /* @__PURE__ */ n.jsxs(Dt, { open: !0, kind: "info", icon: !0, children: [
      /* @__PURE__ */ n.jsx("div", { slot: "title", children: "Ulike geometrityper" }),
      /* @__PURE__ */ n.jsx("div", { slot: "message", children: "Kan ikke endre symboler når de valgte objektene har ulike geometrityper. Velg objekter av samme type for å endre symboler" })
    ] }) }),
    /* @__PURE__ */ n.jsx(_a, { open: !0, children: /* @__PURE__ */ n.jsxs("div", { className: "symbol-settings", children: [
      o === "point" && /* @__PURE__ */ n.jsx(
        lr,
        {
          sketchVM: a
        }
      ),
      o === "polyline" && /* @__PURE__ */ n.jsx(
        er,
        {
          sketchVM: a
        }
      ),
      o === "polygon" && /* @__PURE__ */ n.jsx(
        ar,
        {
          sketchVM: a
        }
      ),
      o === "text" && /* @__PURE__ */ n.jsx(
        gr,
        {
          sketchVM: a
        }
      )
    ] }) }),
    o != null && /* @__PURE__ */ n.jsxs(_a, { title: c("drawing:measurement.title"), open: !0, children: [
      /* @__PURE__ */ n.jsxs(le, { layout: "inline", children: [
        c("drawing:measurement.showMeasurement"),
        /* @__PURE__ */ n.jsx(
          fs,
          {
            checked: i.current.length > 0 ? i.current[0].getAttribute("measurementShowOnMap") ?? e?.showOnMap : e?.showOnMap,
            onCalciteSwitchChange: (m) => {
              i.current.length > 0 ? i.current.forEach((g) => {
                l?.({ showOnMap: m.target.checked }, g);
              }) : l?.({ showOnMap: m.target.checked }, null);
            }
          }
        )
      ] }),
      /* @__PURE__ */ n.jsx(il, { children: /* @__PURE__ */ n.jsx(bl, { heading: "Innstillinger for mål", children: /* @__PURE__ */ n.jsx(
        fr,
        {
          options: i.current.length > 0 ? {
            showOnMap: i.current[0].getAttribute("measurementShowOnMap") ?? e?.showOnMap,
            showLabels: i.current[0].getAttribute("measurementShowLabels") ?? e?.showLabels,
            unit: i.current[0].getAttribute("measurementUnit") ?? e?.unit,
            precision: i.current[0].getAttribute("measurementPrecision") ?? e?.precision,
            labelStyle: i.current[0].getAttribute("measurementLabelStyle") ?? e?.labelStyle,
            showSegmentLengths: i.current[0].getAttribute("measurementShowSegmentLengths") ?? e?.showSegmentLengths,
            textSize: i.current[0].getAttribute("measurementTextSize") ?? e?.textSize
          } : e,
          onChange: (m, g) => {
            i.current.length > 0 ? i.current.forEach((h) => {
              l?.(m, h);
            }) : l?.(m, null);
          },
          geometryType: o || "polygon",
          selectedGraphic: i.current[0]
        }
      ) }) })
    ] })
  ] }) : null;
}, Ft = class Je {
  // Private constructor to prevent direct construction calls with the `new` operator
  constructor() {
    this.measurementLayer = null, this.graphicToLabelMap = /* @__PURE__ */ new Map(), this.graphicIdCounter = 0;
  }
  /**
   * Get the singleton instance
   */
  static getInstance() {
    return Je.instance || (Je.instance = new Je()), Je.instance;
  }
  /**
   * Initialize the MeasurementManager with a view
   */
  init(e) {
    const l = "measurements-graphics-layer", r = e.map;
    if (!r) {
      console.warn("MeasurementManager.init: view.map is not available");
      return;
    }
    const c = r.findLayerById(l);
    c ? this.measurementLayer = c : (this.measurementLayer = new Sa({
      id: l,
      title: "Measurements",
      listMode: "hide"
    }), r.add(this.measurementLayer));
  }
  // Generer en unik ID for grafikk
  getGraphicId(e) {
    const l = e.getAttribute("id") || e.getAttribute("objectid");
    if (l)
      return l.toString();
    const r = `graphic-${this.graphicIdCounter++}`;
    return e.setAttribute("id", r), r;
  }
  // Hent målsettingsinnstillinger for en spesifikk grafikk
  getGraphicMeasurementOptions(e) {
    const l = { ...Je.DEFAULT_OPTIONS };
    return e.geometry?.type === "point" && (l.showOnMap = !1), e.attributes && "measurementShowLabels" in e.attributes && (l.showLabels = e.getAttribute("measurementShowLabels")), e.attributes && "measurementShowOnMap" in e.attributes && (l.showOnMap = e.getAttribute("measurementShowOnMap")), e.attributes && "measurementUnit" in e.attributes && (l.unit = e.getAttribute("measurementUnit")), e.attributes && "measurementPrecision" in e.attributes && (l.precision = e.getAttribute("measurementPrecision")), e.attributes && "measurementLabelStyle" in e.attributes && (l.labelStyle = e.getAttribute("measurementLabelStyle")), e.attributes && "measurementShowSegmentLengths" in e.attributes && (l.showSegmentLengths = e.getAttribute("measurementShowSegmentLengths")), e.attributes && "measurementTextSize" in e.attributes && (l.textSize = e.getAttribute("measurementTextSize")), l.unit = "metric", l;
  }
  // Lagre målsettingsinnstillinger på en grafikk
  setGraphicMeasurementOptions(e, l) {
    l.showLabels !== void 0 && e.setAttribute("measurementShowLabels", l.showLabels), l.showOnMap !== void 0 && e.setAttribute("measurementShowOnMap", l.showOnMap), l.unit !== void 0 && e.setAttribute("measurementUnit", l.unit), l.precision !== void 0 && e.setAttribute("measurementPrecision", l.precision), l.labelStyle !== void 0 && e.setAttribute("measurementLabelStyle", l.labelStyle), l.showSegmentLengths !== void 0 && e.setAttribute("measurementShowSegmentLengths", l.showSegmentLengths), l.textSize !== void 0 && e.setAttribute("measurementTextSize", l.textSize), this.updateMeasurement(e);
  }
  // Hovedmetode for å legge til/oppdatere målsetting
  updateMeasurement(e) {
    if (this.removeMeasurement(e), !e.geometry)
      return;
    const l = this.getGraphicMeasurementOptions(e), r = this.calculateMeasurement(e.geometry, l);
    r && (e.setAttribute("measurement", r.formatted), e.setAttribute("measurementValue", r.value), l.showOnMap && l.showLabels && (this.addLabelMeasurement(e, r, l), (e.geometry.type === "polyline" || e.geometry.type === "polygon") && l.showSegmentLengths && this.addSegmentMeasurements(e, l)));
  }
  // Fjern målsetting for en grafikk
  removeMeasurement(e) {
    if (!this.measurementLayer)
      return;
    const l = this.getGraphicId(e);
    this.graphicToLabelMap.has(l) && (this.graphicToLabelMap.get(l).forEach((b) => {
      this.measurementLayer && this.measurementLayer.remove(b);
    }), this.graphicToLabelMap.delete(l));
    const c = this.measurementLayer.graphics.toArray().filter(
      (o) => o.attributes && o.attributes.parentGraphicId === l && o.attributes.isMeasurementLabel
    );
    for (const o of c)
      this.measurementLayer.remove(o);
  }
  // Beregn målsetting basert på geometri
  calculateMeasurement(e, l) {
    if (!e)
      return null;
    let r = null;
    try {
      switch (e.type) {
        case "point": {
          const c = e;
          r = {
            value: c.z || 0,
            formatted: c.z ? `Z: ${this.formatValue(c.z, "m", l.precision)}` : `(${this.formatValue(c.x, "", l.precision)}, ${this.formatValue(c.y, "", l.precision)})`
          };
          break;
        }
        case "polyline": {
          try {
            let c;
            c = Wt.execute(e, { unit: "meters" }), r = {
              value: c,
              formatted: this.formatLength(c, l.precision)
            };
          } catch (c) {
            console.error("Failed to calculate polyline length", c);
            const o = e;
            let b = 0;
            if (o.paths && o.paths.length > 0)
              for (const i of o.paths)
                for (let d = 1; d < i.length; d++) {
                  const m = i[d][0] - i[d - 1][0], g = i[d][1] - i[d - 1][1];
                  b += Math.sqrt(m * m + g * g);
                }
            r = {
              value: b,
              formatted: this.formatLength(b, l.precision)
            };
          }
          break;
        }
        case "polygon": {
          try {
            let c;
            c = Bl.execute(e, { unit: "square-meters" }), r = {
              value: c,
              formatted: this.formatArea(c, l.precision)
            };
          } catch (c) {
            console.error("Failed to calculate polygon area", c), r = {
              value: 0,
              formatted: this.formatArea(0, l.precision)
            };
          }
          break;
        }
        default:
          r = null;
      }
    } catch (c) {
      console.error("Error in calculateMeasurement", c), r = {
        value: 0,
        formatted: "Beregning feilet"
      };
    }
    return r;
  }
  // Formater lengde med riktig enhet (alltid metrisk)
  formatLength(e, l) {
    return e < 1e3 ? `${this.formatValue(e, "m", l)}` : `${this.formatValue(e / 1e3, "km", l)}`;
  }
  // Formater areal med riktig enhet (alltid metrisk)
  formatArea(e, l) {
    return e < 1e4 ? `${this.formatValue(e, "m²", l)}` : `${this.formatValue(e / 1e4, "ha", l)}`;
  }
  // Formater tall med angitt presisjon
  formatValue(e, l, r) {
    return `${e.toFixed(r)} ${l}`;
  }
  // Finn posisjon for label basert på geometri (alltid senter/midtpunkt)
  getLabelPosition(e) {
    if (!e)
      return null;
    let l = null;
    switch (e.type) {
      case "point": {
        l = e;
        break;
      }
      case "polyline": {
        const r = e;
        r.extent && (l = r.extent.center);
        break;
      }
      case "polygon": {
        const r = e;
        r.centroid ? l = r.centroid : r.extent && (l = r.extent.center);
        break;
      }
      default:
        e.extent && e.extent.center && (l = e.extent.center);
    }
    return l;
  }
  // Get font size based on text size option
  getFontSize(e, l = !1) {
    const r = {
      small: 10,
      medium: 12,
      large: 16
    };
    return l ? r[e] - 2 : r[e];
  }
  // Legg til tekstlabel for målsetting
  addLabelMeasurement(e, l, r) {
    if (!e.geometry)
      return;
    const c = this.getLabelPosition(e.geometry);
    if (!c)
      return;
    const o = this.getFontSize(r.textSize);
    let b;
    switch (r.labelStyle) {
      case "boxed": {
        b = {
          type: "text",
          color: "black",
          haloColor: "white",
          haloSize: "2px",
          text: l.formatted,
          font: {
            size: o,
            family: "sans-serif",
            weight: "bold"
          },
          backgroundColor: [255, 255, 255, 0.7],
          borderLineColor: [0, 0, 0, 0.5],
          borderLineSize: 1,
          yoffset: 3
        };
        break;
      }
      default: {
        b = {
          type: "text",
          color: "black",
          haloColor: "white",
          haloSize: "2px",
          text: l.formatted,
          font: {
            size: o,
            family: "sans-serif",
            weight: "bold"
          }
        };
        break;
      }
    }
    const i = this.getGraphicId(e), d = new dt({
      geometry: c,
      symbol: b,
      attributes: {
        parentGraphicId: i,
        isMeasurementLabel: !0,
        type: "main-measurement"
      }
    });
    this.measurementLayer && this.measurementLayer.add(d);
    const m = this.getGraphicId(e);
    this.graphicToLabelMap.has(m) || this.graphicToLabelMap.set(m, []), this.graphicToLabelMap.get(m).push(d);
  }
  // Create a text symbol for segment measurements
  createSegmentTextSymbol(e, l, r, c = !0) {
    const o = this.getFontSize(r.textSize, c);
    switch (r.labelStyle) {
      case "boxed":
        return {
          type: "text",
          color: "black",
          haloColor: "white",
          haloSize: "2px",
          text: e,
          font: {
            size: o,
            family: "sans-serif",
            weight: "bold"
          },
          backgroundColor: [255, 255, 255, 0.7],
          borderLineColor: [0, 0, 0, 0.5],
          borderLineSize: 1,
          yoffset: 3,
          angle: l
        };
      default:
        return {
          type: "text",
          color: "black",
          haloColor: "white",
          haloSize: "2px",
          text: e,
          font: {
            size: o,
            family: "sans-serif",
            weight: "bold"
          },
          angle: l
        };
    }
  }
  // Calculate segment length and create label
  createSegmentLabel(e, l, r, c) {
    const o = new zl({
      paths: [[[e[0], e[1]], [l[0], l[1]]]],
      spatialReference: r
    }), b = Wt.execute(o, { unit: "meters" }), i = this.formatLength(b, c.precision), d = (e[0] + l[0]) / 2, m = (e[1] + l[1]) / 2, g = new Ra({
      x: d,
      y: m,
      spatialReference: r
    }), h = l[0] - e[0], f = l[1] - e[1];
    let u = -Math.atan2(f, h) * 180 / Math.PI;
    u < -90 ? u += 180 : u > 90 && (u -= 180);
    const v = this.createSegmentTextSymbol(i, u, c);
    return new dt({
      geometry: g,
      symbol: v,
      attributes: {
        // parentGraphicId will be set when added to the layer
        parentGraphicId: null,
        isMeasurementLabel: !0,
        type: "segment-measurement"
      }
    });
  }
  // Check if a polygon is approximately a circle
  isCircle(e) {
    if (!e)
      return { isCircle: !1 };
    if (!e.rings || e.rings.length !== 1)
      return { isCircle: !1 };
    const l = e.rings[0];
    if (l.length < 8)
      return { isCircle: !1 };
    let r = 0, c = 0;
    for (let f = 0; f < l.length - 1; f++)
      r += l[f][0], c += l[f][1];
    const o = r / (l.length - 1), b = c / (l.length - 1);
    let i = 0, d = [];
    for (let f = 0; f < l.length - 1; f++) {
      const u = l[f][0] - o, v = l[f][1] - b, A = Math.sqrt(u * u + v * v);
      d.push(A), i += A;
    }
    const m = i / (l.length - 1), g = 0.05;
    for (const f of d)
      if (Math.abs(f - m) / m > g)
        return { isCircle: !1 };
    return {
      isCircle: !0,
      center: new Ra({
        x: o,
        y: b,
        spatialReference: e.spatialReference
      }),
      radius: m
    };
  }
  // Add measurements for individual segments of polylines or polygon perimeters
  addSegmentMeasurements(e, l) {
    if (!e.geometry)
      return;
    const r = e.geometry, c = [];
    if (r.type === "polyline") {
      const o = r;
      if (o.paths && o.paths.length > 0)
        for (const b of o.paths)
          for (let i = 1; i < b.length; i++) {
            const d = this.createSegmentLabel(
              b[i - 1],
              b[i],
              o.spatialReference,
              l
            );
            if (d && this.measurementLayer) {
              const m = this.getGraphicId(e);
              d.attributes ? d.attributes.parentGraphicId = m : d.attributes = {
                parentGraphicId: m,
                isMeasurementLabel: !0,
                type: "segment-measurement"
              }, this.measurementLayer.add(d), c.push(d);
            }
          }
    } else if (r.type === "polygon") {
      const o = r, b = this.isCircle(o);
      if (b.isCircle && b.center && b.radius) {
        const d = `R: ${this.formatLength(b.radius, l.precision)}`, m = b.radius * 0.3, g = new Ra({
          x: b.center.x,
          y: b.center.y - m,
          // Move down (south) by subtracting from Y
          spatialReference: o.spatialReference
        }), h = this.createSegmentTextSymbol(d, 0, l), f = this.getGraphicId(e), u = new dt({
          geometry: g,
          symbol: h,
          attributes: {
            parentGraphicId: f,
            isMeasurementLabel: !0,
            type: "radius-measurement"
          }
        });
        this.measurementLayer && (this.measurementLayer.add(u), c.push(u));
      } else if (o.rings && o.rings.length > 0)
        for (const i of o.rings) {
          for (let d = 1; d < i.length - 1; d++) {
            const m = this.createSegmentLabel(
              i[d - 1],
              i[d],
              o.spatialReference,
              l
            );
            if (m && this.measurementLayer) {
              const g = this.getGraphicId(e);
              m.attributes ? m.attributes.parentGraphicId = g : m.attributes = {
                parentGraphicId: g,
                isMeasurementLabel: !0,
                type: "polygon-segment-measurement"
              }, this.measurementLayer.add(m), c.push(m);
            }
          }
          if (i.length >= 3) {
            const d = i.length - 2, m = this.createSegmentLabel(
              i[d],
              i[0],
              o.spatialReference,
              l
            );
            if (m && this.measurementLayer) {
              const g = this.getGraphicId(e);
              m.attributes ? m.attributes.parentGraphicId = g : m.attributes = {
                parentGraphicId: g,
                isMeasurementLabel: !0,
                type: "polygon-closing-segment-measurement"
              }, this.measurementLayer.add(m), c.push(m);
            }
          }
        }
    }
    if (c.length > 0) {
      const o = this.getGraphicId(e);
      this.graphicToLabelMap.has(o) || this.graphicToLabelMap.set(o, []), this.graphicToLabelMap.get(o).push(...c);
    }
  }
  // Clear all measurements without destroying the layer
  clearAllMeasurements() {
    if (!this.measurementLayer)
      return;
    const l = this.measurementLayer.graphics.toArray().filter(
      (r) => r.attributes && r.attributes.isMeasurementLabel
    );
    for (const r of l)
      this.measurementLayer.remove(r);
    this.graphicToLabelMap.clear();
  }
  // No need to destroy the singleton, but provide a method to reset if needed
  reset() {
    this.graphicToLabelMap.clear();
  }
};
Ft.instance = null;
Ft.DEFAULT_OPTIONS = {
  showLabels: !0,
  showOnMap: !0,
  unit: "metric",
  precision: 2,
  labelStyle: "simple",
  showSegmentLengths: !0,
  textSize: "medium"
};
let zs = Ft;
const ft = "drawing-graphics-layer", k0 = () => {
  const { mapView: a } = He(), [, e] = x(), l = K(null), r = K(null), c = K(null);
  console.log("Rendering Drawing component");
  const [o, b] = x({
    showLabels: !0,
    showOnMap: !0,
    unit: "metric",
    precision: 2,
    textSize: "medium",
    labelStyle: "simple",
    showSegmentLengths: !0
  }), i = K(null);
  O(() => {
    const m = a?.map;
    if (!a || !m || !a.container || !c.current)
      return;
    let g = !1, h = m.findLayerById(ft);
    return h || (h = new Sa({
      id: ft,
      listMode: "hide"
    }), m.add(h)), l.current = h, a.when(() => {
      if (g)
        return;
      const f = [];
      l.current && f.push({ layer: l.current, enabled: !0 }), m.allLayers.forEach((v) => {
        (v instanceof Dl || v instanceof Sa) && v.id !== ft && f.push({ layer: v, enabled: !0 });
      });
      const u = new $l({
        layer: l.current || void 0,
        view: a,
        creationMode: "update",
        container: c.current,
        snappingOptions: {
          enabled: !0,
          selfEnabled: !1,
          distance: 10,
          featureSources: f
        },
        tooltipOptions: { enabled: !0 },
        visibleElements: { duplicateButton: !1 }
      });
      r.current = u, e(u), i.current = zs.getInstance(), i.current.init(a);
    }), () => {
      g = !0, r.current && (r.current.destroy(), r.current = null);
    };
  }, [a]);
  const d = (m, g) => {
    g && i.current && i.current.setGraphicMeasurementOptions(g, m);
  };
  return /* @__PURE__ */ n.jsxs("div", { id: "tegning-details", children: [
    /* @__PURE__ */ n.jsx("div", { ref: c, id: "tegning-description", className: "sketch-toolbar-container" }),
    /* @__PURE__ */ n.jsx(
      pr,
      {
        sketchVM: r.current?.viewModel ?? null,
        measurementOptions: o,
        onMeasurementOptionsChange: d,
        measurementManager: i.current
      }
    )
  ] });
}, hr = "DrawingBlock-module__block___R5QZD", ur = "DrawingBlock-module__open___pPJL9", Ar = "DrawingBlock-module__header___2OncX", Sr = "DrawingBlock-module__headerActions___DF-R0", Nr = "DrawingBlock-module__trigger___ykZgk", wr = "DrawingBlock-module__heading___hTUwI", Ur = "DrawingBlock-module__indicator___PMMPf", vr = "DrawingBlock-module__contentWrapper___AVgV7", _r = "DrawingBlock-module__content___DSuRC", Ve = {
  block: hr,
  open: ur,
  header: Ar,
  headerActions: Sr,
  trigger: Nr,
  heading: wr,
  indicator: Ur,
  contentWrapper: vr,
  content: _r
};
function xr({ heading: a, open: e, onOpenChange: l, headerActions: r, children: c }) {
  const o = nl(), b = `${o}-content`, i = `${o}-heading`;
  return /* @__PURE__ */ n.jsxs("section", { className: `${Ve.block} ${e ? Ve.open : ""}`, children: [
    /* @__PURE__ */ n.jsxs("div", { className: Ve.header, children: [
      /* @__PURE__ */ n.jsxs(
        "button",
        {
          type: "button",
          "aria-expanded": e,
          "aria-controls": b,
          onClick: () => l(!e),
          className: Ve.trigger,
          children: [
            /* @__PURE__ */ n.jsx(Vt, { size: 16, weight: "bold", className: Ve.indicator, "aria-hidden": "true" }),
            /* @__PURE__ */ n.jsx("span", { id: i, className: Ve.heading, children: a })
          ]
        }
      ),
      r && /* @__PURE__ */ n.jsx("div", { className: Ve.headerActions, children: r })
    ] }),
    /* @__PURE__ */ n.jsx("section", { id: b, "aria-labelledby": i, className: Ve.contentWrapper, children: /* @__PURE__ */ n.jsx("div", { className: Ve.content, children: c }) })
  ] });
}
const Lr = "DrawingCustomToolbar-module__root___LPkOc", Cr = "DrawingCustomToolbar-module__group___SrZ-n", kr = "DrawingCustomToolbar-module__label___6lIrf", Er = "DrawingCustomToolbar-module__toolRow___1D-C6", Mr = "DrawingCustomToolbar-module__toolbarItem___7-ufb", jr = "DrawingCustomToolbar-module__divider___MZewe", Te = {
  root: Lr,
  group: Cr,
  label: kr,
  toolRow: Er,
  toolbarItem: Mr,
  divider: jr
}, Jt = { weight: "duotone", size: 24 }, Tr = [
  { key: "point", icon: /* @__PURE__ */ n.jsx(Is, {}), label: "Punkt", tooltip: "Tegn punkt" },
  { key: "polyline", icon: /* @__PURE__ */ n.jsx(Hs, {}), label: "Linje", tooltip: "Tegn linje" },
  { key: "polygon", icon: /* @__PURE__ */ n.jsx(Vs, {}), label: "Polygon", tooltip: "Tegn polygon" },
  { key: "rectangle", icon: /* @__PURE__ */ n.jsx(Ps, {}), label: "Rektangel", tooltip: "Tegn rektangel" },
  { key: "circle", icon: /* @__PURE__ */ n.jsx(Es, {}), label: "Sirkel", tooltip: "Tegn sirkel" }
], Hr = [
  { key: "click", icon: /* @__PURE__ */ n.jsx(Ms, {}), label: "Velg", tooltip: "Velg objekt" },
  { key: "rectangle", icon: /* @__PURE__ */ n.jsx(Os, {}), label: "Velg med rektangel", tooltip: "Velg med rektangel" },
  { key: "lasso", icon: /* @__PURE__ */ n.jsx(Ts, {}), label: "Velg med lasso", tooltip: "Velg med lasso" }
], Zr = ({
  activeTool: a,
  selectMode: e,
  snappingEnabled: l,
  hasDrawings: r,
  selectionCount: c,
  onCreate: o,
  onSelect: b,
  onDelete: i,
  onToggleSnapping: d
}) => /* @__PURE__ */ n.jsxs("div", { className: Te.root, children: [
  /* @__PURE__ */ n.jsx("div", { className: Te.group, children: /* @__PURE__ */ n.jsx(Et.Provider, { value: Jt, children: /* @__PURE__ */ n.jsxs("div", { className: Te.toolRow, role: "toolbar", "aria-label": "Tegneverktøy", children: [
    Tr.map(({ key: m, icon: g, label: h, tooltip: f }) => /* @__PURE__ */ n.jsx(xa, { content: f, position: "bottom", children: /* @__PURE__ */ n.jsx(ua, { icon: g, label: h, active: a === m, onClick: () => o(m), className: Te.toolbarItem }) }, m)),
    /* @__PURE__ */ n.jsx("span", { className: Te.divider, "aria-hidden": "true" }),
    /* @__PURE__ */ n.jsx(xa, { content: l ? "Slå av snap" : "Slå på snap", position: "bottom", children: /* @__PURE__ */ n.jsx(ua, { icon: /* @__PURE__ */ n.jsx(Zs, {}), label: "Snap", active: l, onClick: d, className: Te.toolbarItem }) })
  ] }) }) }),
  r && /* @__PURE__ */ n.jsx("div", { className: Te.group, children: /* @__PURE__ */ n.jsx(Et.Provider, { value: Jt, children: /* @__PURE__ */ n.jsxs("div", { className: Te.toolRow, role: "toolbar", "aria-label": "Valgverktøy", children: [
    Hr.map(({ key: m, icon: g, label: h, tooltip: f }) => /* @__PURE__ */ n.jsx(xa, { content: f, position: "bottom", children: /* @__PURE__ */ n.jsx(ua, { icon: g, label: h, active: e === m, onClick: () => b(m), className: Te.toolbarItem }) }, m)),
    c > 0 && /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
      /* @__PURE__ */ n.jsx("span", { className: Te.divider, "aria-hidden": "true" }),
      /* @__PURE__ */ n.jsx(xa, { content: "Slett valgt objekt", position: "bottom", children: /* @__PURE__ */ n.jsxs(hs, { rightIcon: /* @__PURE__ */ n.jsx(Ot, { size: 16 }), onClick: i, variant: "secondary", size: "sm", children: [
        c,
        " valgt"
      ] }) })
    ] })
  ] }) }) })
] }), Gs = [
  { value: "solid", label: "Heltrukket" },
  { value: "dash", label: "Stiplet" },
  { value: "dot", label: "Prikker" },
  { value: "dash-dot", label: "Strek-prikk" },
  { value: "dash-dot-dot", label: "Strek-prikk-prikk" }
];
function wa(a) {
  if (!a)
    return "#0000ff";
  const [e, l, r] = Array.isArray(a) ? [a[0], a[1], a[2]] : [a.r ?? 0, a.g ?? 0, a.b ?? 0];
  return `#${e.toString(16).padStart(2, "0")}${l.toString(16).padStart(2, "0")}${r.toString(16).padStart(2, "0")}`;
}
function Ua(a) {
  if (!a)
    return 0;
  let e = Array.isArray(a) ? a[3] : a.a ?? 1;
  return e > 1 && (e = e / 255), Math.round((1 - e) * 100);
}
function va(a, e) {
  const l = parseInt(a.slice(1, 3), 16), r = parseInt(a.slice(3, 5), 16), c = parseInt(a.slice(5, 7), 16), o = (100 - e) / 100;
  return [l, r, c, o];
}
const Rr = "SymbolSettings-module__settings___DHOLk", Ir = "SymbolSettings-module__sliderRow___PWdGI", Vr = "SymbolSettings-module__slider___Nmjob", Pr = "SymbolSettings-module__numberInput___5WpgX", Or = "SymbolSettings-module__colorRow___Ta3Eg", Fr = "SymbolSettings-module__opacityBox___PuUvi", $r = "SymbolSettings-module__opacityBoxInput___bVIsv", Dr = "SymbolSettings-module__opacityUnit___hezvo", he = {
  settings: Rr,
  sliderRow: Ir,
  slider: Vr,
  numberInput: Pr,
  colorRow: Or,
  opacityBox: Fr,
  opacityBoxInput: $r,
  opacityUnit: Dr
}, Oa = ({ label: a, value: e, min: l, max: r, step: c, unit: o, onChange: b }) => /* @__PURE__ */ n.jsxs("div", { className: he.sliderRow, children: [
  /* @__PURE__ */ n.jsx(
    Zt,
    {
      label: a,
      min: l,
      max: r,
      step: c,
      value: e,
      showValue: !1,
      onChange: (i) => b(Number(i.target.value)),
      className: he.slider
    }
  ),
  /* @__PURE__ */ n.jsx(
    El,
    {
      label: "",
      min: l,
      max: r,
      step: c,
      value: e,
      unit: o,
      onChange: (i) => b(Number(i.target.value)),
      className: he.numberInput
    }
  )
] }), Br = ({ sketchVM: a, initialSymbol: e, onSymbolChange: l }) => {
  const r = a, [c, o] = x(() => {
    const i = e ?? r.polylineSymbol;
    return {
      color: wa(i?.color),
      transparency: Ua(i?.color),
      width: i?.width ?? 2,
      style: i?.style ?? "solid"
    };
  });
  function b(i) {
    const d = { ...c, ...i };
    o(d);
    const m = {
      type: "simple-line",
      color: va(d.color, d.transparency),
      width: d.width,
      style: d.style
    };
    l ? l(m) : r.polylineSymbol = m;
  }
  return /* @__PURE__ */ n.jsxs("div", { className: he.settings, children: [
    /* @__PURE__ */ n.jsx(
      Da,
      {
        label: "Stil",
        value: c.style,
        options: Gs,
        onChange: (i) => b({ style: i.target.value })
      }
    ),
    /* @__PURE__ */ n.jsx(
      Va,
      {
        label: "Farge",
        value: c.color,
        onChange: (i) => b({ color: i })
      }
    ),
    /* @__PURE__ */ n.jsx(
      Oa,
      {
        label: "Gjennomsiktighet",
        value: c.transparency,
        min: 0,
        max: 100,
        step: 1,
        unit: "%",
        onChange: (i) => b({ transparency: i })
      }
    ),
    /* @__PURE__ */ n.jsx(
      Oa,
      {
        label: "Bredde",
        value: c.width,
        min: 0.5,
        max: 20,
        step: 0.5,
        unit: "px",
        onChange: (i) => b({ width: i })
      }
    )
  ] });
}, zr = ({ sketchVM: a, initialSymbol: e, onSymbolChange: l }) => {
  const r = a, [c, o] = x(() => {
    const i = e ?? r.polygonSymbol;
    return {
      fillColor: wa(i?.color),
      fillTransparency: Ua(i?.color),
      outlineColor: wa(i?.outline?.color),
      outlineTransparency: Ua(i?.outline?.color),
      outlineWidth: i?.outline?.width ?? 1,
      outlineStyle: i?.outline?.style ?? "solid"
    };
  });
  function b(i) {
    const d = { ...c, ...i };
    o(d);
    const m = {
      type: "simple-fill",
      color: va(d.fillColor, d.fillTransparency),
      outline: {
        color: va(d.outlineColor, d.outlineTransparency),
        width: d.outlineWidth,
        style: d.outlineStyle
      }
    };
    l ? l(m) : r.polygonSymbol = m;
  }
  return /* @__PURE__ */ n.jsxs("div", { className: he.settings, children: [
    /* @__PURE__ */ n.jsxs("div", { className: he.colorRow, children: [
      /* @__PURE__ */ n.jsx(
        Va,
        {
          label: "Fyllfarge",
          value: c.fillColor,
          onChange: (i) => b({ fillColor: i }),
          stretch: !0
        }
      ),
      /* @__PURE__ */ n.jsxs("div", { className: he.opacityBox, children: [
        /* @__PURE__ */ n.jsx(Mt, { size: 12 }),
        /* @__PURE__ */ n.jsx(
          "input",
          {
            type: "number",
            className: he.opacityBoxInput,
            min: 0,
            max: 100,
            step: 1,
            value: c.fillTransparency,
            "aria-label": "Fyllgjennomsiktighet",
            onChange: (i) => b({ fillTransparency: Number(i.target.value) })
          }
        ),
        /* @__PURE__ */ n.jsx("span", { className: he.opacityUnit, "aria-hidden": "true", children: "%" })
      ] })
    ] }),
    /* @__PURE__ */ n.jsxs("div", { className: he.colorRow, children: [
      /* @__PURE__ */ n.jsx(
        Va,
        {
          label: "Omrissfarge",
          value: c.outlineColor,
          onChange: (i) => b({ outlineColor: i }),
          stretch: !0
        }
      ),
      /* @__PURE__ */ n.jsxs("div", { className: he.opacityBox, children: [
        /* @__PURE__ */ n.jsx(Mt, { size: 12 }),
        /* @__PURE__ */ n.jsx(
          "input",
          {
            type: "number",
            className: he.opacityBoxInput,
            min: 0,
            max: 100,
            step: 1,
            value: c.outlineTransparency,
            "aria-label": "Omrissgjennomsiktighet",
            onChange: (i) => b({ outlineTransparency: Number(i.target.value) })
          }
        ),
        /* @__PURE__ */ n.jsx("span", { className: he.opacityUnit, "aria-hidden": "true", children: "%" })
      ] })
    ] }),
    /* @__PURE__ */ n.jsx(
      Da,
      {
        label: "Omrissstil",
        value: c.outlineStyle,
        options: Gs,
        onChange: (i) => b({ outlineStyle: i.target.value })
      }
    ),
    /* @__PURE__ */ n.jsx(
      Zt,
      {
        label: "Omrissbredde",
        value: c.outlineWidth,
        min: 0.5,
        max: 20,
        step: 0.5,
        formatValue: (i) => `${i} px`,
        onChange: (i) => b({ outlineWidth: Number(i.target.value) })
      }
    )
  ] });
}, Ws = [
  {
    name: "shapes-circle-3",
    symbolName: "Circle 3_Shapes_3",
    label: "Circle 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-circle-2",
    symbolName: "Double Circle",
    label: "Circle 2",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-triangle-3",
    symbolName: "Triangle 3_Shapes_3",
    label: "Triangle 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-square-3",
    symbolName: "Square 3_Shapes_3",
    label: "Square 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-rectangle",
    symbolName: "Rectangle",
    label: "Rectangle",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-diamond-3",
    symbolName: "Diamond 3_Shapes_3",
    label: "Diamond 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-hexagon-3",
    symbolName: "Hexagon 3_Shapes_3",
    label: "Hexagon 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-pentagon-3",
    symbolName: "Pentagon 3_Shapes_3",
    label: "Pentagon 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-octagon",
    symbolName: "Triangle 3",
    label: "Octagon",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-octagon-2",
    symbolName: "Octagon 2",
    label: "Octagon 2",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-star-3",
    symbolName: "Star 3_Shapes_3",
    label: "Star 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-cross-3",
    symbolName: "Cross 3_Shapes_3",
    label: "Cross 3",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-asterisk-1",
    symbolName: "asterisk ",
    label: "asterisk 1",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-asterisk-2",
    symbolName: "asterisk 2",
    label: "asterisk 2",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-plus",
    symbolName: "Plus",
    label: "Plus",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "shapes-x",
    symbolName: "X",
    label: "X",
    category: "Shapes",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/a63b3a4631ae41d4a1bc3ba6d9c85bfe/data"
  },
  {
    name: "pins-pin-drop-x",
    symbolName: "Point symbol",
    label: "Pin drop x",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-push-pin-1",
    symbolName: "Point symbol_1",
    label: "Push pin 1",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-circle-pin-drop",
    symbolName: "Point symbol_2",
    label: "Circle pin drop",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-wide-pin-drop",
    symbolName: "Point symbol_3",
    label: "Wide pin drop",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-map-location",
    symbolName: "Point symbol_5",
    label: "Map location",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-simple-pin",
    symbolName: "Point symbol_6",
    label: "Simple pin",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-push-pin-2",
    symbolName: "Point symbol_7",
    label: "Push pin 2",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-location-pin",
    symbolName: "Point symbol_8",
    label: "Location pin",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "pins-location",
    symbolName: "Point symbol_9",
    label: "Location",
    category: "Pins",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/70ccf6bcbd304773a164be896e76edd3/data"
  },
  {
    name: "vehicles-transport-ship",
    symbolName: "Point symbol",
    label: "Transport ship",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-plane",
    symbolName: "Point symbol_1",
    label: "Plane",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-subway",
    symbolName: "Point symbol_2",
    label: "Subway",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-motorcycle",
    symbolName: "Point symbol_3",
    label: "Motorcycle",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-bus",
    symbolName: "Point symbol_4",
    label: "Bus",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-roller-coaster",
    symbolName: "Point symbol_5",
    label: "Roller coaster",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-ferris-wheel",
    symbolName: "Point symbol_6",
    label: "Ferris wheel",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-cruise-ship",
    symbolName: "Point symbol_7",
    label: "Cruise ship",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-traffic-light-horizontal",
    symbolName: "Point symbol_8",
    label: "Traffic light horizontal",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-traffic-light-vertical",
    symbolName: "Point symbol_9",
    label: "Traffic light vertical",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-warning-sign",
    symbolName: "Point symbol_10",
    label: "Warning sign",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-fuel-pump",
    symbolName: "Point symbol_11",
    label: "Fuel pump",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-barrier-sign",
    symbolName: "Point symbol_12",
    label: "Barrier sign",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-anchor",
    symbolName: "Point symbol_13",
    label: "Anchor",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-seating",
    symbolName: "Point symbol_14",
    label: "Seating",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-rocket-ship",
    symbolName: "Point symbol_15",
    label: "Rocket ship",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-speed-boat",
    symbolName: "Point symbol_16",
    label: "Speed boat",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-sail-boat",
    symbolName: "Point symbol_17",
    label: "Sail boat",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-plane-2",
    symbolName: "Point symbol_18",
    label: "Plane 2",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-helicopter",
    symbolName: "Point symbol_19",
    label: "Helicopter",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-train-stop",
    symbolName: "Point symbol_20",
    label: "Train stop",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-cable-car",
    symbolName: "Point symbol_21",
    label: "Cable car",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-commuter-train",
    symbolName: "Point symbol_22",
    label: "Commuter train",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-steam-locomotive",
    symbolName: "Point symbol_24",
    label: "Steam locomotive",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-train-and-mountains",
    symbolName: "Point symbol_25",
    label: "Train and mountains",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-high-speed-train-1",
    symbolName: "Point symbol_26",
    label: "High-speed train 1",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-high-speed-train-2",
    symbolName: "Point symbol_27",
    label: "High-speed train 2",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-high-speed-train-3",
    symbolName: "Point symbol_28",
    label: "High-speed train 3",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-train-on-track",
    symbolName: "Point symbol_29",
    label: "Train on track",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-cable-car-side-profile",
    symbolName: "Point symbol_30",
    label: "Cable car side profile",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-bilevel-rail-car",
    symbolName: "Point symbol_31",
    label: "Bilevel rail car",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-aerial-tramway-1",
    symbolName: "Point symbol_32",
    label: "Aerial tramway 1",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-aerial-tramway-2",
    symbolName: "Point symbol_33",
    label: "Aerial tramway 2",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-aerial-tramway-small",
    symbolName: "Point symbol_34",
    label: "Aerial tramway small",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-taxi",
    symbolName: "Point symbol_35",
    label: "Taxi",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-blue-car",
    symbolName: "Point symbol_36",
    label: "Blue car",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-red-bus",
    symbolName: "Point symbol_37",
    label: "Red bus",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-police-car",
    symbolName: "Point symbol_38",
    label: "Police car",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-emergency-light",
    symbolName: "Point symbol_39",
    label: "Emergency light",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-bicycle",
    symbolName: "Point symbol_40",
    label: "Bicycle",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-classic-motorcycle",
    symbolName: "Point symbol_41",
    label: "Classic motorcycle",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-tractor",
    symbolName: "Point symbol_42",
    label: "Tractor",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-truck-small",
    symbolName: "Point symbol_43",
    label: "Truck small",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-transport-truck",
    symbolName: "Point symbol_44",
    label: "Transport truck",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-van",
    symbolName: "Point symbol_45",
    label: "Van",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-fire-truck",
    symbolName: "Point symbol_46",
    label: "Fire truck",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-ambulance",
    symbolName: "Point symbol_47",
    label: "Ambulance",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-police-car-side-profile",
    symbolName: "Point symbol_48",
    label: "Police car side profile",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-race-car",
    symbolName: "Point symbol_49",
    label: "Race car",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-cable-car-side",
    symbolName: "Point symbol_50",
    label: "Cable car side",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-commuter-bus-side",
    symbolName: "Point symbol_51",
    label: "Commuter bus side",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-blue-car-side",
    symbolName: "Point symbol_52",
    label: "Blue car side",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-taxi-side",
    symbolName: "Point symbol_53",
    label: "Taxi side",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "vehicles-red-car-side",
    symbolName: "Point symbol_54",
    label: "Red car side",
    category: "Vehicles",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/0d9f00ffc3af4d128ac5771e3dbce440/data"
  },
  {
    name: "animals-hedgehog",
    symbolName: "Hedgehog",
    label: "Hedgehog",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-wolf",
    symbolName: "Wolf",
    label: "Wolf",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-porcupine",
    symbolName: "Porcupine",
    label: "Porcupine",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-bear",
    symbolName: "Bear",
    label: "Bear",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-gorilla",
    symbolName: "Gorilla",
    label: "Gorilla",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-mouse",
    symbolName: "Mouse",
    label: "Mouse",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-warthog",
    symbolName: "Warthog",
    label: "Warthog",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-ox",
    symbolName: "Ox",
    label: "Ox",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-hippo",
    symbolName: "Hippo",
    label: "Hippo",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-fox",
    symbolName: "Fox",
    label: "Fox",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-lion",
    symbolName: "Lion",
    label: "Lion",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-squirrel",
    symbolName: "Squirrel",
    label: "Squirrel",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-beaver",
    symbolName: "Beaver",
    label: "Beaver",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-coyote",
    symbolName: "Coyote",
    label: "Coyote",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-monkey",
    symbolName: "Monkey",
    label: "Monkey",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-rhino",
    symbolName: "Rhino",
    label: "Rhino",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-camel",
    symbolName: "Camel",
    label: "Camel",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-monkey-2",
    symbolName: "Monkey 2",
    label: "Monkey 2",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-armadillo",
    symbolName: "Armadillo",
    label: "Armadillo",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-kiwi",
    symbolName: "Kiwi",
    label: "Kiwi",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-calf",
    symbolName: "Calf",
    label: "Calf",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-rabbit",
    symbolName: "Rabbit",
    label: "Rabbit",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-pig",
    symbolName: "Pig",
    label: "Pig",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-otter",
    symbolName: "Otter",
    label: "Otter",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-warthog-2",
    symbolName: "Warthog 2",
    label: "Warthog 2",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-ostrich",
    symbolName: "Ostrich",
    label: "Ostrich",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-lamb",
    symbolName: "Lamb",
    label: "Lamb",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-donkey",
    symbolName: "Donkey",
    label: "Donkey",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-cow",
    symbolName: "Cow",
    label: "Cow",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-dog",
    symbolName: "Dog",
    label: "Dog",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-elephant",
    symbolName: "Elephant",
    label: "Elephant",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-fish",
    symbolName: "Fish",
    label: "Fish",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-mouse-2",
    symbolName: "Mouse 2",
    label: "Mouse 2",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-chicken",
    symbolName: "Chicken",
    label: "Chicken",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-duck",
    symbolName: "Duck",
    label: "Duck",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-parrot",
    symbolName: "Parrot",
    label: "Parrot",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-cat",
    symbolName: "Cat",
    label: "Cat",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-buffalo",
    symbolName: "Buffalo",
    label: "Buffalo",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-mongoose",
    symbolName: "Mongoose",
    label: "Mongoose",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-bird",
    symbolName: "Bird",
    label: "Bird",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-turtle",
    symbolName: "Turtle",
    label: "Turtle",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-horse",
    symbolName: "Horse",
    label: "Horse",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-muskrat",
    symbolName: "Muskrat",
    label: "Muskrat",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-leopard",
    symbolName: "Leopard ",
    label: "Leopard ",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-lion-king",
    symbolName: "Lion King",
    label: "Lion King",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-caribou",
    symbolName: "Caribou",
    label: "Caribou",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-kangaroo",
    symbolName: "Kangaroo",
    label: "Kangaroo",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "animals-elk",
    symbolName: "Elk",
    label: "Elk",
    category: "Animals",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1fbb242c54e4415d9b8e8a343ca7a9d0/data"
  },
  {
    name: "landforms-symbol-1",
    symbolName: "Asset 111pencilcolored",
    label: "Symbol 1",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-2",
    symbolName: "Asset 112pencilcolored",
    label: "Symbol 2",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-3",
    symbolName: "Asset 113pencilcolored",
    label: "Symbol 3",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-4",
    symbolName: "Asset 114pencilcolored",
    label: "Symbol 4",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-5",
    symbolName: "Asset 118pencilcolored",
    label: "Symbol 5",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-6",
    symbolName: "Asset 119pencilcolored",
    label: "Symbol 6",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-7",
    symbolName: "Asset 436pencilcolored",
    label: "Symbol 7",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-8",
    symbolName: "Asset 434pencilcolored",
    label: "Symbol 8",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-9",
    symbolName: "Asset 437pencilcolored",
    label: "Symbol 9",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-10",
    symbolName: "Asset 439pencilcolored",
    label: "Symbol 10",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-11",
    symbolName: "Asset 438pencilcolored",
    label: "Symbol 11",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-12",
    symbolName: "Asset 440pencilcolored",
    label: "Symbol 12",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-13",
    symbolName: "Asset 466pencilcolored",
    label: "Symbol 13",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-14",
    symbolName: "Asset 467pencilcolored",
    label: "Symbol 14",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-15",
    symbolName: "Asset 468pencilcolored",
    label: "Symbol 15",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-16",
    symbolName: "Asset 469pencilcolored",
    label: "Symbol 16",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-17",
    symbolName: "Asset 470pencilcolored",
    label: "Symbol 17",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-18",
    symbolName: "Asset 471pencilcolored",
    label: "Symbol 18",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-19",
    symbolName: "Asset 472pencilcolored",
    label: "Symbol 19",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-20",
    symbolName: "Asset 473pencilcolored",
    label: "Symbol 20",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-21",
    symbolName: "Asset 474pencilcolored",
    label: "Symbol 21",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-22",
    symbolName: "Asset 475pencilcolored",
    label: "Symbol 22",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-23",
    symbolName: "Asset 476pencilcolored",
    label: "Symbol 23",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-24",
    symbolName: "Asset 477pencilcolored",
    label: "Symbol 24",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-25",
    symbolName: "Asset 478pencilcolored",
    label: "Symbol 25",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-26",
    symbolName: "Asset 479pencilcolored",
    label: "Symbol 26",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-27",
    symbolName: "Asset 480pencilcolored",
    label: "Symbol 27",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-28",
    symbolName: "Asset 481pencilcolored",
    label: "Symbol 28",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-29",
    symbolName: "Asset 482pencilcolored",
    label: "Symbol 29",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-30",
    symbolName: "Asset 483pencilcolored",
    label: "Symbol 30",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-31",
    symbolName: "Asset 484pencilcolored",
    label: "Symbol 31",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-32",
    symbolName: "Asset 485pencilcolored",
    label: "Symbol 32",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-33",
    symbolName: "Asset 486pencilcolored",
    label: "Symbol 33",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-34",
    symbolName: "Asset 487pencilcolored",
    label: "Symbol 34",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-35",
    symbolName: "Asset 488pencilcolored",
    label: "Symbol 35",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-36",
    symbolName: "Asset 489pencilcolored",
    label: "Symbol 36",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-37",
    symbolName: "Asset 490pencilcolored",
    label: "Symbol 37",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-38",
    symbolName: "Asset 491pencilcolored",
    label: "Symbol 38",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-39",
    symbolName: "Asset 492pencilcolored",
    label: "Symbol 39",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-40",
    symbolName: "Asset 493pencilcolored",
    label: "Symbol 40",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-41",
    symbolName: "Asset 494pencilcolored",
    label: "Symbol 41",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-42",
    symbolName: "Asset 495pencilcolored",
    label: "Symbol 42",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-43",
    symbolName: "Asset 496pencilcolored",
    label: "Symbol 43",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-44",
    symbolName: "Asset 497pencilcolored",
    label: "Symbol 44",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-45",
    symbolName: "Asset 498pencilcolored",
    label: "Symbol 45",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-46",
    symbolName: "Asset 499pencilcolored",
    label: "Symbol 46",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-47",
    symbolName: "Asset 500pencilcolored",
    label: "Symbol 47",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-48",
    symbolName: "Asset 501pencilcolored",
    label: "Symbol 48",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-49",
    symbolName: "Asset 502pencilcolored",
    label: "Symbol 49",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-50",
    symbolName: "Asset 503pencilcolored",
    label: "Symbol 50",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-51",
    symbolName: "Asset 504pencilcolored",
    label: "Symbol 51",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-52",
    symbolName: "Asset 505pencilcolored",
    label: "Symbol 52",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-53",
    symbolName: "Asset 506pencilcolored",
    label: "Symbol 53",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-54",
    symbolName: "Asset 507pencilcolored",
    label: "Symbol 54",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-55",
    symbolName: "Asset 508pencilcolored",
    label: "Symbol 55",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-56",
    symbolName: "Asset 509pencilcolored",
    label: "Symbol 56",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-57",
    symbolName: "Asset 510pencilcolored",
    label: "Symbol 57",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-58",
    symbolName: "Asset 511pencilcolored",
    label: "Symbol 58",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-59",
    symbolName: "Asset 512pencilcolored",
    label: "Symbol 59",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-60",
    symbolName: "Asset 513pencilcolored",
    label: "Symbol 60",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-61",
    symbolName: "Asset 514pencilcolored",
    label: "Symbol 61",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-62",
    symbolName: "Asset 515pencilcolored",
    label: "Symbol 62",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-63",
    symbolName: "Asset 516pencilcolored",
    label: "Symbol 63",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-64",
    symbolName: "Asset 517pencilcolored",
    label: "Symbol 64",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-65",
    symbolName: "Asset 518pencilcolored",
    label: "Symbol 65",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-66",
    symbolName: "Asset 519pencilcolored",
    label: "Symbol 66",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-67",
    symbolName: "Asset 520pencilcolored",
    label: "Symbol 67",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-68",
    symbolName: "Asset 521pencilcolored",
    label: "Symbol 68",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-69",
    symbolName: "Asset 522pencilcolored",
    label: "Symbol 69",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-70",
    symbolName: "Asset 523pencilcolored",
    label: "Symbol 70",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-71",
    symbolName: "Asset 524pencilcolored",
    label: "Symbol 71",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-72",
    symbolName: "Asset 525pencilcolored",
    label: "Symbol 72",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-73",
    symbolName: "Asset 526pencilcolored",
    label: "Symbol 73",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-74",
    symbolName: "Asset 527pencilcolored",
    label: "Symbol 74",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-75",
    symbolName: "Asset 528pencilcolored",
    label: "Symbol 75",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-76",
    symbolName: "Asset 529pencilcolored",
    label: "Symbol 76",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-77",
    symbolName: "Asset 530pencilcolored",
    label: "Symbol 77",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-78",
    symbolName: "Asset 531pencilcolored",
    label: "Symbol 78",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-79",
    symbolName: "Asset 532pencilcolored",
    label: "Symbol 79",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-80",
    symbolName: "Asset 533pencilcolored",
    label: "Symbol 80",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-81",
    symbolName: "Asset 534pencilcolored",
    label: "Symbol 81",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-82",
    symbolName: "Asset 535pencilcolored",
    label: "Symbol 82",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-83",
    symbolName: "Asset 536pencilcolored",
    label: "Symbol 83",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-84",
    symbolName: "Asset 537pencilcolored",
    label: "Symbol 84",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-85",
    symbolName: "Asset 538pencilcolored",
    label: "Symbol 85",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-86",
    symbolName: "Asset 539pencilcolored",
    label: "Symbol 86",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-87",
    symbolName: "Asset 549pencilcolored",
    label: "Symbol 87",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-88",
    symbolName: "Asset 540pencilcolored",
    label: "Symbol 88",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-89",
    symbolName: "Asset 541pencilcolored",
    label: "Symbol 89",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-90",
    symbolName: "Asset 542pencilcolored",
    label: "Symbol 90",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-91",
    symbolName: "Asset 543pencilcolored",
    label: "Symbol 91",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-92",
    symbolName: "Asset 544pencilcolored",
    label: "Symbol 92",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-93",
    symbolName: "Asset 545pencilcolored",
    label: "Symbol 93",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-94",
    symbolName: "Asset 546pencilcolored",
    label: "Symbol 94",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-95",
    symbolName: "Asset 547pencilcolored",
    label: "Symbol 95",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-96",
    symbolName: "Asset 548pencilcolored",
    label: "Symbol 96",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-97",
    symbolName: "Asset 550pencilcolored",
    label: "Symbol 97",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-98",
    symbolName: "Asset 551pencilcolored",
    label: "Symbol 98",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-99",
    symbolName: "Asset 552pencilcolored",
    label: "Symbol 99",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-100",
    symbolName: "Asset 553pencilcolored",
    label: "Symbol 100",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-101",
    symbolName: "Asset 554pencilcolored",
    label: "Symbol 101",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-102",
    symbolName: "Asset 555pencilcolored",
    label: "Symbol 102",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-103",
    symbolName: "Asset 556pencilcolored",
    label: "Symbol 103",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-104",
    symbolName: "Asset 557pencilcolored",
    label: "Symbol 104",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-105",
    symbolName: "Asset 558pencilcolored",
    label: "Symbol 105",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-106",
    symbolName: "Asset 559pencilcolored",
    label: "Symbol 106",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-107",
    symbolName: "Asset 560pencilcolored",
    label: "Symbol 107",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-108",
    symbolName: "Asset 561pencilcolored",
    label: "Symbol 108",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-109",
    symbolName: "Asset 562pencilcolored",
    label: "Symbol 109",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-110",
    symbolName: "Asset 563pencilcolored",
    label: "Symbol 110",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-111",
    symbolName: "Asset 564pencilcolored",
    label: "Symbol 111",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-112",
    symbolName: "Asset 565pencilcolored",
    label: "Symbol 112",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-113",
    symbolName: "Asset 566pencilcolored",
    label: "Symbol 113",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-114",
    symbolName: "Asset 567pencilcolored",
    label: "Symbol 114",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-115",
    symbolName: "Asset 568pencilcolored",
    label: "Symbol 115",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-116",
    symbolName: "Asset 569pencilcolored",
    label: "Symbol 116",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-117",
    symbolName: "Asset 570pencilcolored",
    label: "Symbol 117",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-118",
    symbolName: "Asset 571pencilcolored",
    label: "Symbol 118",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-119",
    symbolName: "Asset 572pencilcolored",
    label: "Symbol 119",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-120",
    symbolName: "Asset 573pencilcolored",
    label: "Symbol 120",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-121",
    symbolName: "Asset 574pencilcolored",
    label: "Symbol 121",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-122",
    symbolName: "Asset 575pencilcolored",
    label: "Symbol 122",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-123",
    symbolName: "Asset 576pencilcolored",
    label: "Symbol 123",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-124",
    symbolName: "Asset 577pencilcolored",
    label: "Symbol 124",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-125",
    symbolName: "Asset 578pencilcolored",
    label: "Symbol 125",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-126",
    symbolName: "Asset 579pencilcolored",
    label: "Symbol 126",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-127",
    symbolName: "Asset 580pencilcolored",
    label: "Symbol 127",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-128",
    symbolName: "Asset 581pencilcolored",
    label: "Symbol 128",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-129",
    symbolName: "Asset 582pencilcolored",
    label: "Symbol 129",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-130",
    symbolName: "Asset 583pencilcolored",
    label: "Symbol 130",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-131",
    symbolName: "Asset 584pencilcolored",
    label: "Symbol 131",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-132",
    symbolName: "Asset 586pencilcolored",
    label: "Symbol 132",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-133",
    symbolName: "Asset 587pencilcolored",
    label: "Symbol 133",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-134",
    symbolName: "Asset 588pencilcolored",
    label: "Symbol 134",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-135",
    symbolName: "Asset 589pencilcolored",
    label: "Symbol 135",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-136",
    symbolName: "Asset 590pencilcolored",
    label: "Symbol 136",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-137",
    symbolName: "Asset 591pencilcolored",
    label: "Symbol 137",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-138",
    symbolName: "Asset 592pencilcolored",
    label: "Symbol 138",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-139",
    symbolName: "Asset 593pencilcolored",
    label: "Symbol 139",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-140",
    symbolName: "Asset 594pencilcolored",
    label: "Symbol 140",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-141",
    symbolName: "Asset 595pencilcolored",
    label: "Symbol 141",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-142",
    symbolName: "Asset 596pencilcolored",
    label: "Symbol 142",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-143",
    symbolName: "Asset 597pencilcolored",
    label: "Symbol 143",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-144",
    symbolName: "Asset 598pencilcolored",
    label: "Symbol 144",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-145",
    symbolName: "Asset 599pencilcolored",
    label: "Symbol 145",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-146",
    symbolName: "Asset 600pencilcolored",
    label: "Symbol 146",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-147",
    symbolName: "Asset 601pencilcolored",
    label: "Symbol 147",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-148",
    symbolName: "Asset 602pencilcolored",
    label: "Symbol 148",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-149",
    symbolName: "Asset 603pencilcolored",
    label: "Symbol 149",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-150",
    symbolName: "Asset 605pencilcolored",
    label: "Symbol 150",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-151",
    symbolName: "Asset 606pencilcolored",
    label: "Symbol 151",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-152",
    symbolName: "Asset 607pencilcolored",
    label: "Symbol 152",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-153",
    symbolName: "Asset 608pencilcolored",
    label: "Symbol 153",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-154",
    symbolName: "Asset 609pencilcolored",
    label: "Symbol 154",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-155",
    symbolName: "Asset 610pencilcolored",
    label: "Symbol 155",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-156",
    symbolName: "Asset 611pencilcolored",
    label: "Symbol 156",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-157",
    symbolName: "Asset 612pencilcolored",
    label: "Symbol 157",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-158",
    symbolName: "Asset 613pencilcolored",
    label: "Symbol 158",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-159",
    symbolName: "Asset 614pencilcolored",
    label: "Symbol 159",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-160",
    symbolName: "Asset 615pencilcolored",
    label: "Symbol 160",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "landforms-symbol-161",
    symbolName: "Asset 616pencilcolored",
    label: "Symbol 161",
    category: "Landforms",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/45ffe981ef1c4b82933f227c17c5ff80/data"
  },
  {
    name: "trees-symbol-1",
    symbolName: "Asset 100trees",
    label: "Symbol 1",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-2",
    symbolName: "Asset 101trees",
    label: "Symbol 2",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-3",
    symbolName: "Asset 102trees",
    label: "Symbol 3",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-4",
    symbolName: "Asset 103trees",
    label: "Symbol 4",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-5",
    symbolName: "Asset 104trees",
    label: "Symbol 5",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-6",
    symbolName: "Asset 105trees",
    label: "Symbol 6",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-7",
    symbolName: "Asset 106trees",
    label: "Symbol 7",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-8",
    symbolName: "Asset 107trees",
    label: "Symbol 8",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-9",
    symbolName: "Asset 108trees",
    label: "Symbol 9",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-10",
    symbolName: "Asset 109trees",
    label: "Symbol 10",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-11",
    symbolName: "Asset 110trees",
    label: "Symbol 11",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-12",
    symbolName: "Asset 111trees",
    label: "Symbol 12",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-13",
    symbolName: "Asset 112trees",
    label: "Symbol 13",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-14",
    symbolName: "Asset 113trees",
    label: "Symbol 14",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-15",
    symbolName: "Asset 114trees",
    label: "Symbol 15",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-16",
    symbolName: "Asset 115trees",
    label: "Symbol 16",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-17",
    symbolName: "Asset 116trees",
    label: "Symbol 17",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-18",
    symbolName: "Asset 117trees",
    label: "Symbol 18",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-19",
    symbolName: "Asset 118trees",
    label: "Symbol 19",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-20",
    symbolName: "Asset 119trees",
    label: "Symbol 20",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-21",
    symbolName: "Asset 120trees",
    label: "Symbol 21",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-22",
    symbolName: "Asset 121trees",
    label: "Symbol 22",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-23",
    symbolName: "Asset 122trees",
    label: "Symbol 23",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-24",
    symbolName: "Asset 123trees",
    label: "Symbol 24",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-25",
    symbolName: "Asset 124trees",
    label: "Symbol 25",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-26",
    symbolName: "Asset 125trees",
    label: "Symbol 26",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-27",
    symbolName: "Asset 126trees",
    label: "Symbol 27",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-28",
    symbolName: "Asset 12trees",
    label: "Symbol 28",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-29",
    symbolName: "Asset 20trees",
    label: "Symbol 29",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-30",
    symbolName: "Asset 22trees",
    label: "Symbol 30",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-31",
    symbolName: "Asset 35trees",
    label: "Symbol 31",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-32",
    symbolName: "Asset 41trees",
    label: "Symbol 32",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-33",
    symbolName: "Asset 42trees",
    label: "Symbol 33",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-34",
    symbolName: "Asset 43trees",
    label: "Symbol 34",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-35",
    symbolName: "Asset 44trees",
    label: "Symbol 35",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-36",
    symbolName: "Asset 45trees",
    label: "Symbol 36",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-37",
    symbolName: "Asset 46trees",
    label: "Symbol 37",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-38",
    symbolName: "Asset 47trees",
    label: "Symbol 38",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-39",
    symbolName: "Asset 48trees",
    label: "Symbol 39",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-40",
    symbolName: "Asset 57trees",
    label: "Symbol 40",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-41",
    symbolName: "Asset 58trees",
    label: "Symbol 41",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-42",
    symbolName: "Asset 59trees",
    label: "Symbol 42",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-43",
    symbolName: "Asset 60trees",
    label: "Symbol 43",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-44",
    symbolName: "Asset 61trees",
    label: "Symbol 44",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-45",
    symbolName: "Asset 62trees",
    label: "Symbol 45",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-46",
    symbolName: "Asset 63trees",
    label: "Symbol 46",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-47",
    symbolName: "Asset 64trees",
    label: "Symbol 47",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-48",
    symbolName: "Asset 65trees",
    label: "Symbol 48",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-49",
    symbolName: "Asset 66trees",
    label: "Symbol 49",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-50",
    symbolName: "Asset 67trees",
    label: "Symbol 50",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-51",
    symbolName: "Asset 68trees",
    label: "Symbol 51",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-52",
    symbolName: "Asset 69trees",
    label: "Symbol 52",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-53",
    symbolName: "Asset 70trees",
    label: "Symbol 53",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-54",
    symbolName: "Asset 71trees",
    label: "Symbol 54",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-55",
    symbolName: "Asset 73trees",
    label: "Symbol 55",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-56",
    symbolName: "Asset 74trees",
    label: "Symbol 56",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-57",
    symbolName: "Asset 75trees",
    label: "Symbol 57",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-58",
    symbolName: "Asset 76trees",
    label: "Symbol 58",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-59",
    symbolName: "Asset 77trees",
    label: "Symbol 59",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-60",
    symbolName: "Asset 78trees",
    label: "Symbol 60",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-61",
    symbolName: "Asset 79trees",
    label: "Symbol 61",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-62",
    symbolName: "Asset 80trees",
    label: "Symbol 62",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-63",
    symbolName: "Asset 81trees",
    label: "Symbol 63",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-64",
    symbolName: "Asset 82trees",
    label: "Symbol 64",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-65",
    symbolName: "Asset 83trees",
    label: "Symbol 65",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-66",
    symbolName: "Asset 84trees",
    label: "Symbol 66",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-67",
    symbolName: "Asset 85trees",
    label: "Symbol 67",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-68",
    symbolName: "Asset 86trees",
    label: "Symbol 68",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-69",
    symbolName: "Asset 87trees",
    label: "Symbol 69",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-70",
    symbolName: "Asset 88trees",
    label: "Symbol 70",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-71",
    symbolName: "Asset 89trees",
    label: "Symbol 71",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-72",
    symbolName: "Asset 90trees",
    label: "Symbol 72",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-73",
    symbolName: "Asset 91trees",
    label: "Symbol 73",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-74",
    symbolName: "Asset 92trees",
    label: "Symbol 74",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-75",
    symbolName: "Asset 93trees",
    label: "Symbol 75",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-76",
    symbolName: "Asset 94trees",
    label: "Symbol 76",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-77",
    symbolName: "Asset 95trees",
    label: "Symbol 77",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-78",
    symbolName: "Asset 96trees",
    label: "Symbol 78",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-79",
    symbolName: "Asset 97trees",
    label: "Symbol 79",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-80",
    symbolName: "Asset 98trees",
    label: "Symbol 80",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "trees-symbol-81",
    symbolName: "Asset 99trees",
    label: "Symbol 81",
    category: "Trees",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e08037675f354ea1bab42359b9a0c04b/data"
  },
  {
    name: "buildings-apartment-building",
    symbolName: "Asset 10building",
    label: "Apartment building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-modern-building",
    symbolName: "Asset 10building2",
    label: "Modern building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-house",
    symbolName: "Asset 10house",
    label: "House",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-clock-tower",
    symbolName: "Asset 11building2",
    label: "Clock tower",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-simple-house",
    symbolName: "Asset 2house",
    label: "Simple house",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-glass-building",
    symbolName: "Asset 12building",
    label: "Glass building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-complex",
    symbolName: "Asset 12building2",
    label: "Complex",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-simple-building",
    symbolName: "Asset 12house",
    label: "Simple building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-two-towers",
    symbolName: "Asset 13building",
    label: "Two towers",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-classic-apartment",
    symbolName: "Asset 13building2",
    label: "Classic apartment",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-modern-house-circle-window",
    symbolName: "Asset 13house",
    label: "Modern house circle window",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-tower",
    symbolName: "Asset 14building",
    label: "Tower",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-towers",
    symbolName: "Asset 14building2",
    label: "Towers",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-house-with-garage",
    symbolName: "Asset 14house",
    label: "House with garage",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-building-with-flag",
    symbolName: "Asset 15building",
    label: "Building with flag",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-narrow-tower",
    symbolName: "Asset 15building2",
    label: "Narrow tower",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-large-home",
    symbolName: "Asset 15house",
    label: "Large home",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-city-buildings",
    symbolName: "Asset 16building",
    label: "City buildings",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-mid-rise",
    symbolName: "Asset 16building2",
    label: "Mid-rise ",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-mart",
    symbolName: "Asset 16house",
    label: "Mart",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-hospital",
    symbolName: "Asset 17building",
    label: "Hospital",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-multiple-buildings",
    symbolName: "Asset 17building2",
    label: "Multiple buildings",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-mansion",
    symbolName: "Asset 17house",
    label: "Mansion",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-school-tower",
    symbolName: "Asset 18building",
    label: "School tower",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-high-rise",
    symbolName: "Asset 18building2",
    label: "High-rise ",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-townhouse",
    symbolName: "Asset 18house",
    label: "Townhouse",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-glass-tower",
    symbolName: "Asset 19building",
    label: "Glass tower",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-multi-storey-building",
    symbolName: "Asset 19building2",
    label: "Multi-storey building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-restaurant",
    symbolName: "Asset 19house",
    label: "Restaurant",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-cityscape",
    symbolName: "Asset 1building",
    label: "Cityscape",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-education",
    symbolName: "Asset 1building2",
    label: "Education",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-split-level-home",
    symbolName: "Asset 1house",
    label: "Split-level home",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-garage",
    symbolName: "Asset 20building2",
    label: "Garage",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-shopping-center",
    symbolName: "Asset 20house",
    label: "Shopping center",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-city-building",
    symbolName: "Asset 2building",
    label: "City building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-skyscraper",
    symbolName: "Asset 2building2",
    label: "Skyscraper",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-school",
    symbolName: "Asset 3building",
    label: "School",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-building-with-outline",
    symbolName: "Asset 3building2",
    label: "Building with outline",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-modern-house",
    symbolName: "Asset 3house",
    label: "Modern house",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-office-building",
    symbolName: "Asset 4building",
    label: "Office building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-skyline-2",
    symbolName: "Asset 4building2",
    label: "Skyline 2",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-two-storey-house",
    symbolName: "Asset 4house",
    label: "Two storey house",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-campus",
    symbolName: "Asset 5building",
    label: "Campus",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-college",
    symbolName: "Asset 5building2",
    label: "College",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-store",
    symbolName: "Asset 5house",
    label: "Store",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-government-building",
    symbolName: "Asset 6building",
    label: "Government building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-capitol",
    symbolName: "Asset 6building2",
    label: "Capitol",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-shop",
    symbolName: "Asset 6house",
    label: "Shop",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-official-building",
    symbolName: "Asset 7building",
    label: "Official building",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-skyline",
    symbolName: "Asset 7building2",
    label: "Skyline",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-house-with-chimney",
    symbolName: "Asset 7house",
    label: "House with chimney",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-skyline-3",
    symbolName: "Asset 8building",
    label: "Skyline 3",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-bungalow",
    symbolName: "Asset 8house",
    label: "Bungalow",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-high-rise-2",
    symbolName: "Asset 9building",
    label: "High-rise",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-condo",
    symbolName: "Asset 9building2",
    label: "Condo",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "buildings-low-rise",
    symbolName: "Asset 9house",
    label: "Low-rise",
    category: "Buildings",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/fe12ab0e0c834ca2adff4e10f68e1327/data"
  },
  {
    name: "human-landscape-1-symbol-1",
    symbolName: "Asset 9pencil",
    label: "Symbol 1",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-2",
    symbolName: "Asset 10pencil",
    label: "Symbol 2",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-3",
    symbolName: "Asset 11pencil",
    label: "Symbol 3",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-4",
    symbolName: "Asset 12pencil",
    label: "Symbol 4",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-5",
    symbolName: "Asset 13pencil",
    label: "Symbol 5",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-6",
    symbolName: "Asset 14pencil",
    label: "Symbol 6",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-7",
    symbolName: "Asset 15pencil",
    label: "Symbol 7",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-8",
    symbolName: "Asset 16pencil",
    label: "Symbol 8",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-9",
    symbolName: "Asset 17pencil",
    label: "Symbol 9",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-10",
    symbolName: "Asset 18pencil",
    label: "Symbol 10",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-11",
    symbolName: "Asset 19pencil",
    label: "Symbol 11",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-12",
    symbolName: "Asset 1pencil",
    label: "Symbol 12",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-13",
    symbolName: "Asset 20pencil",
    label: "Symbol 13",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-14",
    symbolName: "Asset 21pencil",
    label: "Symbol 14",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-15",
    symbolName: "Asset 22pencil",
    label: "Symbol 15",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-16",
    symbolName: "Asset 23pencil",
    label: "Symbol 16",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-17",
    symbolName: "Asset 24pencil",
    label: "Symbol 17",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-18",
    symbolName: "Asset 25pencil",
    label: "Symbol 18",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-19",
    symbolName: "Asset 26pencil",
    label: "Symbol 19",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-20",
    symbolName: "Asset 27pencil",
    label: "Symbol 20",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-21",
    symbolName: "Asset 28pencil",
    label: "Symbol 21",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-22",
    symbolName: "Asset 29pencil",
    label: "Symbol 22",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-23",
    symbolName: "Asset 2pencil",
    label: "Symbol 23",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-24",
    symbolName: "Asset 30pencil",
    label: "Symbol 24",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-25",
    symbolName: "Asset 31pencil",
    label: "Symbol 25",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-26",
    symbolName: "Asset 32pencil",
    label: "Symbol 26",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-27",
    symbolName: "Asset 33pencil",
    label: "Symbol 27",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-28",
    symbolName: "Asset 34pencil",
    label: "Symbol 28",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-29",
    symbolName: "Asset 35pencil",
    label: "Symbol 29",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-30",
    symbolName: "Asset 36pencil",
    label: "Symbol 30",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-31",
    symbolName: "Asset 37pencil",
    label: "Symbol 31",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-32",
    symbolName: "Asset 38pencil",
    label: "Symbol 32",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-33",
    symbolName: "Asset 39pencil",
    label: "Symbol 33",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-34",
    symbolName: "Asset 3pencil",
    label: "Symbol 34",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-35",
    symbolName: "Asset 40pencil",
    label: "Symbol 35",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-36",
    symbolName: "Asset 41pencil",
    label: "Symbol 36",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-37",
    symbolName: "Asset 42pencil",
    label: "Symbol 37",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-38",
    symbolName: "Asset 43pencil",
    label: "Symbol 38",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-39",
    symbolName: "Asset 44pencil",
    label: "Symbol 39",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-40",
    symbolName: "Asset 45pencil",
    label: "Symbol 40",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-41l",
    symbolName: "Asset 46pencil",
    label: "Symbol 41l",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-42",
    symbolName: "Asset 47pencil",
    label: "Symbol 42",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-43",
    symbolName: "Asset 48pencil",
    label: "Symbol 43",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-44",
    symbolName: "Asset 49pencil",
    label: "Symbol 44",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-45",
    symbolName: "Asset 4pencil",
    label: "Symbol 45",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-46",
    symbolName: "Asset 50pencil",
    label: "Symbol 46",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-47",
    symbolName: "Asset 51pencil",
    label: "Symbol 47",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-48",
    symbolName: "Asset 52pencil",
    label: "Symbol 48",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-49",
    symbolName: "Asset 53pencil",
    label: "Symbol 49",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-50",
    symbolName: "Asset 54pencil",
    label: "Symbol 50",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-51",
    symbolName: "Asset 55pencil",
    label: "Symbol 51",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-52",
    symbolName: "Asset 56pencil",
    label: "Symbol 52",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-53",
    symbolName: "Asset 57pencil",
    label: "Symbol 53",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-54",
    symbolName: "Asset 58pencil",
    label: "Symbol 54",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-55",
    symbolName: "Asset 59pencil",
    label: "Symbol 55",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-56",
    symbolName: "Asset 5pencil",
    label: "Symbol 56",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-57",
    symbolName: "Asset 60pencil",
    label: "Symbol 57",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-58",
    symbolName: "Asset 61pencil",
    label: "Symbol 58",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-59",
    symbolName: "Asset 62pencil",
    label: "Symbol 59",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-60",
    symbolName: "Asset 63pencil",
    label: "Symbol 60",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-61",
    symbolName: "Asset 64pencil",
    label: "Symbol 61",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-62",
    symbolName: "Asset 65pencil",
    label: "Symbol 62",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-63",
    symbolName: "Asset 66pencil",
    label: "Symbol 63",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-64",
    symbolName: "Asset 67pencil",
    label: "Symbol 64",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-65",
    symbolName: "Asset 68pencil",
    label: "Symbol 65",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-66",
    symbolName: "Asset 69pencil",
    label: "Symbol 66",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-67",
    symbolName: "Asset 6pencil",
    label: "Symbol 67",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-68",
    symbolName: "Asset 70pencil",
    label: "Symbol 68",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-69",
    symbolName: "Asset 71pencil",
    label: "Symbol 69",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-70",
    symbolName: "Asset 7pencil",
    label: "Symbol 70",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-71",
    symbolName: "Asset 8pencil",
    label: "Symbol 71",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-72",
    symbolName: "Asset 138",
    label: "Symbol 72",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-73",
    symbolName: "Asset 139",
    label: "Symbol 73",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-74",
    symbolName: "Asset 14",
    label: "Symbol 74",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-75",
    symbolName: "Asset 140",
    label: "Symbol 75",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-76",
    symbolName: "Asset 141",
    label: "Symbol 76",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-77",
    symbolName: "Asset 142",
    label: "Symbol 77",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-78",
    symbolName: "Asset 143",
    label: "Symbol 78",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-79",
    symbolName: "Asset 144",
    label: "Symbol 79",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-80",
    symbolName: "Asset 145",
    label: "Symbol 80",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-81",
    symbolName: "Asset 146",
    label: "Symbol 81",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-82",
    symbolName: "Asset 147",
    label: "Symbol 82",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-83",
    symbolName: "Asset 148",
    label: "Symbol 83",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-84",
    symbolName: "Asset 15",
    label: "Symbol 84",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-85",
    symbolName: "Asset 150",
    label: "Symbol 85",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-86",
    symbolName: "Asset 151",
    label: "Symbol 86",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-87",
    symbolName: "Asset 152",
    label: "Symbol 87",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-88",
    symbolName: "Asset 153",
    label: "Symbol 88",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-89",
    symbolName: "Asset 154",
    label: "Symbol 89",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-90",
    symbolName: "Asset 158",
    label: "Symbol 90",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-91",
    symbolName: "Asset 159",
    label: "Symbol 91",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-92",
    symbolName: "Asset 164",
    label: "Symbol 92",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-93",
    symbolName: "Asset 165",
    label: "Symbol 93",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-94",
    symbolName: "Asset 166",
    label: "Symbol 94",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-95",
    symbolName: "Asset 167",
    label: "Symbol 95",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-96",
    symbolName: "Asset 168",
    label: "Symbol 96",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-97",
    symbolName: "Asset 169",
    label: "Symbol 97",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-98",
    symbolName: "Asset 17",
    label: "Symbol 98",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-99",
    symbolName: "Asset 170",
    label: "Symbol 99",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-100",
    symbolName: "Asset 171",
    label: "Symbol 100",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-101",
    symbolName: "Asset 172",
    label: "Symbol 101",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-102",
    symbolName: "Asset 173",
    label: "Symbol 102",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-103",
    symbolName: "Asset 174",
    label: "Symbol 103",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-104",
    symbolName: "Asset 175",
    label: "Symbol 104",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-105",
    symbolName: "Asset 176",
    label: "Symbol 105",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-106",
    symbolName: "Asset 177",
    label: "Symbol 106",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-107",
    symbolName: "Asset 178",
    label: "Symbol 107",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-108",
    symbolName: "Asset 179",
    label: "Symbol 108",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-109",
    symbolName: "Asset 18",
    label: "Symbol 109",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-110",
    symbolName: "Asset 180",
    label: "Symbol 110",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-111",
    symbolName: "Asset 181",
    label: "Symbol 111",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-112",
    symbolName: "Asset 182",
    label: "Symbol 112",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-113",
    symbolName: "Asset 183",
    label: "Symbol 113",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-114",
    symbolName: "Asset 184",
    label: "Symbol 114",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-115",
    symbolName: "Asset 19",
    label: "Symbol 115",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-116",
    symbolName: "Asset 191",
    label: "Symbol 116",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-117",
    symbolName: "Asset 192",
    label: "Symbol 117",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-118",
    symbolName: "Asset 193",
    label: "Symbol 118",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-119",
    symbolName: "Asset 194",
    label: "Symbol 119",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-1-symbol-120",
    symbolName: "Asset 195",
    label: "Symbol 120",
    category: "Human landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e9cb6bb3273342b69628e0da4be1b60c/data"
  },
  {
    name: "human-landscape-2-symbol-1",
    symbolName: "Asset 100pencilcolored",
    label: "Symbol 1",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-2",
    symbolName: "Asset 101pencilcolored",
    label: "Symbol 2",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-3",
    symbolName: "Asset 103pencilcolored",
    label: "Symbol 3",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-4",
    symbolName: "Asset 104pencilcolored",
    label: "Symbol 4",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-5",
    symbolName: "Asset 105pencilcolored",
    label: "Symbol 5",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-6",
    symbolName: "Asset 107pencilcolored",
    label: "Symbol 6",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-7",
    symbolName: "Asset 108pencilcolored",
    label: "Symbol 7",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-8",
    symbolName: "Asset 109pencilcolored",
    label: "Symbol 8",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-9",
    symbolName: "Asset 120pencilcolored",
    label: "Symbol 9",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-10",
    symbolName: "Asset 127pencilcolored",
    label: "Symbol 10",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-11",
    symbolName: "Asset 219pencilcolored",
    label: "Symbol 11",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-12",
    symbolName: "Asset 220pencilcolored",
    label: "Symbol 12",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-13",
    symbolName: "Asset 221pencilcolored",
    label: "Symbol 13",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-14",
    symbolName: "Asset 222pencilcolored",
    label: "Symbol 14",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-15",
    symbolName: "Asset 223pencilcolored",
    label: "Symbol 15",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-16",
    symbolName: "Asset 224pencilcolored",
    label: "Symbol 16",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-17",
    symbolName: "Asset 225pencilcolored",
    label: "Symbol 17",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-18",
    symbolName: "Asset 226pencilcolored",
    label: "Symbol 18",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-19",
    symbolName: "Asset 227pencilcolored",
    label: "Symbol 19",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-20",
    symbolName: "Asset 228pencilcolored",
    label: "Symbol 20",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-21",
    symbolName: "Asset 229pencilcolored",
    label: "Symbol 21",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-22",
    symbolName: "Asset 230pencilcolored",
    label: "Symbol 22",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-23",
    symbolName: "Asset 231pencilcolored",
    label: "Symbol 23",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-24",
    symbolName: "Asset 232pencilcolored",
    label: "Symbol 24",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-25",
    symbolName: "Asset 233pencilcolored",
    label: "Symbol 25",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-26",
    symbolName: "Asset 234pencilcolored",
    label: "Symbol 26",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-27",
    symbolName: "Asset 235pencilcolored",
    label: "Symbol 27",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-28",
    symbolName: "Asset 236pencilcolored",
    label: "Symbol 28",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-29",
    symbolName: "Asset 237pencilcolored",
    label: "Symbol 29",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-30",
    symbolName: "Asset 238pencilcolored",
    label: "Symbol 30",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-31",
    symbolName: "Asset 239pencilcolored",
    label: "Symbol 31",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-32",
    symbolName: "Asset 99pencilcolored",
    label: "Symbol 32",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-33",
    symbolName: "Asset 98pencilcolored",
    label: "Symbol 33",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-34",
    symbolName: "Asset 96pencilcolored",
    label: "Symbol 34",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-35",
    symbolName: "Asset 95pencilcolored",
    label: "Symbol 35",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-36",
    symbolName: "Asset 94pencilcolored",
    label: "Symbol 36",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-37",
    symbolName: "Asset 93pencilcolored",
    label: "Symbol 37",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-38",
    symbolName: "Asset 92pencilcolored",
    label: "Symbol 38",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-39",
    symbolName: "Asset 91pencilcolored",
    label: "Symbol 39",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-40",
    symbolName: "Asset 90pencilcolored",
    label: "Symbol 40",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-41",
    symbolName: "Asset 89pencilcolored",
    label: "Symbol 41",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-42",
    symbolName: "Asset 88pencilcolored",
    label: "Symbol 42",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-43",
    symbolName: "Asset 72pencilcolored",
    label: "Symbol 43",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-44",
    symbolName: "Asset 71pencilcolored",
    label: "Symbol 44",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-45",
    symbolName: "Asset 70pencilcolored",
    label: "Symbol 45",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-46",
    symbolName: "Asset 69pencilcolored",
    label: "Symbol 46",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-47",
    symbolName: "Asset 68pencilcolored",
    label: "Symbol 47",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-48",
    symbolName: "Asset 67pencilcolored",
    label: "Symbol 48",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-49",
    symbolName: "Asset 66pencilcolored",
    label: "Symbol 49",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-50",
    symbolName: "Asset 64pencilcolored",
    label: "Symbol 50",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-51",
    symbolName: "Asset 63pencilcolored",
    label: "Symbol 51",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-52",
    symbolName: "Asset 62pencilcolored",
    label: "Symbol 52",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-53",
    symbolName: "Asset 409pencilcolored",
    label: "Symbol 53",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-54",
    symbolName: "Asset 410pencilcolored",
    label: "Symbol 54",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-55",
    symbolName: "Asset 411pencilcolored",
    label: "Symbol 55",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-56",
    symbolName: "Asset 412pencilcolored",
    label: "Symbol 56",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-57",
    symbolName: "Asset 413pencilcolored",
    label: "Symbol 57",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-58",
    symbolName: "Asset 414pencilcolored",
    label: "Symbol 58",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-59",
    symbolName: "Asset 415pencilcolored",
    label: "Symbol 59",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-60",
    symbolName: "Asset 416pencilcolored",
    label: "Symbol 60",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-61",
    symbolName: "Asset 417pencilcolored",
    label: "Symbol 61",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-62",
    symbolName: "Asset 418pencilcolored",
    label: "Symbol 62",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-63",
    symbolName: "Asset 419pencilcolored",
    label: "Symbol 63",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-64",
    symbolName: "Asset 420pencilcolored",
    label: "Symbol 64",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-65",
    symbolName: "Asset 421pencilcolored",
    label: "Symbol 65",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-66",
    symbolName: "Asset 422pencilcolored",
    label: "Symbol 66",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-67",
    symbolName: "Asset 423pencilcolored",
    label: "Symbol 67",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-68",
    symbolName: "Asset 424pencilcolored",
    label: "Symbol 68",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-69",
    symbolName: "Asset 425pencilcolored",
    label: "Symbol 69",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-70",
    symbolName: "Asset 426pencilcolored",
    label: "Symbol 70",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-71",
    symbolName: "Asset 427pencilcolored",
    label: "Symbol 71",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-72",
    symbolName: "Asset 428pencilcolored",
    label: "Symbol 72",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-73",
    symbolName: "Asset 429pencilcolored",
    label: "Symbol 73",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-74",
    symbolName: "Asset 42pencilcolored",
    label: "Symbol 74",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-75",
    symbolName: "Asset 430pencilcolored",
    label: "Symbol 75",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-76",
    symbolName: "Asset 431pencilcolored",
    label: "Symbol 76",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-77",
    symbolName: "Asset 432pencilcolored",
    label: "Symbol 77",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-78",
    symbolName: "Asset 433pencilcolored",
    label: "Symbol 78",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-79",
    symbolName: "Asset 43pencilcolored",
    label: "Symbol 79",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-80",
    symbolName: "Asset 44pencilcolored",
    label: "Symbol 80",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-81",
    symbolName: "Asset 45pencilcolored",
    label: "Symbol 81",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-82",
    symbolName: "Asset 46pencilcolored",
    label: "Symbol 82",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-83",
    symbolName: "Asset 47pencilcolored",
    label: "Symbol 83",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-84",
    symbolName: "Asset 51pencilcolored",
    label: "Symbol 84",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-85",
    symbolName: "Asset 52pencilcolored",
    label: "Symbol 85",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-86",
    symbolName: "Asset 54pencilcolored",
    label: "Symbol 86",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-87",
    symbolName: "Asset 55pencilcolored",
    label: "Symbol 87",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "human-landscape-2-symbol-88",
    symbolName: "Asset 57pencilcolored",
    label: "Symbol 88",
    category: "Human landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/8560ce55ee7547a0b6b1d59df76d3f6b/data"
  },
  {
    name: "natural-landscape-1-symbol-1",
    symbolName: "Asset 1",
    label: "Symbol 1",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-2",
    symbolName: "Asset 10",
    label: "Symbol 2",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-3",
    symbolName: "Asset 100",
    label: "Symbol 3",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-4",
    symbolName: "Asset 102",
    label: "Symbol 4",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-5",
    symbolName: "Asset 103",
    label: "Symbol 5",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-6",
    symbolName: "Asset 104",
    label: "Symbol 6",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-7",
    symbolName: "Asset 106",
    label: "Symbol 7",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-8",
    symbolName: "Asset 108",
    label: "Symbol 8",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-9",
    symbolName: "Asset 109",
    label: "Symbol 9",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-10",
    symbolName: "Asset 11",
    label: "Symbol 10",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-11",
    symbolName: "Asset 110",
    label: "Symbol 11",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-12",
    symbolName: "Asset 111",
    label: "Symbol 12",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-13",
    symbolName: "Asset 112",
    label: "Symbol 13",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-14",
    symbolName: "Asset 113",
    label: "Symbol 14",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-15",
    symbolName: "Asset 114",
    label: "Symbol 15",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-16",
    symbolName: "Asset 116",
    label: "Symbol 16",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-17",
    symbolName: "Asset 117",
    label: "Symbol 17",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-18",
    symbolName: "Asset 118",
    label: "Symbol 18",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-19",
    symbolName: "Asset 119",
    label: "Symbol 19",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-20",
    symbolName: "Asset 12",
    label: "Symbol 20",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-21",
    symbolName: "Asset 120",
    label: "Symbol 21",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-22",
    symbolName: "Asset 121",
    label: "Symbol 22",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-23",
    symbolName: "Asset 122",
    label: "Symbol 23",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-24",
    symbolName: "Asset 123",
    label: "Symbol 24",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-25",
    symbolName: "Asset 124",
    label: "Symbol 25",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-26",
    symbolName: "Asset 125",
    label: "Symbol 26",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-27",
    symbolName: "Asset 127",
    label: "Symbol 27",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-28",
    symbolName: "Asset 128",
    label: "Symbol 28",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-29",
    symbolName: "Asset 129",
    label: "Symbol 29",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-30",
    symbolName: "Asset 13",
    label: "Symbol 30",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-31",
    symbolName: "Asset 130",
    label: "Symbol 31",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-32",
    symbolName: "Asset 131",
    label: "Symbol 32",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-33",
    symbolName: "Asset 132",
    label: "Symbol 33",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-34",
    symbolName: "Asset 133",
    label: "Symbol 34",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-35",
    symbolName: "Asset 134",
    label: "Symbol 35",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-36",
    symbolName: "Asset 135",
    label: "Symbol 36",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-37",
    symbolName: "Asset 137",
    label: "Symbol 37",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-38",
    symbolName: "Asset 16",
    label: "Symbol 38",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-39",
    symbolName: "Asset 160",
    label: "Symbol 39",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-40",
    symbolName: "Asset 161",
    label: "Symbol 40",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-41",
    symbolName: "Asset 162",
    label: "Symbol 41",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-42",
    symbolName: "Asset 163",
    label: "Symbol 42",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-43",
    symbolName: "Asset 2",
    label: "Symbol 43",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-44",
    symbolName: "Asset 20",
    label: "Symbol 44",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-45",
    symbolName: "Asset 21",
    label: "Symbol 45",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-46",
    symbolName: "Asset 22",
    label: "Symbol 46",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-47",
    symbolName: "Asset 23",
    label: "Symbol 47",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-48",
    symbolName: "Asset 24",
    label: "Symbol 48",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-49",
    symbolName: "Asset 25",
    label: "Symbol 49",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-50",
    symbolName: "Asset 26",
    label: "Symbol 50",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-51",
    symbolName: "Asset 27",
    label: "Symbol 51",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-52",
    symbolName: "Asset 28",
    label: "Symbol 52",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-53",
    symbolName: "Asset 29",
    label: "Symbol 53",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-54",
    symbolName: "Asset 3",
    label: "Symbol 54",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-55",
    symbolName: "Asset 31",
    label: "Symbol 55",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-56",
    symbolName: "Asset 32",
    label: "Symbol 56",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-57",
    symbolName: "Asset 33",
    label: "Symbol 57",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-58",
    symbolName: "Asset 34",
    label: "Symbol 58",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-59",
    symbolName: "Asset 35",
    label: "Symbol 59",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-60",
    symbolName: "Asset 36",
    label: "Symbol 60",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-61",
    symbolName: "Asset 37",
    label: "Symbol 61",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-62",
    symbolName: "Asset 38",
    label: "Symbol 62",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-63",
    symbolName: "Asset 39",
    label: "Symbol 63",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-64",
    symbolName: "Asset 4",
    label: "Symbol 64",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-65",
    symbolName: "Asset 40",
    label: "Symbol 65",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-66",
    symbolName: "Asset 41",
    label: "Symbol 66",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-67",
    symbolName: "Asset 42",
    label: "Symbol 67",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-68",
    symbolName: "Asset 43",
    label: "Symbol 68",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-69",
    symbolName: "Asset 44",
    label: "Symbol 69",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-70",
    symbolName: "Asset 45",
    label: "Symbol 70",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-71",
    symbolName: "Asset 46",
    label: "Symbol 71",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-72",
    symbolName: "Asset 47",
    label: "Symbol 72",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-73",
    symbolName: "Asset 48",
    label: "Symbol 73",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-74",
    symbolName: "Asset 5",
    label: "Symbol 74",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-75",
    symbolName: "Asset 52",
    label: "Symbol 75",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-76",
    symbolName: "Asset 53",
    label: "Symbol 76",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-77",
    symbolName: "Asset 54",
    label: "Symbol 77",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-78",
    symbolName: "Asset 55",
    label: "Symbol 78",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-79",
    symbolName: "Asset 56",
    label: "Symbol 79",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-80",
    symbolName: "Asset 57",
    label: "Symbol 80",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-81",
    symbolName: "Asset 58",
    label: "Symbol 81",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-82",
    symbolName: "Asset 59",
    label: "Symbol 82",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-83",
    symbolName: "Asset 6",
    label: "Symbol 83",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-84",
    symbolName: "Asset 60",
    label: "Symbol 84",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-85",
    symbolName: "Asset 61",
    label: "Symbol 85",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-86",
    symbolName: "Asset 62",
    label: "Symbol 86",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-87",
    symbolName: "Asset 63",
    label: "Symbol 87",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-88",
    symbolName: "Asset 64",
    label: "Symbol 88",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-89",
    symbolName: "Asset 65",
    label: "Symbol 89",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-90",
    symbolName: "Asset 66",
    label: "Symbol 90",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-91",
    symbolName: "Asset 67",
    label: "Symbol 91",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-92",
    symbolName: "Asset 68",
    label: "Symbol 92",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-93",
    symbolName: "Asset 69",
    label: "Symbol 93",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-94",
    symbolName: "Asset 7",
    label: "Symbol 94",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-95",
    symbolName: "Asset 70",
    label: "Symbol 95",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-96",
    symbolName: "Asset 71",
    label: "Symbol 96",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-97",
    symbolName: "Asset 72",
    label: "Symbol 97",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-98",
    symbolName: "Asset 73",
    label: "Symbol 98",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-99",
    symbolName: "Asset 74",
    label: "Symbol 99",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-100",
    symbolName: "Asset 75",
    label: "Symbol 100",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-101",
    symbolName: "Asset 76",
    label: "Symbol 101",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-102",
    symbolName: "Asset 77",
    label: "Symbol 102",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-103",
    symbolName: "Asset 78",
    label: "Symbol 103",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-104",
    symbolName: "Asset 79",
    label: "Symbol 104",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-105",
    symbolName: "Asset 8",
    label: "Symbol 105",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-106",
    symbolName: "Asset 80",
    label: "Symbol 106",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-107",
    symbolName: "Asset 81",
    label: "Symbol 107",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-108",
    symbolName: "Asset 82",
    label: "Symbol 108",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-109",
    symbolName: "Asset 83",
    label: "Symbol 109",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-110",
    symbolName: "Asset 85",
    label: "Symbol 110",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-111",
    symbolName: "Asset 86",
    label: "Symbol 111",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-112",
    symbolName: "Asset 87",
    label: "Symbol 112",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-113",
    symbolName: "Asset 88",
    label: "Symbol 113",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-114",
    symbolName: "Asset 89",
    label: "Symbol 114",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-115",
    symbolName: "Asset 9",
    label: "Symbol 115",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-116",
    symbolName: "Asset 90",
    label: "Symbol 116",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-117",
    symbolName: "Asset 91",
    label: "Symbol 117",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-118",
    symbolName: "Asset 92",
    label: "Symbol 118",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-119",
    symbolName: "Asset 93",
    label: "Symbol 119",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-120",
    symbolName: "Asset 94",
    label: "Symbol 120",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-121",
    symbolName: "Asset 95",
    label: "Symbol 121",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-122",
    symbolName: "Asset 96",
    label: "Symbol 122",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-123",
    symbolName: "Asset 97",
    label: "Symbol 123",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-124",
    symbolName: "Asset 98",
    label: "Symbol 124",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-1-symbol-125",
    symbolName: "Asset 99",
    label: "Symbol 125",
    category: "Natural landscape 1",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/bedfab602abc49e0800482182f0c3e19/data"
  },
  {
    name: "natural-landscape-2-symbol-1",
    symbolName: "Asset 130pencilcolored",
    label: "Symbol 1",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-2",
    symbolName: "Asset 131pencilcolored",
    label: "Symbol 2",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-3",
    symbolName: "Asset 132pencilcolored",
    label: "Symbol 3",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-4",
    symbolName: "Asset 133pencilcolored",
    label: "Symbol 4",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-5",
    symbolName: "Asset 134pencilcolored",
    label: "Symbol 5",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-6",
    symbolName: "Asset 135pencilcolored",
    label: "Symbol 6",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-7",
    symbolName: "Asset 136pencilcolored",
    label: "Symbol 7",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-8",
    symbolName: "Asset 137pencilcolored",
    label: "Symbol 8",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-9",
    symbolName: "Asset 138pencilcolored",
    label: "Symbol 9",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-10",
    symbolName: "Asset 139pencilcolored",
    label: "Symbol 10",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-11",
    symbolName: "Asset 140pencilcolored",
    label: "Symbol 11",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-12",
    symbolName: "Asset 141pencilcolored",
    label: "Symbol 12",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-13",
    symbolName: "Asset 142pencilcolored",
    label: "Symbol 13",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-14",
    symbolName: "Asset 143pencilcolored",
    label: "Symbol 14",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-15",
    symbolName: "Asset 144pencilcolored",
    label: "Symbol 15",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-16",
    symbolName: "Asset 145pencilcolored",
    label: "Symbol 16",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-17",
    symbolName: "Asset 146pencilcolored",
    label: "Symbol 17",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-18",
    symbolName: "Asset 147pencilcolored",
    label: "Symbol 18",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-19",
    symbolName: "Asset 148pencilcolored",
    label: "Symbol 19",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-20",
    symbolName: "Asset 149pencilcolored",
    label: "Symbol 20",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-21",
    symbolName: "Asset 150pencilcolored",
    label: "Symbol 21",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-23",
    symbolName: "Asset 151pencilcolored",
    label: "Symbol 23",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-24",
    symbolName: "Asset 152pencilcolored",
    label: "Symbol 24",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-25",
    symbolName: "Asset 153pencilcolored",
    label: "Symbol 25",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-26",
    symbolName: "Asset 154pencilcolored",
    label: "Symbol 26",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-27",
    symbolName: "Asset 155pencilcolored",
    label: "Symbol 27",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-28",
    symbolName: "Asset 156pencilcolored",
    label: "Symbol 28",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-29",
    symbolName: "Asset 157pencilcolored",
    label: "Symbol 29",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-30",
    symbolName: "Asset 158pencilcolored",
    label: "Symbol 30",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-31",
    symbolName: "Asset 159pencilcolored",
    label: "Symbol 31",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-32",
    symbolName: "Asset 160pencilcolored",
    label: "Symbol 32",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-33",
    symbolName: "Asset 161pencilcolored",
    label: "Symbol 33",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-34",
    symbolName: "Asset 162pencilcolored",
    label: "Symbol 34",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-35",
    symbolName: "Asset 163pencilcolored",
    label: "Symbol 35",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-36",
    symbolName: "Asset 164pencilcolored",
    label: "Symbol 36",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-37",
    symbolName: "Asset 200pencilcolored",
    label: "Symbol 37",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-38",
    symbolName: "Asset 201pencilcolored",
    label: "Symbol 38",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-39",
    symbolName: "Asset 202pencilcolored",
    label: "Symbol 39",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-40",
    symbolName: "Asset 203pencilcolored",
    label: "Symbol 40",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-41",
    symbolName: "Asset 204pencilcolored",
    label: "Symbol 41",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-42",
    symbolName: "Asset 205pencilcolored",
    label: "Symbol 42",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-43",
    symbolName: "Asset 207pencilcolored",
    label: "Symbol 43",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-44",
    symbolName: "Asset 208pencilcolored",
    label: "Symbol 44",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-45",
    symbolName: "Asset 209pencilcolored",
    label: "Symbol 45",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-46",
    symbolName: "Asset 210pencilcolored",
    label: "Symbol 46",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-47",
    symbolName: "Asset 211pencilcolored",
    label: "Symbol 47",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-48",
    symbolName: "Asset 212pencilcolored",
    label: "Symbol 48",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-49",
    symbolName: "Asset 213pencilcolored",
    label: "Symbol 49",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-50",
    symbolName: "Asset 214pencilcolored",
    label: "Symbol 50",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-51",
    symbolName: "Asset 215pencilcolored",
    label: "Symbol 51",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-52",
    symbolName: "Asset 216pencilcolored",
    label: "Symbol 52",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-53",
    symbolName: "Asset 217pencilcolored",
    label: "Symbol 53",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-54",
    symbolName: "Asset 218pencilcolored",
    label: "Symbol 54",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-55",
    symbolName: "Asset 240pencilcolored",
    label: "Symbol 55",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-56",
    symbolName: "Asset 241pencilcolored",
    label: "Symbol 56",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-57",
    symbolName: "Asset 242pencilcolored",
    label: "Symbol 57",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-58",
    symbolName: "Asset 243pencilcolored",
    label: "Symbol 58",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-59",
    symbolName: "Asset 244pencilcolored",
    label: "Symbol 59",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-60",
    symbolName: "Asset 245pencilcolored",
    label: "Symbol 60",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-61",
    symbolName: "Asset 246pencilcolored",
    label: "Symbol 61",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-62",
    symbolName: "Asset 247pencilcolored",
    label: "Symbol 62",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-63",
    symbolName: "Asset 248pencilcolored",
    label: "Symbol 63",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-64",
    symbolName: "Asset 249pencilcolored",
    label: "Symbol 64",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-65",
    symbolName: "Asset 250pencilcolored",
    label: "Symbol 65",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-66",
    symbolName: "Asset 251pencilcolored",
    label: "Symbol 66",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-67",
    symbolName: "Asset 252pencilcolored",
    label: "Symbol 67",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-68",
    symbolName: "Asset 253pencilcolored",
    label: "Symbol 68",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-69",
    symbolName: "Asset 254pencilcolored",
    label: "Symbol 69",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-70",
    symbolName: "Asset 255pencilcolored",
    label: "Symbol 70",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-71",
    symbolName: "Asset 256pencilcolored",
    label: "Symbol 71",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-72",
    symbolName: "Asset 257pencilcolored",
    label: "Symbol 72",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-73",
    symbolName: "Asset 258pencilcolored",
    label: "Symbol 73",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-74",
    symbolName: "Asset 259pencilcolored",
    label: "Symbol 74",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-75",
    symbolName: "Asset 260pencilcolored",
    label: "Symbol 75",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-76",
    symbolName: "Asset 261pencilcolored",
    label: "Symbol 76",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-77",
    symbolName: "Asset 262pencilcolored",
    label: "Symbol 77",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-78",
    symbolName: "Asset 263pencilcolored",
    label: "Symbol 78",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-79",
    symbolName: "Asset 264pencilcolored",
    label: "Symbol 79",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-80",
    symbolName: "Asset 265pencilcolored",
    label: "Symbol 80",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-81",
    symbolName: "Asset 266pencilcolored",
    label: "Symbol 81",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-82",
    symbolName: "Asset 267pencilcolored",
    label: "Symbol 82",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-83",
    symbolName: "Asset 268pencilcolored",
    label: "Symbol 83",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-84",
    symbolName: "Asset 269pencilcolored",
    label: "Symbol 84",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-85",
    symbolName: "Asset 270pencilcolored",
    label: "Symbol 85",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-86",
    symbolName: "Asset 271pencilcolored",
    label: "Symbol 86",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-87",
    symbolName: "Asset 272pencilcolored",
    label: "Symbol 87",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-88",
    symbolName: "Asset 273pencilcolored",
    label: "Symbol 88",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-89",
    symbolName: "Asset 274pencilcolored",
    label: "Symbol 89",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-90",
    symbolName: "Asset 275pencilcolored",
    label: "Symbol 90",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-91",
    symbolName: "Asset 276pencilcolored",
    label: "Symbol 91",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-92",
    symbolName: "Asset 277pencilcolored",
    label: "Symbol 92",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-93",
    symbolName: "Asset 278pencilcolored",
    label: "Symbol 93",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-94",
    symbolName: "Asset 279pencilcolored",
    label: "Symbol 94",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-95",
    symbolName: "Asset 280pencilcolored",
    label: "Symbol 95",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-96",
    symbolName: "Asset 281pencilcolored",
    label: "Symbol 96",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-97",
    symbolName: "Asset 282pencilcolored",
    label: "Symbol 97",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-98",
    symbolName: "Asset 283pencilcolored",
    label: "Symbol 98",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-99",
    symbolName: "Asset 284pencilcolored",
    label: "Symbol 99",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-100",
    symbolName: "Asset 285pencilcolored",
    label: "Symbol 100",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-101",
    symbolName: "Asset 286pencilcolored",
    label: "Symbol 101",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-102",
    symbolName: "Asset 287pencilcolored",
    label: "Symbol 102",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-103",
    symbolName: "Asset 288pencilcolored",
    label: "Symbol 103",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-104",
    symbolName: "Asset 289pencilcolored",
    label: "Symbol 104",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-105",
    symbolName: "Asset 290pencilcolored",
    label: "Symbol 105",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-106",
    symbolName: "Asset 291pencilcolored",
    label: "Symbol 106",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-107",
    symbolName: "Asset 292pencilcolored",
    label: "Symbol 107",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-108",
    symbolName: "Asset 293pencilcolored",
    label: "Symbol 108",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-109",
    symbolName: "Asset 295pencilcolored",
    label: "Symbol 109",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-110",
    symbolName: "Asset 296pencilcolored",
    label: "Symbol 110",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-111",
    symbolName: "Asset 301pencilcolored",
    label: "Symbol 111",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-112",
    symbolName: "Asset 302pencilcolored",
    label: "Symbol 112",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-113",
    symbolName: "Asset 303pencilcolored",
    label: "Symbol 113",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-114",
    symbolName: "Asset 304pencilcolored",
    label: "Symbol 114",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-115",
    symbolName: "Asset 305pencilcolored",
    label: "Symbol 115",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-116",
    symbolName: "Asset 306pencilcolored",
    label: "Symbol 116",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-117",
    symbolName: "Asset 308pencilcolored",
    label: "Symbol 117",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-118",
    symbolName: "Asset 310pencilcolored",
    label: "Symbol 118",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-119",
    symbolName: "Asset 311pencilcolored",
    label: "Symbol 119",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-120",
    symbolName: "Asset 312pencilcolored",
    label: "Symbol 120",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-121",
    symbolName: "Asset 313pencilcolored",
    label: "Symbol 121",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-122",
    symbolName: "Asset 314pencilcolored",
    label: "Symbol 122",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-123",
    symbolName: "Asset 315pencilcolored",
    label: "Symbol 123",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-124",
    symbolName: "Asset 321pencilcolored",
    label: "Symbol 124",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-125",
    symbolName: "Asset 322pencilcolored",
    label: "Symbol 125",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-126",
    symbolName: "Asset 323pencilcolored",
    label: "Symbol 126",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-127",
    symbolName: "Asset 324pencilcolored",
    label: "Symbol 127",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-128",
    symbolName: "Asset 325pencilcolored",
    label: "Symbol 128",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-129",
    symbolName: "Asset 326pencilcolored",
    label: "Symbol 129",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-130",
    symbolName: "Asset 327pencilcolored",
    label: "Symbol 130",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-131",
    symbolName: "Asset 328pencilcolored",
    label: "Symbol 131",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-132",
    symbolName: "Asset 329pencilcolored",
    label: "Symbol 132",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-133",
    symbolName: "Asset 330pencilcolored",
    label: "Symbol 133",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-134",
    symbolName: "Asset 331pencilcolored",
    label: "Symbol 134",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-135",
    symbolName: "Asset 332pencilcolored",
    label: "Symbol 135",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-136",
    symbolName: "Asset 333pencilcolored",
    label: "Symbol 136",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-137",
    symbolName: "Asset 334pencilcolored",
    label: "Symbol 137",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-138",
    symbolName: "Asset 335pencilcolored",
    label: "Symbol 138",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-139",
    symbolName: "Asset 336pencilcolored",
    label: "Symbol 139",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-140",
    symbolName: "Asset 337pencilcolored",
    label: "Symbol 140",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-141",
    symbolName: "Asset 338pencilcolored",
    label: "Symbol 141",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-142",
    symbolName: "Asset 339pencilcolored",
    label: "Symbol 142",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-143",
    symbolName: "Asset 340pencilcolored",
    label: "Symbol 143",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-144",
    symbolName: "Asset 341pencilcolored",
    label: "Symbol 144",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-145",
    symbolName: "Asset 342pencilcolored",
    label: "Symbol 145",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-146",
    symbolName: "Asset 343pencilcolored",
    label: "Symbol 146",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-147",
    symbolName: "Asset 344pencilcolored",
    label: "Symbol 147",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-148",
    symbolName: "Asset 345pencilcolored",
    label: "Symbol 148",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-149",
    symbolName: "Asset 346pencilcolored",
    label: "Symbol 149",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-150",
    symbolName: "Asset 347pencilcolored",
    label: "Symbol 150",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-151",
    symbolName: "Asset 348pencilcolored",
    label: "Symbol 151",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-152",
    symbolName: "Asset 349pencilcolored",
    label: "Symbol 152",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-153",
    symbolName: "Asset 350pencilcolored",
    label: "Symbol 153",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-154",
    symbolName: "Asset 351pencilcolored",
    label: "Symbol 154",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-155",
    symbolName: "Asset 352pencilcolored",
    label: "Symbol 155",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-156",
    symbolName: "Asset 353pencilcolored",
    label: "Symbol 156",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-157",
    symbolName: "Asset 354pencilcolored",
    label: "Symbol 157",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-158",
    symbolName: "Asset 355pencilcolored",
    label: "Symbol 158",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-159",
    symbolName: "Asset 359pencilcolored",
    label: "Symbol 159",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-160",
    symbolName: "Asset 361pencilcolored",
    label: "Symbol 160",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-161",
    symbolName: "Asset 375pencilcolored",
    label: "Symbol 161",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-162",
    symbolName: "Asset 383pencilcolored",
    label: "Symbol 162",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-163",
    symbolName: "Asset 384pencilcolored",
    label: "Symbol 163",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-164",
    symbolName: "Asset 385pencilcolored",
    label: "Symbol 164",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-165",
    symbolName: "Asset 386pencilcolored",
    label: "Symbol 165",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-166",
    symbolName: "Asset 387pencilcolored",
    label: "Symbol 166",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-167",
    symbolName: "Asset 388pencilcolored",
    label: "Symbol 167",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-168",
    symbolName: "Asset 389pencilcolored",
    label: "Symbol 168",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-169",
    symbolName: "Asset 390pencilcolored",
    label: "Symbol 169",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-170",
    symbolName: "Asset 391pencilcolored",
    label: "Symbol 170",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-171",
    symbolName: "Asset 392pencilcolored",
    label: "Symbol 171",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-172",
    symbolName: "Asset 393pencilcolored",
    label: "Symbol 172",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-173",
    symbolName: "Asset 394pencilcolored",
    label: "Symbol 173",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-174",
    symbolName: "Asset 395pencilcolored",
    label: "Symbol 174",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-175",
    symbolName: "Asset 396pencilcolored",
    label: "Symbol 175",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-176",
    symbolName: "Asset 397pencilcolored",
    label: "Symbol 176",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-177",
    symbolName: "Asset 398pencilcolored",
    label: "Symbol 177",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-178",
    symbolName: "Asset 399pencilcolored",
    label: "Symbol 178",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-179",
    symbolName: "Asset 400pencilcolored",
    label: "Symbol 179",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-180",
    symbolName: "Asset 401pencilcolored",
    label: "Symbol 180",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-181",
    symbolName: "Asset 402pencilcolored",
    label: "Symbol 181",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-182",
    symbolName: "Asset 404pencilcolored",
    label: "Symbol 182",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-183",
    symbolName: "Asset 405pencilcolored",
    label: "Symbol 183",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-184",
    symbolName: "Asset 406pencilcolored",
    label: "Symbol 184",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-185",
    symbolName: "Asset 407pencilcolored",
    label: "Symbol 185",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-186",
    symbolName: "Asset 408pencilcolored",
    label: "Symbol 186",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-187",
    symbolName: "Asset 441pencilcolored",
    label: "Symbol 187",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-188",
    symbolName: "Asset 442pencilcolored",
    label: "Symbol 188",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-189",
    symbolName: "Asset 443pencilcolored",
    label: "Symbol 189",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-190",
    symbolName: "Asset 435pencilcolored",
    label: "Symbol 190",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-191",
    symbolName: "Asset 444pencilcolored",
    label: "Symbol 191",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-192",
    symbolName: "Asset 445pencilcolored",
    label: "Symbol 192",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-193",
    symbolName: "Asset 447pencilcolored",
    label: "Symbol 193",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-194",
    symbolName: "Asset 448pencilcolored",
    label: "Symbol 194",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-195",
    symbolName: "Asset 446pencilcolored",
    label: "Symbol 195",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-196",
    symbolName: "Asset 449pencilcolored",
    label: "Symbol 196",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-197",
    symbolName: "Asset 450pencilcolored",
    label: "Symbol 197",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-198",
    symbolName: "Asset 451pencilcolored",
    label: "Symbol 198",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-199",
    symbolName: "Asset 452pencilcolored",
    label: "Symbol 199",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-200",
    symbolName: "Asset 454pencilcolored",
    label: "Symbol 200",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-201",
    symbolName: "Asset 453pencilcolored",
    label: "Symbol 201",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-202",
    symbolName: "Asset 455pencilcolored",
    label: "Symbol 202",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-203",
    symbolName: "Asset 456pencilcolored",
    label: "Symbol 203",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-204",
    symbolName: "Asset 457pencilcolored",
    label: "Symbol 204",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-205",
    symbolName: "Asset 458pencilcolored",
    label: "Symbol 205",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-206",
    symbolName: "Asset 460pencilcolored",
    label: "Symbol 206",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-207",
    symbolName: "Asset 461pencilcolored",
    label: "Symbol 207",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-208",
    symbolName: "Asset 462pencilcolored",
    label: "Symbol 208",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-209",
    symbolName: "Asset 463pencilcolored",
    label: "Symbol 209",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-210",
    symbolName: "Asset 464pencilcolored",
    label: "Symbol 210",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "natural-landscape-2-symbol-211",
    symbolName: "Asset 465pencilcolored",
    label: "Symbol 211",
    category: "Natural landscape 2",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/f2aaebea3bf04c65ba97f7f5c020ce3b/data"
  },
  {
    name: "arrows-arrow-1",
    symbolName: "Arrow 1_Arrows_3",
    label: "Arrow 1",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-2",
    symbolName: "Arrow 2_Arrows_3",
    label: "Arrow 2",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-3",
    symbolName: "Arrow 3_Arrows_3",
    label: "Arrow 3",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-4",
    symbolName: "Arrow 4_Arrows_3",
    label: "Arrow 4",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-5",
    symbolName: "Arrow 5_Arrows_3",
    label: "Arrow 5",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-6",
    symbolName: "Arrow 6_Arrows_3",
    label: "Arrow 6",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-7",
    symbolName: "Arrow 7_Arrows_3",
    label: "Arrow 7",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-8",
    symbolName: "Arrow 8_Arrows_3",
    label: "Arrow 8",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-9",
    symbolName: "Arrow 9_Arrows_3",
    label: "Arrow 9",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-10",
    symbolName: "Arrow 10_Arrows_3",
    label: "Arrow 10",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-11",
    symbolName: "Arrow 11_Arrows_3",
    label: "Arrow 11",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-12",
    symbolName: "Arrow 12_Arrows_3",
    label: "Arrow 12",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-13",
    symbolName: "Arrow 13_Arrows_3",
    label: "Arrow 13",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-14",
    symbolName: "Arrow 14_Arrows_3",
    label: "Arrow 14",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-15",
    symbolName: "Arrow 15_Arrows_3",
    label: "Arrow 15",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-16",
    symbolName: "Arrow 16_Arrows_3",
    label: "Arrow 16",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-17",
    symbolName: "Arrow 17_Arrows_3",
    label: "Arrow 17",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-18",
    symbolName: "Arrow 18_Arrows_3",
    label: "Arrow 18",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-19",
    symbolName: "Arrow 19_Arrows_3",
    label: "Arrow 19",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-20",
    symbolName: "Arrow 20_Arrows_3",
    label: "Arrow 20",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-cutout-1",
    symbolName: "Arrow Cutout 1_Arrows_3",
    label: "Arrow Cutout 1",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-cutout-2",
    symbolName: "Arrow Cutout 2_Arrows_3",
    label: "Arrow Cutout 2",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrow-cutout-3",
    symbolName: "Arrow Cutout 3_Arrows_3",
    label: "Arrow Cutout 3",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-clockwise-arrow",
    symbolName: "Clockwise Arrow_Other_3",
    label: "Clockwise Arrow",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-counterclockwise-arrow",
    symbolName: "Counterclockwise Arrow_Other_3",
    label: "Counterclockwise Arrow",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-left-turn-arrow-1",
    symbolName: "Left Turn Arrow 1_Other_3",
    label: "Left Turn Arrow 1",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-right-turn-arrow-1",
    symbolName: "Right Turn Arrow 1_Other_3",
    label: "Right Turn Arrow 1",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-left-turn-arrow-2",
    symbolName: "Left Turn Arrow 2_Other_3",
    label: "Left Turn Arrow 2",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-right-turn-arrow-2",
    symbolName: "Right Turn Arrow 2_Other_3",
    label: "Right Turn Arrow 2",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-paired-arrow",
    symbolName: "Paired Arrow_Other_3",
    label: "Paired Arrow",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-two-way-arrow",
    symbolName: "Two-Way Arrow_Other_3",
    label: "Two-Way Arrow",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-u-turn-arrow-1",
    symbolName: "U Turn Arrow 1_Other_3",
    label: "U Turn Arrow 1",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-u-turn-arrow-2",
    symbolName: "U Turn Arrow 2_Other_3",
    label: "U Turn Arrow 2",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-a",
    symbolName: "Arrowhead A_Arrowheads_3",
    label: "Arrowhead A",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-b",
    symbolName: "Arrowhead B_Arrowheads_3",
    label: "Arrowhead B",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-c",
    symbolName: "Arrowhead C_Arrowheads_3",
    label: "Arrowhead C",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-d",
    symbolName: "Arrowhead D_Arrowheads_3",
    label: "Arrowhead D",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-e",
    symbolName: "Arrowhead E_Arrowheads_3",
    label: "Arrowhead E",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-f",
    symbolName: "Arrowhead F_Arrowheads_3",
    label: "Arrowhead F",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-g",
    symbolName: "Arrowhead G_Arrowheads_3",
    label: "Arrowhead G",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-h",
    symbolName: "Arrowhead H_Arrowheads_3",
    label: "Arrowhead H",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-j",
    symbolName: "Arrowhead J_Arrowheads_3",
    label: "Arrowhead J",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-k",
    symbolName: "Arrowhead K_Arrowheads_3",
    label: "Arrowhead K",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-l",
    symbolName: "Arrowhead L_Arrowheads_3",
    label: "Arrowhead L",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-m",
    symbolName: "Arrowhead M_Arrowheads_3",
    label: "Arrowhead M",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-n",
    symbolName: "Arrowhead N_Arrowheads_3",
    label: "Arrowhead N",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-p",
    symbolName: "Arrowhead P_Arrowheads_3",
    label: "Arrowhead P",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-q",
    symbolName: "Arrowhead Q_Arrowheads_3",
    label: "Arrowhead Q",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-r",
    symbolName: "Arrowhead R_Arrowheads_3",
    label: "Arrowhead R",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "arrows-arrowhead-s",
    symbolName: "Arrowhead S_Arrowheads_3",
    label: "Arrowhead S",
    category: "Arrows",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/eef578633a3e41b985d0c980275c6d74/data"
  },
  {
    name: "animated-circle-with-outline-scaling",
    symbolName: "Circle with outline scaling",
    label: "Circle with outline scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-triangle-with-outline-scaling",
    symbolName: "Triangle with outline scaling",
    label: "Triangle with outline scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-square-with-outline-scaling",
    symbolName: "Square with outline scaling",
    label: "Square with outline scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-rounded-with-outline-scaling",
    symbolName: "Rounded with outline scaling",
    label: "Rounded with outline scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-octagon-with-outline-scaling",
    symbolName: "Octagon with outline scaling",
    label: "Octagon with outline scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-hexagon-with-outline-scaling",
    symbolName: "Hexagon with outline scaling",
    label: "Hexagon with outline scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-star-with-outline-scaling",
    symbolName: "Star with outline scaling",
    label: "Star with outline scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-circle-scaling",
    symbolName: "Circle scaling",
    label: "Circle scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-triangle-scaling",
    symbolName: "Triangle scaling",
    label: "Triangle scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-square-scaling",
    symbolName: "Square scaling",
    label: "Square scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-rounded-with-scaling",
    symbolName: "Rounded scaling",
    label: "Rounded with scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-octagon-with-scaling",
    symbolName: "Octagon scaling",
    label: "Octagon with scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-hexagon-with-scaling",
    symbolName: "Hexagon scaling",
    label: "Hexagon with scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-star-with-scaling",
    symbolName: "Star with scaling",
    label: "Star with scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-pin-offset",
    symbolName: "Pin offset",
    label: "Pin offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-teardrop-pin-offset",
    symbolName: "Teardrop pin offset",
    label: "Teardrop pin offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-esri-pin-offset",
    symbolName: "Esri pin offset",
    label: "Esri pin offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-square-pin-offset",
    symbolName: "Square pin offset",
    label: "Square pin offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-esri-pin-2-offset",
    symbolName: "Esri Pin 2 offset",
    label: "Esri Pin 2 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-tear-pin-2-offset",
    symbolName: "Tear Pin 2 offset",
    label: "Tear Pin 2 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-pin-scaling",
    symbolName: "Pin scaling",
    label: "Pin scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-teardrop-scaling",
    symbolName: "Teardrop scaling",
    label: "Teardrop scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-esri-pin-scaling",
    symbolName: "Esri pin  scaling",
    label: "Esri pin scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-square-pin-scaling",
    symbolName: "Square pin scaling",
    label: "Square pin scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-esri-pin-scaling-2",
    symbolName: "Esri Pin scaling",
    label: "Esri Pin scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-tear-pin-2-scaling",
    symbolName: "Tear Pin 2 scaling",
    label: "Tear Pin 2 scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrow-marker-1-offset",
    symbolName: "Arrow Marker 1 offset",
    label: "Arrow Marker 1 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrow-marker-2-offset",
    symbolName: "Arrow Marker 2 offset",
    label: "Arrow Marker 2 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrow-marker-3-offset",
    symbolName: "Arrow Marker 3 offset",
    label: "Arrow Marker 3 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrow-marker-4-offset",
    symbolName: "Arrow Marker 4 offset",
    label: "Arrow Marker 4 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrow-marker-5-offset",
    symbolName: "Arrow Marker 5 offset",
    label: "Arrow Marker 5 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrowhead-1-offset",
    symbolName: "Arrowhead 1 offset",
    label: "Arrowhead 1 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrowhead-2-offset",
    symbolName: "Arrowhead 2 offset",
    label: "Arrowhead 2 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-arrowhead-3-offset",
    symbolName: "Arrowhead 3 offset",
    label: "Arrowhead 3 offset",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-fire-station-color-change",
    symbolName: "Fire Station color change",
    label: "Fire Station color change",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-police-station-color-change",
    symbolName: "Police Station color change",
    label: "Police Station color change",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-hospital-color-change",
    symbolName: "Hospital color change",
    label: "Hospital color change",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-fire-warning-color-change",
    symbolName: "Fire_Incidents - Large_3",
    label: "Fire warning color change",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-road-block-color-change",
    symbolName: "Road Block",
    label: "Road block color change",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-warning-color-change",
    symbolName: "Animated 3_1",
    label: "Warning color change",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-incident-poi-scaling",
    symbolName: "Originator Incident",
    label: "Incident POI scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-information-scaling",
    symbolName: "Information",
    label: "Information scaling",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-crosshair",
    symbolName: "Crosshair",
    label: "Crosshair",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-square-crosshair",
    symbolName: "Square Crosshair",
    label: "Square Crosshair",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  },
  {
    name: "animated-cross-triangle",
    symbolName: "Cross Triangle",
    label: "Cross Triangle",
    category: "Animated",
    styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/e735e01bd1d34c2eaaafa3229c231be2/data"
  }
], Gr = "Sirkler", Wr = Array.from(
  new Set(Ws.map((a) => a.category))
), Ks = Ws.map((a) => ({
  name: a.name,
  label: a.label,
  category: a.category,
  webStyle: { symbolName: a.symbolName, styleUrl: a.styleUrl }
})), qs = new Map(Ks.map((a) => [a.name, a]));
function Kr(a) {
  return qs.get(a);
}
const qr = /* @__PURE__ */ new Set(["Shapes"]);
function Ys(a) {
  const e = qs.get(a)?.category;
  return e != null && qr.has(e);
}
const pt = /* @__PURE__ */ new Map(), ht = /* @__PURE__ */ new Map(), ut = /* @__PURE__ */ new Map();
function Yr(a) {
  let e = pt.get(a);
  return e || (e = fetch(`${a}?f=json`).then((l) => l.json()).then((l) => l.items ?? []), e.catch(() => pt.delete(a)), pt.set(a, e)), e;
}
function Jr(a, e) {
  return /^https?:\/\//.test(e) ? e : `${a.replace(/\/data$/, "")}/${e.replace(/^\.\//, "")}`;
}
function Xr(a) {
  let e = ht.get(a);
  return e || (e = fetch(`${a}?f=json`).then((l) => l.json()), e.catch(() => ht.delete(a)), ht.set(a, e)), e;
}
function Js(a, e) {
  const l = `${a}::${e}`;
  let r = ut.get(l);
  return r || (r = Yr(a).then((c) => {
    const o = c.find((b) => b.name === e);
    if (!o?.cimRef)
      throw new Error(`Symbolet "${e}" ble ikke funnet i stilen ${a}`);
    return Xr(Jr(a, o.cimRef));
  }).then((c) => new It({ data: { type: "CIMSymbolReference", symbol: c } })), r.catch(() => ut.delete(l)), ut.set(l, r)), r;
}
function Qr(a) {
  const e = Kr(a)?.webStyle;
  if (!e)
    throw new Error(`Fant ikke web style-symbol for "${a}"`);
  return Js(e.styleUrl, e.symbolName);
}
async function ec(a, e, l) {
  const c = (await Qr(a)).clone();
  return Wl(c, e), Ys(a) && Kl(c, new Gl(l)), c.data.esriWebStyleName = a, c;
}
function ac(a) {
  const e = a?.data?.esriWebStyleName;
  if (a?.type !== "cim" || !e)
    return null;
  const l = ql(a), r = Yl(a);
  return {
    name: e,
    size: l ?? 16,
    color: r ? [r.r, r.g, r.b, r.a] : [0, 0, 0, 1]
  };
}
const tc = ({ symbol: a, size: e = 24 }) => {
  const l = K(null), [r, c] = x(!1);
  return O(() => {
    const o = l.current;
    if (!o)
      return;
    const b = new IntersectionObserver(
      (i) => {
        i[0]?.isIntersecting && (c(!0), b.disconnect());
      },
      { rootMargin: "100px" }
    );
    return b.observe(o), () => b.disconnect();
  }, []), O(() => {
    if (!r)
      return;
    const o = l.current;
    if (!o)
      return;
    let b = !1;
    return o.innerHTML = "", (a.type === "web-style" && a.styleUrl && a.name ? Js(a.styleUrl, a.name) : Promise.resolve(a)).then((d) => Rt(d, { size: e })).then((d) => {
      !b && d && o.appendChild(d);
    }).catch((d) => {
      console.error("Kunne ikke forhåndsvise symbol:", d);
    }), () => {
      b = !0;
    };
  }, [r, a, e]), /* @__PURE__ */ n.jsx(
    "div",
    {
      ref: l,
      style: {
        width: e,
        height: e,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }
  );
}, sc = "ShapePicker-module__fields___-LJ5Q", lc = "ShapePicker-module__hint___VHJLO", Xt = {
  fields: sc,
  hint: lc
}, Aa = "simple", nc = "Sirkel", rc = Wr.map((a) => ({ value: a, label: a })), Xs = [
  { name: Aa, label: nc, category: Gr },
  ...Ks
];
function cc(a) {
  return a.name === Aa ? new Xl({
    color: [0, 0, 0, 1],
    size: 16,
    outline: { color: [255, 255, 255, 0.8], width: 1 }
  }) : new Jl({ name: a.webStyle.symbolName, styleUrl: a.webStyle.styleUrl });
}
const oc = new Map(Xs.map((a) => [a.name, cc(a)])), mc = ({ value: a, onChange: e }) => {
  const [l, r] = x(""), c = is(() => l ? Xs.filter((o) => o.category === l).map(({ name: o, label: b }) => ({ value: o, label: b })) : [], [l]);
  return /* @__PURE__ */ n.jsxs("div", { className: Xt.fields, children: [
    /* @__PURE__ */ n.jsx("p", { className: Xt.hint, children: "Velg kategori for å endre symbol" }),
    /* @__PURE__ */ n.jsx(
      Da,
      {
        label: "Kategori",
        hideLabel: !0,
        value: l,
        placeholder: "Velg kategori",
        onChange: (o) => r(o.target.value),
        options: rc
      }
    ),
    l && /* @__PURE__ */ n.jsx(
      Ml,
      {
        label: "Symbol",
        hideLabel: !0,
        placeholder: "Søk symbol (f.eks. skole, sirkel, kryss…)",
        value: [a],
        onChange: (o) => {
          o[0] && e(o[0]);
        },
        options: c,
        optionsLayout: "grid",
        renderOption: (o) => /* @__PURE__ */ n.jsx("span", { title: o.label, children: /* @__PURE__ */ n.jsx(tc, { symbol: oc.get(o.value), size: 32 }) })
      }
    )
  ] });
}, ic = ({ sketchVM: a, initialSymbol: e, onSymbolChange: l }) => {
  const r = a, [c, o] = x(() => {
    const g = e ?? r.pointSymbol, h = ac(g);
    return h ? {
      shape: h.name,
      color: wa(h.color),
      transparency: Ua(h.color),
      size: h.size
    } : {
      shape: Aa,
      color: wa(g?.color),
      transparency: Ua(g?.color),
      size: g?.size ?? 8
    };
  });
  function b(g) {
    o((h) => ({ ...h, ...g }));
  }
  const i = K(0), d = K(c);
  O(() => {
    const g = d.current, h = g.shape !== c.shape || g.color !== c.color || g.transparency !== c.transparency || g.size !== c.size;
    if (d.current = c, !h)
      return;
    let f = !1;
    function u(A) {
      f || (l ? l(A) : r.pointSymbol = A);
    }
    if (c.shape === Aa)
      return u({
        type: "simple-marker",
        color: va(c.color, c.transparency),
        size: c.size,
        outline: { color: [255, 255, 255, 0.8], width: 1 }
      }), () => {
        f = !0;
      };
    const v = ++i.current;
    return ec(c.shape, c.size, va(c.color, c.transparency)).then((A) => {
      i.current === v && u(A);
    }).catch((A) => console.error("Kunne ikke bygge punktsymbol for", c.shape, A)), () => {
      f = !0;
    };
  }, [c.shape, c.color, c.transparency, c.size]);
  const m = c.shape === Aa || Ys(c.shape);
  return /* @__PURE__ */ n.jsxs("div", { className: he.settings, children: [
    /* @__PURE__ */ n.jsx(mc, { value: c.shape, onChange: (g) => b({ shape: g }) }),
    m && /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
      /* @__PURE__ */ n.jsx(
        Va,
        {
          label: "Farge",
          value: c.color,
          onChange: (g) => b({ color: g })
        }
      ),
      /* @__PURE__ */ n.jsx(
        Oa,
        {
          label: "Gjennomsiktighet",
          value: c.transparency,
          min: 0,
          max: 100,
          step: 1,
          unit: "%",
          onChange: (g) => b({ transparency: g })
        }
      )
    ] }),
    /* @__PURE__ */ n.jsx(
      Oa,
      {
        label: "Størrelse",
        value: c.size,
        min: 2,
        max: 40,
        step: 1,
        unit: "px",
        onChange: (g) => b({ size: g })
      }
    )
  ] });
}, bc = ({ sketchVM: a, geometryType: e, selectedGraphic: l, initialSymbol: r, onSymbolChange: c }) => {
  const o = String(l?.uid ?? "");
  return e === "polyline" ? /* @__PURE__ */ n.jsx(Br, { sketchVM: a, initialSymbol: r, onSymbolChange: c }, o) : e === "polygon" ? /* @__PURE__ */ n.jsx(zr, { sketchVM: a, initialSymbol: r, onSymbolChange: c }, o) : e === "point" ? /* @__PURE__ */ n.jsx(ic, { sketchVM: a, initialSymbol: r, onSymbolChange: c }, o) : null;
}, dc = "MeasurementSettings-module__settings___pm2BB", yc = "MeasurementSettings-module__sectionHeading___4pQXh", gc = "MeasurementSettings-module__blockContent___ed2tu", fc = "MeasurementSettings-module__sliderRow___6ZKgg", pc = "MeasurementSettings-module__slider___iF-xF", hc = "MeasurementSettings-module__numberInput___0YlJh", At = {
  settings: dc,
  sectionHeading: yc,
  blockContent: gc,
  sliderRow: fc,
  slider: pc,
  numberInput: hc
}, uc = ({ options: a, onChange: e, geometryType: l, selectedGraphic: r }) => {
  const [c, o] = x(a?.showOnMap ?? !0), [b, i] = x(a?.showSegmentLengths ?? !0), [d, m] = x(a?.labelStyle ?? "simple"), [g, h] = x(a?.textSize ?? "medium"), [f, u] = x(a?.precision ?? 2);
  O(() => {
    if (!r)
      return;
    const A = r.getAttribute("measurementShowOnMap"), p = r.getAttribute("measurementShowSegmentLengths"), S = r.getAttribute("measurementLabelStyle"), U = r.getAttribute("measurementTextSize"), w = r.getAttribute("measurementPrecision");
    A != null && o(A), p != null && i(p), S != null && m(S), U != null && h(U), w != null && u(w);
  }, [r]);
  const v = (A) => e(A, r ?? null);
  return /* @__PURE__ */ n.jsxs("div", { className: At.settings, children: [
    /* @__PURE__ */ n.jsx(
      Gt,
      {
        label: "Vis mål",
        checked: c,
        onChange: (A) => {
          o(A), v({ showOnMap: A });
        }
      }
    ),
    c && /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
      /* @__PURE__ */ n.jsx("p", { className: At.sectionHeading, children: "Innstillinger for mål" }),
      /* @__PURE__ */ n.jsxs("div", { className: At.blockContent, children: [
        (l === "polyline" || l === "polygon") && /* @__PURE__ */ n.jsx(
          Gt,
          {
            label: "Vis delsegmenter / radius",
            checked: b,
            onChange: (A) => {
              i(A), v({ showSegmentLengths: A });
            }
          }
        ),
        /* @__PURE__ */ n.jsx(
          Da,
          {
            label: "Etikettstil",
            value: d,
            options: [
              { value: "simple", label: "Enkel" },
              { value: "boxed", label: "Med bakgrunn" }
            ],
            onChange: (A) => {
              const p = A.target.value;
              m(p), v({ labelStyle: p });
            }
          }
        ),
        /* @__PURE__ */ n.jsx(
          jl,
          {
            label: "Tekststørrelse",
            value: g,
            options: [
              { value: "small", label: "Liten" },
              { value: "medium", label: "Medium" },
              { value: "large", label: "Stor" }
            ],
            onChange: (A) => {
              h(A), v({ textSize: A });
            }
          }
        ),
        /* @__PURE__ */ n.jsx(
          Zt,
          {
            label: "Desimaler",
            min: 0,
            max: 6,
            step: 1,
            value: f,
            onChange: (A) => {
              const p = parseInt(A.target.value);
              u(p), v({ precision: p });
            }
          }
        )
      ] })
    ] })
  ] });
}, Ac = "DrawingCustomSettings-module__container___RFOhU", Sc = "DrawingCustomSettings-module__section___N7kaX", Nc = {
  container: Ac,
  section: Sc
}, wc = ({
  sketchVM: a,
  measurementOptions: e,
  onMeasurementOptionsChange: l,
  onGeometryTypeChange: r,
  onSymbolChange: c,
  measurementManager: o,
  graphic: b
}) => {
  const [i, d] = x(null), m = (w) => {
    d(w), r?.(w);
  }, [g, h] = x(void 0), f = K([]), u = (w) => {
    if (w.length === 0)
      return null;
    const V = w[0]?.geometry?.type;
    return V ? w.every((J) => J.geometry?.type === V) ? V : "multiple" : null;
  }, v = (w) => w.includes("point") ? "point" : w.includes("polyline") ? "polyline" : w.includes("polygon") || w.includes("rectangle") || w.includes("circle") ? "polygon" : w.includes("text") ? "text" : null;
  if (O(() => {
    if (!a || b)
      return;
    if (a.activeTool) {
      const E = v(a.activeTool);
      E && m(E);
    }
    const w = a.watch("polygonSymbol", (E) => {
      f.current.forEach((I) => {
        I.geometry?.type === "polygon" && (I.symbol = E);
      });
    }), V = a.watch("pointSymbol", (E) => {
      f.current.forEach((I) => {
        I.geometry?.type === "point" && I.symbol?.type !== "text" && (I.symbol = E);
      });
    }), J = a.watch("polylineSymbol", (E) => {
      f.current.forEach((I) => {
        I.geometry?.type === "polyline" && (I.symbol = E);
      });
    }), M = a.watch("textSymbol", (E) => {
      f.current.forEach((I) => {
        I.geometry?.type === "point" && I.symbol?.type === "text" && (I.symbol = E);
      });
    }), X = a.watch("activeTool", (E) => {
      if (E) {
        const I = v(E);
        I && m(I);
      }
    }), Z = a.on("create", (E) => {
      E.graphic && (f.current = [E.graphic], h(E.graphic), o?.updateMeasurement(E.graphic)), E.state === "start" && m(v(a.activeTool ?? "")), E.state === "complete" && E.graphic && a.update([E.graphic]), E.state === "cancel" && (o?.removeMeasurement(E.graphic), f.current = [], h(void 0), m(null));
    }), T = a.on("delete", (E) => {
      E.graphics?.forEach((I) => o?.removeMeasurement(I)), f.current = [], h(void 0), m(null);
    }), P = a.on("update", (E) => {
      f.current = E.graphics || [];
      const I = f.current[0], F = u(f.current);
      if (m(F), h(I), F && I?.symbol)
        switch (F) {
          case "point":
            a.pointSymbol = I.symbol;
            break;
          case "polyline":
            a.polylineSymbol = I.symbol;
            break;
          case "polygon":
            a.polygonSymbol = I.symbol;
            break;
          case "text":
            a.textSymbol = I.symbol;
            break;
        }
      E.graphics?.forEach((q) => o?.updateMeasurement(q)), E.state === "complete" && (f.current = [], h(void 0), m(null));
    });
    return () => {
      w.remove(), V.remove(), J.remove(), M.remove(), X.remove(), Z.remove(), T.remove(), P.remove();
    };
  }, [a, o]), !a)
    return null;
  const A = b ? b.geometry?.type ?? null : i, p = b ?? g, S = p ? {
    showOnMap: p.getAttribute("measurementShowOnMap") ?? (A === "point" ? !1 : e?.showOnMap),
    showLabels: p.getAttribute("measurementShowLabels") ?? e?.showLabels,
    unit: p.getAttribute("measurementUnit") ?? e?.unit,
    precision: p.getAttribute("measurementPrecision") ?? e?.precision,
    labelStyle: p.getAttribute("measurementLabelStyle") ?? e?.labelStyle,
    showSegmentLengths: p.getAttribute("measurementShowSegmentLengths") ?? e?.showSegmentLengths,
    textSize: p.getAttribute("measurementTextSize") ?? e?.textSize
  } : e, U = (w, V) => {
    b ? l?.(w, b) : f.current.length > 0 ? f.current.forEach(
      (J) => l?.(w, J)
    ) : l?.(w, V ?? null);
  };
  return /* @__PURE__ */ n.jsx("div", { className: Nc.container, children: A !== null && A !== "multiple" && A !== "text" && /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    /* @__PURE__ */ n.jsx(
      bc,
      {
        sketchVM: a,
        geometryType: A,
        selectedGraphic: p,
        initialSymbol: b ? b.symbol : void 0,
        onSymbolChange: b ? c ?? ((w) => {
          b.symbol = w;
        }) : void 0
      }
    ),
    /* @__PURE__ */ n.jsx(
      uc,
      {
        options: S,
        onChange: U,
        geometryType: A,
        selectedGraphic: p
      }
    )
  ] }) });
}, Uc = {
  point: "Punkt",
  polyline: "Linje",
  polygon: "Polygon",
  rectangle: "Rektangel",
  circle: "Sirkel",
  text: "Tekst"
}, Qt = "drawing-custom-graphics-layer", es = "drawing-custom-selection-layer";
function vc(a, e) {
  return a.graphics.filter((l) => !!l.geometry && Ql.execute(e, l.geometry)).toArray();
}
function Me(a, e, l) {
  a.has(e) || a.set(e, []), a.get(e).push(l);
}
function _c(a) {
  const e = K(null), l = K(null), r = K(null), c = K(null), o = K(null), b = K("point"), i = K(null), d = K(/* @__PURE__ */ new Map()), m = K(/* @__PURE__ */ new Map()), g = K(/* @__PURE__ */ new Map()), h = K(/* @__PURE__ */ new Map()), f = K(!1), u = K(null), [v, A] = x(null), [p, S] = x(null), [U, w] = x(null), [V, J] = x(!0), [M, X] = x(0), [Z, T] = x(0), [P, E] = x([]), [I, F] = x(!1), [q, ne] = x(!1), [z, W] = x(0), [ie, ue] = x(0), [Ze, je] = x(null), H = ce(() => {
    const C = i.current ? i.current.uid : null, Y = C ? (d.current.get(C)?.length ?? 0) > 0 || g.current.has(C) : !1, te = C ? (m.current.get(C)?.length ?? 0) > 0 : !1;
    F(Y), ne(te);
  }, []);
  O(() => {
    const C = a?.map;
    if (!a || !C || !a.container)
      return;
    let Y = !1;
    const te = [];
    let Q = C.findLayerById(Qt);
    Q || (Q = new Sa({ id: Qt, listMode: "hide" }), C.add(Q)), e.current = Q;
    const ee = Q.graphics.toArray();
    ee.length > 0 && (E(ee.map((D) => ({
      graphic: D,
      toolType: D.__toolType ?? D.geometry?.type ?? "point"
    }))), T(ee.length));
    let oe = C.findLayerById(es);
    oe || (oe = new Sa({ id: es, listMode: "hide" }), C.add(oe)), l.current = oe;
    const Ae = (D) => {
      if (D.state !== "complete")
        return;
      D.graphic.__toolType = b.current, o.current?.updateMeasurement(D.graphic), T((G) => G + 1), E((G) => [...G, { graphic: D.graphic, toolType: b.current }]);
      const ye = D.graphic.uid;
      Me(d.current, ye, { kind: "geometry" }), m.current.set(ye, []), H();
    }, Se = (D) => {
      D.graphics?.forEach((G) => o.current?.updateMeasurement(G)), ue((G) => G + 1);
      const ye = D.state === "complete" ? 0 : D.graphics?.length ?? 0;
      if (X(ye), D.state === "start") {
        const G = D.graphics?.length === 1 ? D.graphics[0] : null;
        i.current = G, je(G ? G.uid : null), f.current = !1, u.current = G?.geometry ? G.geometry.clone() : null;
      } else if (D.state === "active") {
        if (!f.current && D.graphics?.length === 1) {
          const G = D.graphics[0].uid, Ue = u.current ?? void 0;
          Me(d.current, G, { kind: "geometry", geometry: Ue }), m.current.set(G, []), f.current = !0;
        }
      } else if (D.state === "complete") {
        if (!f.current && D.graphics?.length === 1) {
          const G = D.graphics[0].uid, Ue = u.current ?? void 0;
          Me(d.current, G, { kind: "geometry", geometry: Ue }), m.current.set(G, []);
        }
        f.current = !1, u.current = null, je(null);
      }
      H();
    }, aa = (D) => {
      D.graphics?.forEach((G) => o.current?.removeMeasurement(G)), X(0), T((G) => Math.max(0, G - (D.graphics?.length ?? 0)));
      const ye = new Set(D.graphics ?? []);
      E((G) => G.filter((Ue) => !ye.has(Ue.graphic)));
    };
    return a.when(() => {
      if (Y)
        return;
      const D = new Kt({
        layer: Q,
        view: a,
        defaultCreateOptions: { mode: "hybrid" },
        pointSymbol: {
          type: "simple-marker",
          color: [255, 0, 0],
          size: 8,
          outline: { color: [255, 255, 255, 0.8], width: 1 }
        },
        snappingOptions: {
          enabled: !0,
          selfEnabled: !0,
          featureEnabled: !0,
          distance: 10,
          featureSources: C.allLayers.filter((G) => G.type === "feature" || G.type === "graphics").map((G) => new an({ layer: G, enabled: !0 })).toArray()
        },
        tooltipOptions: { enabled: !0 }
      }), ye = new Kt({ layer: oe, view: a });
      r.current = D, c.current = ye, A(D), te.push(
        D.watch("activeTool", (G) => {
          S(G), G && w(null);
        }),
        D.on("create", Ae),
        D.on("update", Se),
        D.on("undo", H),
        D.on("redo", H),
        D.on("delete", aa),
        ye.on("create", (G) => {
          const Ue = G.graphic?.geometry;
          if (G.state !== "complete" || !Ue)
            return;
          const Fe = vc(Q, Ue);
          oe.removeAll(), Fe.length > 0 && D.update(Fe);
        })
      ), o.current = zs.getInstance(), o.current.init(a);
    }), () => {
      Y = !0, te.forEach((D) => D.remove()), r.current?.destroy(), r.current = null, c.current?.destroy(), c.current = null;
    };
  }, [a, H]);
  const ge = ce((C) => {
    if (c.current?.cancel(), w(null), p === C) {
      r.current?.cancel();
      return;
    }
    b.current = C, r.current?.create(C);
  }, [p]), Re = ce((C) => {
    if (r.current?.cancel(), c.current?.cancel(), l.current?.removeAll(), U === C) {
      w(null);
      return;
    }
    w(C), C === "rectangle" ? c.current?.create("rectangle") : C === "lasso" && c.current?.create("polygon", { mode: "freehand" });
  }, [U]), Oe = ce(() => {
    const C = r.current;
    if (!C)
      return;
    const Y = !C.snappingOptions.enabled;
    C.snappingOptions = new en({
      enabled: Y,
      selfEnabled: !0,
      featureEnabled: !0,
      distance: 10,
      featureSources: C.snappingOptions.featureSources
    }), J(Y);
  }, []), xe = ce(() => r.current?.delete(), []), Le = ce(() => {
    const C = i.current;
    if (!C)
      return;
    const Y = C.uid, te = r.current, Q = g.current.get(Y);
    if (Q !== void 0) {
      clearTimeout(h.current.get(Y)), h.current.delete(Y), g.current.delete(Y), C.symbol && Me(m.current, Y, { kind: "symbol", symbol: C.symbol.clone() }), C.symbol = Q, W((oe) => oe + 1), H();
      return;
    }
    const ee = d.current.get(Y);
    for (; ee?.length; ) {
      const oe = ee[ee.length - 1];
      if (oe.kind === "symbol") {
        ee.pop(), C.symbol && Me(m.current, Y, { kind: "symbol", symbol: C.symbol.clone() }), C.symbol = oe.symbol, W((Ae) => Ae + 1);
        break;
      }
      if (oe.geometry) {
        ee.pop();
        const Ae = C.geometry ? C.geometry.clone() : void 0;
        Me(m.current, Y, { kind: "geometry", geometry: Ae }), C.geometry = oe.geometry, ue((Se) => Se + 1), o.current?.updateMeasurement(C);
        break;
      }
      if (te?.canUndo()) {
        te.undo(), te.canUndo() || (ee.pop(), Me(m.current, Y, { kind: "geometry" }));
        break;
      }
      ee.pop();
    }
    H();
  }, [H]), Ce = ce(() => {
    const C = i.current;
    if (!C)
      return;
    const Y = C.uid, te = r.current, Q = m.current.get(Y);
    for (; Q?.length; ) {
      const ee = Q[Q.length - 1];
      if (ee.kind === "symbol") {
        Q.pop(), C.symbol && Me(d.current, Y, { kind: "symbol", symbol: C.symbol.clone() }), C.symbol = ee.symbol, W((oe) => oe + 1);
        break;
      }
      if (ee.geometry) {
        Q.pop();
        const oe = C.geometry ? C.geometry.clone() : void 0;
        Me(d.current, Y, { kind: "geometry", geometry: oe }), C.geometry = ee.geometry, ue((Ae) => Ae + 1), o.current?.updateMeasurement(C);
        break;
      }
      if (te?.canRedo()) {
        te.redo(), te.canRedo() || (Q.pop(), Me(d.current, Y, { kind: "geometry" }));
        break;
      }
      Q.pop();
    }
    H();
  }, [H]), Ie = ce((C, Y) => {
    const te = C.uid;
    !g.current.has(te) && C.symbol && g.current.set(te, C.symbol.clone()), clearTimeout(h.current.get(te));
    const Q = setTimeout(() => {
      const ee = g.current.get(te);
      ee && (Me(d.current, te, { kind: "symbol", symbol: ee }), g.current.delete(te), h.current.delete(te), H());
    }, 500);
    h.current.set(te, Q), m.current.set(te, []), C.symbol = Y, H();
  }, [H]), ke = ce((C) => {
    const Y = C.uid;
    clearTimeout(h.current.get(Y)), g.current.delete(Y), h.current.delete(Y), d.current.delete(Y), m.current.delete(Y), i.current === C && (i.current = null), r.current?.cancel(), c.current?.cancel(), l.current?.removeAll(), o.current?.removeMeasurement(C), e.current?.remove(C), X(0), T((te) => Math.max(0, te - 1)), E((te) => te.filter((Q) => Q.graphic !== C)), H();
  }, [H]), ea = ce((C) => {
    i.current = C, c.current?.cancel(), l.current?.removeAll(), C ? r.current?.update([C]) : r.current?.cancel(), H();
  }, [H]);
  return {
    sketchVM: v,
    measurementManager: o.current,
    activeTool: p,
    selectMode: U,
    snappingEnabled: V,
    selectionCount: M,
    graphicCount: Z,
    drawings: P,
    canUndo: I,
    canRedo: q,
    symbolRevision: z,
    geometryRevision: ie,
    selectedGraphicUid: Ze,
    handleCreate: ge,
    handleSelect: Re,
    handleToggleSnapping: Oe,
    handleUndo: Le,
    handleRedo: Ce,
    handleSymbolChange: Ie,
    handleDelete: xe,
    handleDeleteGraphic: ke,
    handleActivateDrawing: ea
  };
}
const xc = "DrawingCustom-module__root___C3yS5", Lc = "DrawingCustom-module__drawingNotice___o1Ho6", Cc = "DrawingCustom-module__drawingHistoryActions___nXng9", kc = "DrawingCustom-module__measurementLabel___HwBOC", Ia = {
  root: xc,
  drawingNotice: Lc,
  drawingHistoryActions: Cc,
  measurementLabel: kc
}, Ec = {
  showLabels: !0,
  showOnMap: !0,
  unit: "metric",
  precision: 2,
  textSize: "medium",
  labelStyle: "simple",
  showSegmentLengths: !0
};
function Mc(a) {
  return a ? a.includes("point") ? "point" : a.includes("polyline") ? "polyline" : a.includes("polygon") || a.includes("rectangle") || a.includes("circle") ? "polygon" : a.includes("text") ? "text" : null : null;
}
function jc(a, e) {
  const l = e.filter((r) => r.toolType === a.toolType).indexOf(a) + 1;
  return `${Uc[a.toolType] ?? a.toolType} ${l}`;
}
function Tc({ geometryType: a, graphicCount: e }) {
  let l;
  return a !== null ? l = "Velg objekter av samme type for å endre symboler" : l = "Velg et verktøy ovenfor. Du kan tegne opp flere objekter.", /* @__PURE__ */ n.jsx(As, { variant: "info", icon: /* @__PURE__ */ n.jsx(Ba, { size: 20, weight: "regular" }), className: Ia.drawingNotice, children: /* @__PURE__ */ n.jsx("p", { children: l }) });
}
const E0 = () => {
  const { mapView: a } = He(), { setDisableMapClick: e } = Ll();
  O(() => (e(!0), () => {
    e(!1);
  }), []);
  const {
    sketchVM: l,
    measurementManager: r,
    activeTool: c,
    selectMode: o,
    snappingEnabled: b,
    selectionCount: i,
    graphicCount: d,
    drawings: m,
    handleCreate: g,
    handleSelect: h,
    handleToggleSnapping: f,
    canUndo: u,
    canRedo: v,
    symbolRevision: A,
    geometryRevision: p,
    selectedGraphicUid: S,
    handleUndo: U,
    handleRedo: w,
    handleSymbolChange: V,
    handleDelete: J,
    handleDeleteGraphic: M,
    handleActivateDrawing: X
  } = _c(a), Z = Mc(c), [T, P] = x(null), [E, I] = x(0), F = K(0);
  O(() => {
    S !== null && S !== T && P(S);
  }, [S]), bs(() => {
    const z = m.length > F.current;
    if (F.current = m.length, m.length === 0) {
      P(null);
      return;
    }
    const W = m[m.length - 1];
    P(W.graphic.uid), z && X(W.graphic);
  }, [m.length]);
  const q = (z, W) => {
    W && r && (r.setGraphicMeasurementOptions(W, z), I((ie) => ie + 1));
  }, ne = is(() => {
    const z = /* @__PURE__ */ new Map();
    for (const W of m) {
      const ie = W.graphic.uid, ue = W.toolType !== "point" && W.toolType !== "text";
      z.set(ie, ue ? W.graphic.getAttribute("measurement") : null);
    }
    return z;
  }, [m, E, p]);
  return /* @__PURE__ */ n.jsxs("div", { id: "drawing-custom-details", className: Ia.root, children: [
    /* @__PURE__ */ n.jsx(
      Zr,
      {
        activeTool: c,
        selectMode: o,
        snappingEnabled: b,
        hasDrawings: d > 0,
        selectionCount: i,
        onCreate: g,
        onSelect: h,
        onDelete: J,
        onToggleSnapping: f
      }
    ),
    /* @__PURE__ */ n.jsxs("div", { id: "drawing-custom-list", children: [
      m.length === 0 && /* @__PURE__ */ n.jsx(Tc, { geometryType: Z, graphicCount: d }),
      m.map((z) => {
        const W = z.graphic.uid;
        return /* @__PURE__ */ n.jsxs(
          xr,
          {
            heading: jc(z, m),
            open: T === W,
            onOpenChange: (ie) => {
              P(ie ? W : null), X(ie ? z.graphic : null);
            },
            headerActions: /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
              ne.get(W) && /* @__PURE__ */ n.jsx("span", { className: Ia.measurementLabel, children: ne.get(W) }),
              /* @__PURE__ */ n.jsx(
                us,
                {
                  icon: /* @__PURE__ */ n.jsx(Ot, { size: 16 }),
                  label: "Slett tegning",
                  size: "sm",
                  onClick: () => M(z.graphic)
                }
              )
            ] }),
            children: [
              /* @__PURE__ */ n.jsxs(Tl, { "aria-label": "Angre/gjør om", className: Ia.drawingHistoryActions, children: [
                /* @__PURE__ */ n.jsx(
                  ua,
                  {
                    icon: /* @__PURE__ */ n.jsx(Ls, { size: 20 }),
                    label: "Angre",
                    disabled: !u,
                    onClick: U
                  }
                ),
                /* @__PURE__ */ n.jsx(
                  ua,
                  {
                    icon: /* @__PURE__ */ n.jsx(Cs, { size: 20 }),
                    label: "Gjør om",
                    disabled: !v,
                    onClick: w
                  }
                )
              ] }),
              /* @__PURE__ */ n.jsx(
                wc,
                {
                  graphic: z.graphic,
                  sketchVM: l,
                  measurementOptions: Ec,
                  onMeasurementOptionsChange: q,
                  onSymbolChange: (ie) => V(z.graphic, ie),
                  measurementManager: r
                },
                W === T ? `${W}-${A}` : W
              )
            ]
          },
          W
        );
      })
    ] })
  ] });
}, Hc = "LayerSelector-module__cardGroup___dog-Z", Zc = "LayerSelector-module__centerContainer___aSILL", Rc = "LayerSelector-module__messageContainer___pyCOj", Ic = "LayerSelector-module__thumbnail___DRTN9", Vc = "LayerSelector-module__cardFooter___KmyW-", Pc = "LayerSelector-module__layerVisible___bsAVM", ka = {
  cardGroup: Hc,
  centerContainer: Zc,
  messageContainer: Rc,
  thumbnail: Ic,
  cardFooter: Vc,
  layerVisible: Pc
}, M0 = ({
  layersGroupId: a,
  onError: e,
  fallbackThumbnail: l = "public/images/basis terreng.png"
}) => {
  const { t: r } = Pe(["kartinnhold"]), { mapView: c } = He(), [o, b] = x([]), [i, d] = x(!0);
  O(() => {
    if (!c || !a)
      return;
    (async () => {
      try {
        d(!0);
        const h = new Ns();
        await h.load();
        const u = await new ws({
          portal: h,
          id: a
        }).queryItems(), v = await Promise.all(
          u.results.map(async (A) => {
            if (!A.id || !A.title)
              throw new Error("Invalid portal item: missing id or title");
            const p = c.map?.allLayers.find(
              (S) => S.title === A.title
            );
            return {
              id: A.id,
              title: A.title,
              portalItem: A,
              layer: p,
              thumbnailUrl: A.thumbnailUrl || l
            };
          })
        );
        b(v);
      } catch (h) {
        console.error("Error loading group layers:", h), e?.(r("kartinnhold:errorLoadingLayers"));
      } finally {
        d(!1);
      }
    })();
  }, [c, a, e, l, r]);
  const m = async (g) => {
    if (c)
      try {
        b((h) => {
          const f = [...h], u = f.findIndex((v) => v.id === g);
          if (u >= 0) {
            const v = f[u];
            v.layer ? (c.map && c.map.remove(v.layer), f[u] = {
              ...v,
              layer: void 0
            }) : (b((A) => {
              const p = [...A];
              return p[u] = {
                ...p[u],
                isLoading: !0
              }, p;
            }), tn.fromPortalItem({
              portalItem: new Us({
                id: v.id
              })
            }).then((A) => {
              if (A.blendMode = "multiply", c.map)
                c.map.add(A);
              else
                throw new Error("Map is not available");
              const p = c.watch("updating", () => {
                const S = c.allLayerViews.find((U) => U.layer === A);
                S && !S.updating && (p.remove(), b((U) => {
                  const w = [...U];
                  return w[u] = {
                    ...w[u],
                    layer: A,
                    isLoading: !1
                  }, w;
                }));
              });
            }).catch((A) => {
              console.error("Error adding layer:", A), e?.(r("kartinnhold:errorAddingLayer", { title: v.title }));
            }));
          }
          return f;
        });
      } catch (h) {
        console.error("Error managing layer:", h), e?.(r("kartinnhold:errorManagingLayer"));
      }
  };
  return i ? /* @__PURE__ */ n.jsx("div", { className: ka.centerContainer, children: /* @__PURE__ */ n.jsx(dl, { scale: "s", type: "indeterminate" }) }) : o.length === 0 ? /* @__PURE__ */ n.jsx("div", { className: ka.messageContainer, children: r("kartinnhold:noLayers") }) : /* @__PURE__ */ n.jsx(yl, { selectionMode: "none", children: o.map((g) => /* @__PURE__ */ n.jsxs(
    gl,
    {
      "thumbnail-position": "block-start",
      children: [
        /* @__PURE__ */ n.jsx(
          "img",
          {
            slot: "thumbnail",
            className: ka.thumbnail,
            src: g.thumbnailUrl,
            alt: g.title
          }
        ),
        /* @__PURE__ */ n.jsx("span", { className: ka.cardTitle, slot: "footer-start", children: g.title }),
        /* @__PURE__ */ n.jsx(
          ds,
          {
            scale: "s",
            slot: "footer-end",
            loading: g.isLoading,
            disabled: g.isLoading,
            icon: g.layer ? "minus-circle" : "add-layer",
            onClick: () => m(g.id)
          }
        )
      ]
    },
    g.id
  )) });
}, Oc = "MapItem-module__item___VfsvS", Fc = "MapItem-module__active___wncKR", $c = "MapItem-module__thumbnail___IweqH", Dc = "MapItem-module__card___tWfIb", Bc = "MapItem-module__title___MLNdF", zc = "MapItem-module__image___IkGzb", Gc = "MapItem-module__text___sh1cd", Wc = "MapItem-module__description___XGEsY", $e = {
  item: Oc,
  active: Fc,
  thumbnail: $c,
  card: Dc,
  title: Bc,
  image: zc,
  text: Gc,
  description: Wc
};
function Kc({ title: a, description: e, thumbnailUrl: l, isActive: r, onClick: c, variant: o = "list", role: b, ariaChecked: i, tabIndex: d, id: m }) {
  return /* @__PURE__ */ n.jsxs(
    "button",
    {
      id: m,
      role: b,
      "aria-checked": b === "radio" ? i : void 0,
      tabIndex: d,
      className: `${$e.item} ${o === "card" ? $e.card : ""} ${r ? $e.active : ""}`,
      onClick: c,
      type: "button",
      children: [
        /* @__PURE__ */ n.jsx("div", { className: $e.thumbnail, children: /* @__PURE__ */ n.jsx("img", { src: l, alt: "", className: $e.image }) }),
        /* @__PURE__ */ n.jsxs("div", { className: $e.text, children: [
          /* @__PURE__ */ n.jsx("span", { className: $e.title, children: a }),
          e && /* @__PURE__ */ n.jsx("span", { className: $e.description, children: e })
        ] })
      ]
    }
  );
}
const qc = "ThematicMapSelector-module__centerContainer___MgqzU", Yc = "ThematicMapSelector-module__messageContainer___s34HH", Jc = "ThematicMapSelector-module__gallery___dNrUU", St = {
  centerContainer: qc,
  messageContainer: Yc,
  gallery: Jc
}, Nt = /* @__PURE__ */ new WeakMap(), j0 = ({
  thematicMapsGroupId: a,
  onError: e,
  fallbackThumbnail: l = "public/images/basis terreng.png"
}) => {
  const { t: r } = Pe(["kartinnhold"]), { mapView: c } = He(), [o, b] = x([]), [i, d] = x(!0);
  O(() => {
    if (!c || !a)
      return;
    Nt.has(c) || Nt.set(c, c.map), (async () => {
      try {
        d(!0);
        const u = new Ns();
        await u.load();
        const v = new ws({
          portal: u,
          id: a
        }), A = {
          query: "type:'Web Map'",
          sortField: "title",
          sortOrder: "asc",
          num: 100
        }, S = (await v.queryItems(A)).results.map((U) => {
          if (!U.id || !U.title)
            throw new Error("Invalid portal item: missing id or title");
          const w = U.thumbnailUrl || l;
          return {
            id: U.id,
            title: U.title,
            active: c.map.portalItem?.id === U.id,
            thumbnailUrl: w
          };
        });
        b(S);
      } catch (u) {
        console.error("Error loading thematic maps:", u), e?.("Kunne ikke laste tematiske kart");
      } finally {
        d(!1);
      }
    })();
  }, [c, a, e, l]);
  const m = () => {
    const f = c && Nt.get(c);
    !c || !f || (c.map = f, b((u) => u.map((v) => ({ ...v, active: !1 }))));
  }, g = async (f) => {
    if (c)
      try {
        const u = new sn({
          portalItem: new Us({
            id: f
          })
        });
        await u.load(), c.map = u, b(
          (v) => v.map((A) => ({
            ...A,
            active: A.id === f
          }))
        );
      } catch (u) {
        console.error("Error changing web map:", u), e?.("Kunne ikke bytte til valgt temakart");
      }
  };
  if (i)
    return /* @__PURE__ */ n.jsx("div", { className: St.centerContainer, children: /* @__PURE__ */ n.jsx(Hl, {}) });
  if (o.length === 0)
    return /* @__PURE__ */ n.jsx("div", { className: St.messageContainer, children: r("kartinnhold:noThematicMaps") });
  const h = o.some((f) => f.active);
  return /* @__PURE__ */ n.jsxs("div", { id: "kartinnhold-gallery", className: St.gallery, children: [
    o.map((f) => /* @__PURE__ */ n.jsx(
      Kc,
      {
        title: f.title,
        thumbnailUrl: f.thumbnailUrl,
        isActive: f.active,
        onClick: () => f.active ? m() : g(f.id)
      },
      f.id
    )),
    h && /* @__PURE__ */ n.jsx(hs, { variant: "secondary", size: "sm", onClick: m, children: r("kartinnhold:resetThematicMap") })
  ] });
}, Xc = "AddressSearch-module__wrapper___Lt7Og", Qc = "AddressSearch-module__searchInput___SL0JK", eo = "AddressSearch-module__listbox___SBRWu", ao = "AddressSearch-module__noResults___3zjaP", to = "AddressSearch-module__optionItem___CaFU6", so = "AddressSearch-module__active___7g0Sv", lo = "AddressSearch-module__resultsHeader___yXnWw", no = "AddressSearch-module__indexBadge___-gCz0", De = {
  wrapper: Xc,
  searchInput: Qc,
  listbox: eo,
  noResults: ao,
  optionItem: to,
  active: so,
  resultsHeader: lo,
  indexBadge: no
};
function T0({ input: a, suggestions: e, isFetchingDetails: l, onInputChange: r, onSuggestionClick: c, onHoverChange: o, className: b }) {
  const { t: i } = Pe("common"), [d, m] = x(!1), [g, h] = x(-1), f = K(null), u = "address-search-listbox", v = d && a.length > 0 && !l, A = (p) => {
    switch (p.key) {
      case "ArrowDown":
        p.preventDefault(), h((S) => Math.min(S + 1, e.length - 1));
        break;
      case "ArrowUp":
        p.preventDefault(), h((S) => Math.max(S - 1, 0));
        break;
      case "Enter": {
        const S = g >= 0 ? e[g] : e[0];
        S && (c(S), m(!1), h(-1));
        break;
      }
      case "Escape":
        r(""), m(!1), h(-1), f.current?.blur();
        break;
    }
  };
  return /* @__PURE__ */ n.jsxs(
    "div",
    {
      className: `${De.wrapper}${b ? ` ${b}` : ""}`,
      onBlur: (p) => {
        p.currentTarget.contains(p.relatedTarget) || (m(!1), h(-1));
      },
      children: [
        /* @__PURE__ */ n.jsx(
          Zl,
          {
            ref: f,
            label: i("addressSearch.label"),
            hideLabel: !0,
            size: "md",
            className: De.searchInput,
            prefix: /* @__PURE__ */ n.jsx(Rs, { size: 16 }),
            suffix: a ? /* @__PURE__ */ n.jsx(
              us,
              {
                icon: /* @__PURE__ */ n.jsx(Ds, { size: 14 }),
                label: i("addressSearch.clearLabel"),
                variant: "ghost",
                size: "sm",
                onMouseDown: (p) => p.preventDefault(),
                onClick: () => {
                  r(""), m(!1), h(-1), f.current?.focus();
                }
              }
            ) : void 0,
            role: "combobox",
            "aria-expanded": v,
            "aria-controls": u,
            "aria-activedescendant": g >= 0 ? `address-search-option-${g}` : void 0,
            "aria-autocomplete": "list",
            value: a,
            placeholder: i("addressSearch.placeholder"),
            disabled: l,
            onChange: (p) => {
              r(p.target.value), m(!0), h(-1);
            },
            onFocus: () => m(!0),
            onKeyDown: A,
            autoComplete: "off"
          }
        ),
        v && /* @__PURE__ */ n.jsxs(
          "ul",
          {
            id: u,
            role: "listbox",
            "aria-label": i("addressSearch.suggestionsLabel"),
            className: De.listbox,
            children: [
              e.length === 0 && /* @__PURE__ */ n.jsx("li", { role: "option", "aria-selected": !1, className: De.noResults, children: i("addressSearch.noResults") }),
              e.length > 0 && /* @__PURE__ */ n.jsx("li", { className: De.resultsHeader, children: i("addressSearch.resultsHeader") }),
              e.map((p, S) => /* @__PURE__ */ n.jsx(
                "li",
                {
                  id: `address-search-option-${S}`,
                  role: "option",
                  "aria-selected": S === g,
                  className: De.optionItem,
                  onMouseDown: (U) => U.preventDefault(),
                  children: /* @__PURE__ */ n.jsx(
                    Rl,
                    {
                      title: p.address,
                      prefix: /* @__PURE__ */ n.jsx("span", { className: De.indexBadge, children: S + 1 }),
                      action: /* @__PURE__ */ n.jsx(Pt, { size: 16, color: "var(--text-primary)" }),
                      className: S === g ? De.active : void 0,
                      onClick: () => {
                        c(p), m(!1), h(-1);
                      },
                      onMouseEnter: () => {
                        h(S), o(S);
                      },
                      onMouseLeave: () => o(null)
                    }
                  )
                },
                `${p.text}-${p.x}-${p.y}`
              ))
            ]
          }
        )
      ]
    }
  );
}
const Tt = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  silent: 4
};
function ro(a) {
  return !!a && a in Tt;
}
function co() {
  if (typeof window < "u")
    try {
      const a = new URLSearchParams(window.location.search).get("debug");
      if (a === "verbose" || a === "debug")
        return "debug";
      if (a === "off" || a === "silent")
        return "silent";
      const e = window.localStorage?.getItem("origoLogLevel");
      if (ro(e))
        return e;
    } catch {
    }
  return "info";
}
let oo = co();
function za(a) {
  const e = `[${a}]`, l = (r) => Tt[r] >= Tt[oo];
  return {
    debug: (...r) => {
      l("debug") && console.debug(e, ...r);
    },
    info: (...r) => {
      l("info") && console.info(e, ...r);
    },
    warn: (...r) => {
      l("warn") && console.warn(e, ...r);
    },
    error: (...r) => {
      l("error") && console.error(e, ...r);
    }
  };
}
class mo extends Error {
  constructor(e, l, r) {
    super(e), this.name = "SettingsError", this.errorType = l, Object.assign(this, r);
  }
  /**
   * Creates user-friendly Norwegian error message
   */
  toUserMessage() {
    switch (this.errorType) {
      case "NOT_FOUND":
        return `Kunne ikke finne innstillinger for ${this.itemName || "applikasjonen"}. Kontakt administrator.`;
      case "NETWORK":
        return "Kunne ikke laste innstillinger på grunn av nettverksfeil. Prøv igjen.";
      case "PARSE":
        return "Innstillingene har ugyldig format. Kontakt administrator.";
      case "UNAUTHORIZED":
        return "Du har ikke tilgang til å laste innstillinger. Kontakt administrator.";
      default:
        return "En ukjent feil oppstod ved lasting av innstillinger. Kontakt administrator.";
    }
  }
}
const Ea = za("Auth");
let ga = null;
function io() {
  if (ga !== null)
    return ga;
  const a = window.location.hostname;
  if (a === "localhost" || a === "127.0.0.1") {
    const l = typeof import.meta < "u" && { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 }.VITE_DEV_CUSTOMER, r = l || "mars";
    return l ? Ea.debug(`Development mode: using VITE_DEV_CUSTOMER='${r}'`) : Ea.debug(`Development mode: using default customer '${r}'. Set VITE_DEV_CUSTOMER to override.`), ga = r, r;
  }
  const e = a.split(".");
  if (e.length >= 2) {
    const l = e[1];
    return Ea.debug(`Extracted customer domain from hostname: '${l}'`), ga = l, l;
  }
  return Ea.warn(`Unexpected hostname format: '${a}'. Using hostname as customer domain.`), ga = a, a;
}
const bo = {
  isSignedIn: !1,
  user: void 0,
  status: "idle",
  error: void 0,
  isAuthRequired: !1
}, wt = Qe(
  "auth/checkSignInStatus",
  async ({ authService: a, requireAuth: e }, { rejectWithValue: l }) => {
    try {
      return await a.checkSignInStatus(e);
    } catch (r) {
      return l(r.message);
    }
  }
), Ut = Qe(
  "auth/requireSignIn",
  async ({ authService: a }, { rejectWithValue: e }) => {
    try {
      return await a.requireSignIn();
    } catch (l) {
      return e(l.message);
    }
  }
), vt = Qe(
  "auth/signOut",
  async ({ authService: a }, { rejectWithValue: e }) => {
    try {
      await a.signOut();
    } catch (l) {
      return e(l.message);
    }
  }
), Qs = $a({
  name: "auth",
  initialState: bo,
  reducers: {
    setIsAuthRequired: (a, e) => {
      a.isAuthRequired = e.payload;
    },
    clearAuth: (a) => {
      a.isSignedIn = !1, a.user = void 0, a.status = "idle", a.error = void 0;
    }
  },
  extraReducers: (a) => {
    a.addCase(wt.pending, (e) => {
      e.status = "loading", e.error = void 0;
    }).addCase(wt.fulfilled, (e, l) => {
      e.status = "succeeded", e.isSignedIn = l.payload.isSignedIn, e.user = l.payload.user;
    }).addCase(wt.rejected, (e, l) => {
      e.status = "failed", e.error = l.payload;
    }).addCase(Ut.pending, (e) => {
      e.status = "loading", e.error = void 0;
    }).addCase(Ut.fulfilled, (e, l) => {
      e.status = "succeeded", e.isSignedIn = !0, e.user = l.payload;
    }).addCase(Ut.rejected, (e, l) => {
      e.status = "failed", e.error = l.payload;
    }).addCase(vt.pending, (e) => {
      e.status = "loading";
    }).addCase(vt.fulfilled, (e) => {
      e.status = "idle", e.isSignedIn = !1, e.user = void 0, e.error = void 0;
    }).addCase(vt.rejected, (e, l) => {
      e.status = "failed", e.error = l.payload;
    });
  }
});
Qs.actions;
const yo = Qs.reducer, el = za("tokenSlice"), go = {
  token: void 0,
  expiresAt: void 0,
  isRefreshing: !1,
  lastRefreshError: void 0,
  appName: void 0,
  username: void 0,
  customerName: void 0,
  applicationRoles: []
}, _t = Qe("token/getToken", async ({ tokenProvider: a }) => {
  try {
    return await a.getTokenMetadata?.();
  } catch (e) {
    el.warn("Failed to get token:", e);
    return;
  }
}), xt = Qe(
  "token/refreshToken",
  async ({ tokenProvider: a }) => {
    try {
      return await a.refreshToken(), await a.getTokenMetadata?.();
    } catch (e) {
      el.warn("Failed to refresh token:", e);
      return;
    }
  }
), al = $a({
  name: "token",
  initialState: go,
  reducers: {
    setToken: (a, e) => {
      a.token = e.payload;
    },
    setTokenMetadata: (a, e) => {
      e.payload.token && (a.token = e.payload.token), e.payload.expiresAt && (a.expiresAt = e.payload.expiresAt), e.payload.username && (a.username = e.payload.username), e.payload.customerName && (a.customerName = e.payload.customerName), e.payload.applicationRoles && (a.applicationRoles = e.payload.applicationRoles);
    },
    setAppName: (a, e) => {
      a.appName = e.payload;
    },
    clearToken: (a) => {
      a.token = void 0, a.expiresAt = void 0, a.lastRefreshError = void 0, a.username = void 0, a.customerName = void 0, a.applicationRoles = [];
    }
  },
  extraReducers: (a) => {
    a.addCase(_t.pending, (e) => {
      e.isRefreshing = !0, e.lastRefreshError = void 0;
    }).addCase(_t.fulfilled, (e, l) => {
      e.isRefreshing = !1, l.payload && (e.token = l.payload.token, e.expiresAt = l.payload.expiresAt, e.username = l.payload.username, e.customerName = l.payload.customerName, e.applicationRoles = l.payload.applicationRoles || []);
    }).addCase(_t.rejected, (e, l) => {
      e.isRefreshing = !1, e.lastRefreshError = l.error?.message;
    }).addCase(xt.pending, (e) => {
      e.isRefreshing = !0, e.lastRefreshError = void 0;
    }).addCase(xt.fulfilled, (e, l) => {
      e.isRefreshing = !1, l.payload && (e.token = l.payload.token, e.expiresAt = l.payload.expiresAt, e.username = l.payload.username, e.customerName = l.payload.customerName, e.applicationRoles = l.payload.applicationRoles || []);
    }).addCase(xt.rejected, (e, l) => {
      e.isRefreshing = !1, e.lastRefreshError = l.error?.message;
    });
  }
});
al.actions;
const fo = al.reducer, po = (a) => a.auth.token.token, ho = za("settingsSlice"), uo = {
  settings: void 0,
  isLoading: !1,
  error: void 0
}, as = Qe(
  "settings/loadSettings",
  async ({ settingsService: a, config: e, requireAuth: l }) => {
    try {
      return { settings: await a.loadSettings(e, l) };
    } catch (r) {
      ho.warn("Failed to load settings, using defaults:", r);
      const c = r instanceof mo ? { type: r.errorType, message: r.toUserMessage() } : { type: "UNKNOWN", message: "En ukjent feil oppstod ved lasting av innstillinger." };
      return { settings: e.defaultSettings, error: c };
    }
  }
), tl = $a({
  name: "settings",
  initialState: uo,
  reducers: {
    setSettings: (a, e) => {
      a.settings = e.payload;
    }
  },
  extraReducers: (a) => {
    a.addCase(as.pending, (e) => {
      e.isLoading = !0;
    }).addCase(as.fulfilled, (e, l) => {
      e.isLoading = !1, e.settings = l.payload.settings, e.error = l.payload.error;
    });
  }
});
tl.actions;
const Ao = tl.reducer;
var fa = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ts;
function So() {
  if (ts)
    return fa;
  ts = 1;
  var a = _e, e = Symbol.for("react.element"), l = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, c = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function b(i, d, m) {
    var g, h = {}, f = null, u = null;
    m !== void 0 && (f = "" + m), d.key !== void 0 && (f = "" + d.key), d.ref !== void 0 && (u = d.ref);
    for (g in d)
      r.call(d, g) && !o.hasOwnProperty(g) && (h[g] = d[g]);
    if (i && i.defaultProps)
      for (g in d = i.defaultProps, d)
        h[g] === void 0 && (h[g] = d[g]);
    return { $$typeof: e, type: i, key: f, ref: u, props: h, _owner: c.current };
  }
  return fa.Fragment = l, fa.jsx = b, fa.jsxs = b, fa;
}
var Ma = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ss;
function No() {
  return ss || (ss = 1, process.env.NODE_ENV !== "production" && function() {
    var a = _e, e = Symbol.for("react.element"), l = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), b = Symbol.for("react.provider"), i = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), u = Symbol.for("react.offscreen"), v = Symbol.iterator, A = "@@iterator";
    function p(s) {
      if (s === null || typeof s != "object")
        return null;
      var y = v && s[v] || s[A];
      return typeof y == "function" ? y : null;
    }
    var S = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function U(s) {
      {
        for (var y = arguments.length, N = new Array(y > 1 ? y - 1 : 0), _ = 1; _ < y; _++)
          N[_ - 1] = arguments[_];
        w("error", s, N);
      }
    }
    function w(s, y, N) {
      {
        var _ = S.ReactDebugCurrentFrame, j = _.getStackAddendum();
        j !== "" && (y += "%s", N = N.concat([j]));
        var R = N.map(function(k) {
          return String(k);
        });
        R.unshift("Warning: " + y), Function.prototype.apply.call(console[s], console, R);
      }
    }
    var V = !1, J = !1, M = !1, X = !1, Z = !1, T;
    T = Symbol.for("react.module.reference");
    function P(s) {
      return !!(typeof s == "string" || typeof s == "function" || s === r || s === o || Z || s === c || s === m || s === g || X || s === u || V || J || M || typeof s == "object" && s !== null && (s.$$typeof === f || s.$$typeof === h || s.$$typeof === b || s.$$typeof === i || s.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      s.$$typeof === T || s.getModuleId !== void 0));
    }
    function E(s, y, N) {
      var _ = s.displayName;
      if (_)
        return _;
      var j = y.displayName || y.name || "";
      return j !== "" ? N + "(" + j + ")" : N;
    }
    function I(s) {
      return s.displayName || "Context";
    }
    function F(s) {
      if (s == null)
        return null;
      if (typeof s.tag == "number" && U("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof s == "function")
        return s.displayName || s.name || null;
      if (typeof s == "string")
        return s;
      switch (s) {
        case r:
          return "Fragment";
        case l:
          return "Portal";
        case o:
          return "Profiler";
        case c:
          return "StrictMode";
        case m:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case i:
            var y = s;
            return I(y) + ".Consumer";
          case b:
            var N = s;
            return I(N._context) + ".Provider";
          case d:
            return E(s, s.render, "ForwardRef");
          case h:
            var _ = s.displayName || null;
            return _ !== null ? _ : F(s.type) || "Memo";
          case f: {
            var j = s, R = j._payload, k = j._init;
            try {
              return F(k(R));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ne = 0, z, W, ie, ue, Ze, je, H;
    function ge() {
    }
    ge.__reactDisabledLog = !0;
    function Re() {
      {
        if (ne === 0) {
          z = console.log, W = console.info, ie = console.warn, ue = console.error, Ze = console.group, je = console.groupCollapsed, H = console.groupEnd;
          var s = {
            configurable: !0,
            enumerable: !0,
            value: ge,
            writable: !0
          };
          Object.defineProperties(console, {
            info: s,
            log: s,
            warn: s,
            error: s,
            group: s,
            groupCollapsed: s,
            groupEnd: s
          });
        }
        ne++;
      }
    }
    function Oe() {
      {
        if (ne--, ne === 0) {
          var s = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, s, {
              value: z
            }),
            info: q({}, s, {
              value: W
            }),
            warn: q({}, s, {
              value: ie
            }),
            error: q({}, s, {
              value: ue
            }),
            group: q({}, s, {
              value: Ze
            }),
            groupCollapsed: q({}, s, {
              value: je
            }),
            groupEnd: q({}, s, {
              value: H
            })
          });
        }
        ne < 0 && U("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var xe = S.ReactCurrentDispatcher, Le;
    function Ce(s, y, N) {
      {
        if (Le === void 0)
          try {
            throw Error();
          } catch (j) {
            var _ = j.stack.trim().match(/\n( *(at )?)/);
            Le = _ && _[1] || "";
          }
        return `
` + Le + s;
      }
    }
    var Ie = !1, ke;
    {
      var ea = typeof WeakMap == "function" ? WeakMap : Map;
      ke = new ea();
    }
    function C(s, y) {
      if (!s || Ie)
        return "";
      {
        var N = ke.get(s);
        if (N !== void 0)
          return N;
      }
      var _;
      Ie = !0;
      var j = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var R;
      R = xe.current, xe.current = null, Re();
      try {
        if (y) {
          var k = function() {
            throw Error();
          };
          if (Object.defineProperty(k.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(k, []);
            } catch (se) {
              _ = se;
            }
            Reflect.construct(s, [], k);
          } else {
            try {
              k.call();
            } catch (se) {
              _ = se;
            }
            s.call(k.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (se) {
            _ = se;
          }
          s();
        }
      } catch (se) {
        if (se && _ && typeof se.stack == "string") {
          for (var L = se.stack.split(`
`), ae = _.stack.split(`
`), $ = L.length - 1, B = ae.length - 1; $ >= 1 && B >= 0 && L[$] !== ae[B]; )
            B--;
          for (; $ >= 1 && B >= 0; $--, B--)
            if (L[$] !== ae[B]) {
              if ($ !== 1 || B !== 1)
                do
                  if ($--, B--, B < 0 || L[$] !== ae[B]) {
                    var re = `
` + L[$].replace(" at new ", " at ");
                    return s.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", s.displayName)), typeof s == "function" && ke.set(s, re), re;
                  }
                while ($ >= 1 && B >= 0);
              break;
            }
        }
      } finally {
        Ie = !1, xe.current = R, Oe(), Error.prepareStackTrace = j;
      }
      var we = s ? s.displayName || s.name : "", fe = we ? Ce(we) : "";
      return typeof s == "function" && ke.set(s, fe), fe;
    }
    function Y(s, y, N) {
      return C(s, !1);
    }
    function te(s) {
      var y = s.prototype;
      return !!(y && y.isReactComponent);
    }
    function Q(s, y, N) {
      if (s == null)
        return "";
      if (typeof s == "function")
        return C(s, te(s));
      if (typeof s == "string")
        return Ce(s);
      switch (s) {
        case m:
          return Ce("Suspense");
        case g:
          return Ce("SuspenseList");
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case d:
            return Y(s.render);
          case h:
            return Q(s.type, y, N);
          case f: {
            var _ = s, j = _._payload, R = _._init;
            try {
              return Q(R(j), y, N);
            } catch {
            }
          }
        }
      return "";
    }
    var ee = Object.prototype.hasOwnProperty, oe = {}, Ae = S.ReactDebugCurrentFrame;
    function Se(s) {
      if (s) {
        var y = s._owner, N = Q(s.type, s._source, y ? y.type : null);
        Ae.setExtraStackFrame(N);
      } else
        Ae.setExtraStackFrame(null);
    }
    function aa(s, y, N, _, j) {
      {
        var R = Function.call.bind(ee);
        for (var k in s)
          if (R(s, k)) {
            var L = void 0;
            try {
              if (typeof s[k] != "function") {
                var ae = Error((_ || "React class") + ": " + N + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ae.name = "Invariant Violation", ae;
              }
              L = s[k](y, k, _, N, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch ($) {
              L = $;
            }
            L && !(L instanceof Error) && (Se(j), U("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", _ || "React class", N, k, typeof L), Se(null)), L instanceof Error && !(L.message in oe) && (oe[L.message] = !0, Se(j), U("Failed %s type: %s", N, L.message), Se(null));
          }
      }
    }
    var D = Array.isArray;
    function ye(s) {
      return D(s);
    }
    function G(s) {
      {
        var y = typeof Symbol == "function" && Symbol.toStringTag, N = y && s[Symbol.toStringTag] || s.constructor.name || "Object";
        return N;
      }
    }
    function Ue(s) {
      try {
        return Fe(s), !1;
      } catch {
        return !0;
      }
    }
    function Fe(s) {
      return "" + s;
    }
    function ta(s) {
      if (Ue(s))
        return U("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", G(s)), Fe(s);
    }
    var Ee = S.ReactCurrentOwner, Ga = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, sa, la, ze;
    ze = {};
    function Wa(s) {
      if (ee.call(s, "ref")) {
        var y = Object.getOwnPropertyDescriptor(s, "ref").get;
        if (y && y.isReactWarning)
          return !1;
      }
      return s.ref !== void 0;
    }
    function Ka(s) {
      if (ee.call(s, "key")) {
        var y = Object.getOwnPropertyDescriptor(s, "key").get;
        if (y && y.isReactWarning)
          return !1;
      }
      return s.key !== void 0;
    }
    function qa(s, y) {
      if (typeof s.ref == "string" && Ee.current && y && Ee.current.stateNode !== y) {
        var N = F(Ee.current.type);
        ze[N] || (U('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', F(Ee.current.type), s.ref), ze[N] = !0);
      }
    }
    function Ya(s, y) {
      {
        var N = function() {
          sa || (sa = !0, U("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", y));
        };
        N.isReactWarning = !0, Object.defineProperty(s, "key", {
          get: N,
          configurable: !0
        });
      }
    }
    function Ja(s, y) {
      {
        var N = function() {
          la || (la = !0, U("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", y));
        };
        N.isReactWarning = !0, Object.defineProperty(s, "ref", {
          get: N,
          configurable: !0
        });
      }
    }
    var Xa = function(s, y, N, _, j, R, k) {
      var L = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: s,
        key: y,
        ref: N,
        props: k,
        // Record the component responsible for creating this element.
        _owner: R
      };
      return L._store = {}, Object.defineProperty(L._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(L, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: _
      }), Object.defineProperty(L, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: j
      }), Object.freeze && (Object.freeze(L.props), Object.freeze(L)), L;
    };
    function Qa(s, y, N, _, j) {
      {
        var R, k = {}, L = null, ae = null;
        N !== void 0 && (ta(N), L = "" + N), Ka(y) && (ta(y.key), L = "" + y.key), Wa(y) && (ae = y.ref, qa(y, j));
        for (R in y)
          ee.call(y, R) && !Ga.hasOwnProperty(R) && (k[R] = y[R]);
        if (s && s.defaultProps) {
          var $ = s.defaultProps;
          for (R in $)
            k[R] === void 0 && (k[R] = $[R]);
        }
        if (L || ae) {
          var B = typeof s == "function" ? s.displayName || s.name || "Unknown" : s;
          L && Ya(k, B), ae && Ja(k, B);
        }
        return Xa(s, L, ae, j, _, Ee.current, k);
      }
    }
    var Ge = S.ReactCurrentOwner, na = S.ReactDebugCurrentFrame;
    function Ne(s) {
      if (s) {
        var y = s._owner, N = Q(s.type, s._source, y ? y.type : null);
        na.setExtraStackFrame(N);
      } else
        na.setExtraStackFrame(null);
    }
    var We;
    We = !1;
    function Ke(s) {
      return typeof s == "object" && s !== null && s.$$typeof === e;
    }
    function ra() {
      {
        if (Ge.current) {
          var s = F(Ge.current.type);
          if (s)
            return `

Check the render method of \`` + s + "`.";
        }
        return "";
      }
    }
    function et(s) {
      {
        if (s !== void 0) {
          var y = s.fileName.replace(/^.*[\\\/]/, ""), N = s.lineNumber;
          return `

Check your code at ` + y + ":" + N + ".";
        }
        return "";
      }
    }
    var ca = {};
    function at(s) {
      {
        var y = ra();
        if (!y) {
          var N = typeof s == "string" ? s : s.displayName || s.name;
          N && (y = `

Check the top-level render call using <` + N + ">.");
        }
        return y;
      }
    }
    function oa(s, y) {
      {
        if (!s._store || s._store.validated || s.key != null)
          return;
        s._store.validated = !0;
        var N = at(y);
        if (ca[N])
          return;
        ca[N] = !0;
        var _ = "";
        s && s._owner && s._owner !== Ge.current && (_ = " It was passed a child from " + F(s._owner.type) + "."), Ne(s), U('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', N, _), Ne(null);
      }
    }
    function ma(s, y) {
      {
        if (typeof s != "object")
          return;
        if (ye(s))
          for (var N = 0; N < s.length; N++) {
            var _ = s[N];
            Ke(_) && oa(_, y);
          }
        else if (Ke(s))
          s._store && (s._store.validated = !0);
        else if (s) {
          var j = p(s);
          if (typeof j == "function" && j !== s.entries)
            for (var R = j.call(s), k; !(k = R.next()).done; )
              Ke(k.value) && oa(k.value, y);
        }
      }
    }
    function tt(s) {
      {
        var y = s.type;
        if (y == null || typeof y == "string")
          return;
        var N;
        if (typeof y == "function")
          N = y.propTypes;
        else if (typeof y == "object" && (y.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        y.$$typeof === h))
          N = y.propTypes;
        else
          return;
        if (N) {
          var _ = F(y);
          aa(N, s.props, "prop", _, s);
        } else if (y.PropTypes !== void 0 && !We) {
          We = !0;
          var j = F(y);
          U("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", j || "Unknown");
        }
        typeof y.getDefaultProps == "function" && !y.getDefaultProps.isReactClassApproved && U("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function st(s) {
      {
        for (var y = Object.keys(s.props), N = 0; N < y.length; N++) {
          var _ = y[N];
          if (_ !== "children" && _ !== "key") {
            Ne(s), U("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", _), Ne(null);
            break;
          }
        }
        s.ref !== null && (Ne(s), U("Invalid attribute `ref` supplied to `React.Fragment`."), Ne(null));
      }
    }
    var ia = {};
    function ba(s, y, N, _, j, R) {
      {
        var k = P(s);
        if (!k) {
          var L = "";
          (s === void 0 || typeof s == "object" && s !== null && Object.keys(s).length === 0) && (L += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ae = et(j);
          ae ? L += ae : L += ra();
          var $;
          s === null ? $ = "null" : ye(s) ? $ = "array" : s !== void 0 && s.$$typeof === e ? ($ = "<" + (F(s.type) || "Unknown") + " />", L = " Did you accidentally export a JSX literal instead of a component?") : $ = typeof s, U("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", $, L);
        }
        var B = Qa(s, y, N, j, R);
        if (B == null)
          return B;
        if (k) {
          var re = y.children;
          if (re !== void 0)
            if (_)
              if (ye(re)) {
                for (var we = 0; we < re.length; we++)
                  ma(re[we], s);
                Object.freeze && Object.freeze(re);
              } else
                U("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ma(re, s);
        }
        if (ee.call(y, "key")) {
          var fe = F(s), se = Object.keys(y).filter(function(mt) {
            return mt !== "key";
          }), qe = se.length > 0 ? "{key: someKey, " + se.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ia[fe + qe]) {
            var ot = se.length > 0 ? "{" + se.join(": ..., ") + ": ...}" : "{}";
            U(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, qe, fe, ot, fe), ia[fe + qe] = !0;
          }
        }
        return s === r ? st(B) : tt(B), B;
      }
    }
    function lt(s, y, N) {
      return ba(s, y, N, !0);
    }
    function nt(s, y, N) {
      return ba(s, y, N, !1);
    }
    var rt = nt, ct = lt;
    Ma.Fragment = r, Ma.jsx = rt, Ma.jsxs = ct;
  }()), Ma;
}
process.env.NODE_ENV === "production" ? So() : No();
pl({
  auth: yo,
  token: fo,
  settings: Ao
});
const ls = 25833, wo = /^\d+\s*\/\s*\d+/, Uo = /^(\d{3,4})[\s-]+(\d+\s*\/\s*\d+.*)$/, vo = (a) => wo.test(a.trim()), sl = (a) => {
  const e = a.trim(), l = e.match(Uo);
  return l ? { query: l[2], kommunenr: l[1].padStart(4, "0") } : { query: e };
}, _o = (a) => [a.gardsnr, a.bruksnr, a.festenr || void 0, a.seksjonsnr || void 0].filter((l) => l !== void 0).join("/"), xo = (a) => {
  const e = new URLSearchParams();
  return Object.entries(a).forEach(([l, r]) => {
    r != null && r !== "" && e.set(l, String(r));
  }), e;
}, Lo = {
  async fetchSuggestions(a, e, l, r, c, o) {
    const { query: b, kommunenr: i } = sl(a), d = vo(b) ? "eiendom" : "adresse", m = d === "eiendom" ? b : a, g = i ? { ...c, filter_kommunenavn: "", filter_kommunenr: i } : c, h = xo({ query: m, token: e, maxsize: String(r), filter_kilde: d, ...g }), f = `${l}?${h.toString()}`, u = await fetch(f, { signal: o });
    if (!u.ok)
      throw new Error("Failed to fetch suggestions");
    const v = await u.json();
    if (d === "eiendom") {
      const A = g?.filter_kommunenavn?.toLowerCase();
      return (v.hits ?? []).filter((p) => !A || p.kommunenavn?.toLowerCase().includes(A)).map((p) => {
        if (typeof p.x != "number" || typeof p.y != "number" || p.gardsnr === void 0 || p.bruksnr === void 0)
          return null;
        const S = _o(p), U = p.kommunenavn ?? "";
        return {
          text: [S, U].filter(Boolean).join(", "),
          address: S,
          postalCode: "",
          postalArea: U,
          x: p.x,
          y: p.y,
          wkid: ls,
          gnr: p.gardsnr,
          bnr: p.bruksnr,
          fnr: p.festenr,
          snr: p.seksjonsnr,
          kommunenr: p.kommunenr != null ? String(p.kommunenr) : void 0
        };
      }).filter((p) => !!p);
    }
    return (v.hits ?? []).map((A) => {
      if (typeof A.x != "number" || typeof A.y != "number")
        return null;
      const p = A.postnr ?? "", S = A.poststed ?? "", U = A.adresse ?? `${A.gatenavn ?? ""} ${A.husnrbokstav ?? `${A.husnr ?? ""}${A.husbokstav ?? ""}`.trim()}`.trim(), w = [U, `${p} ${S}`.trim()].filter(Boolean).join(", ");
      return w ? {
        text: w,
        address: U,
        postalCode: p,
        postalArea: S,
        x: A.x,
        y: A.y,
        wkid: ls,
        adresseId: A.adresseid
      } : null;
    }).filter((A) => A !== null);
  }
}, ns = (a) => a.toLowerCase().normalize("NFKD").replace(/[^\p{L}\p{N}]+/gu, " ").trim(), Lt = za("useAddressSearch"), rs = {
  mars: "Fredrikstad",
  venus: "Nesodden"
}, Co = (a) => {
  if (a && !(a.toLowerCase() in rs))
    return a;
  const e = io();
  return rs[e] ?? e;
}, ko = "https://services.geodataonline.no/arcgis/rest/services/ProxyServices/search/adresse", H0 = ({ searchApiUrl: a = ko, minChars: e = 2, maxResults: l = 4, kommunenavn: r, onValidateLocation: c, matrikkelClient: o }) => {
  const [b, i] = x(""), [d, m] = x([]), [g, h] = x(!1), [f, u] = x(null), [v, A] = x(!1), [p, S] = x(!1), U = K(null), w = Ht(po), V = ce(
    async (Z) => {
      try {
        const T = new Ra({ x: Z.x, y: Z.y, spatialReference: { wkid: Z.wkid } });
        let P;
        if (o) {
          const E = o;
          if (E.getMatrikkelEnhetFromGeometry) {
            const I = await E.getMatrikkelEnhetFromGeometry(T);
            P = (Array.isArray(I) ? I : [])[0];
          }
        }
        return {
          ...Z,
          matrikkelEnhet: P ? { ...P, kommunenr: String(P.kommunenr) } : void 0
        };
      } catch (T) {
        return Lt.error("Matrikkel lookup failed", T), null;
      }
    },
    [o]
  ), J = ce(
    (Z) => {
      const T = Z.trim(), P = !!w && T.length >= e;
      i(Z), u(null), m([]), h(!1), A(P), U.current && clearTimeout(U.current), U.current = setTimeout(async () => {
        if (!P || !w) {
          m([]), h(!1), A(!1);
          return;
        }
        try {
          const E = await Lo.fetchSuggestions(Z, w, a, l, { filter_kommunenavn: Co(r) }), { query: I } = sl(Z), F = ns(I).split(/\s+/).filter(Boolean), q = E.filter((ne) => {
            const z = ns(ne.text ?? "");
            return F.every((W) => z.includes(W));
          });
          m(q);
        } catch (E) {
          E.name !== "AbortError" && (Lt.error("Suggestions error", E), m([]));
        } finally {
          A(!1), h(!0);
        }
      }, 500);
    },
    [w, a, e, l, r]
  ), M = ce(
    async (Z) => {
      try {
        const T = {
          selected: !0,
          id: Z.adresseId != null ? String(Z.adresseId) : void 0,
          name: Z.text,
          address: Z.address,
          postalCode: Z.postalCode,
          postalArea: Z.postalArea,
          x: Z.x,
          y: Z.y,
          wkid: Z.wkid
        }, P = await V(T);
        return !P || c && !await c(P) ? null : P;
      } catch (T) {
        return T.name !== "AbortError" && Lt.error("Error fetching address details:", T), null;
      }
    },
    [V, c]
  ), X = ce((Z) => {
    i(Z.address ?? ""), u(Z), m([]), h(!1);
  }, []);
  return {
    input: b,
    setInput: i,
    suggestions: d,
    hasFetchedSuggestions: g,
    selectedSuggestion: f,
    isLoading: v,
    isFetchingDetails: p,
    setIsFetchingDetails: S,
    handleInputChange: J,
    handleSuggestionClick: X,
    fetchAddressDetailsFromSuggestion: M
  };
}, Eo = "VersionInfo-module__headerButton___9pT0V", Mo = "VersionInfo-module__footerLink___2Y7St", jo = "VersionInfo-module__notice___je-0O", To = "VersionInfo-module__noticeButton___ZGSac", Ho = "VersionInfo-module__dialogMeta___akGsY", Zo = "VersionInfo-module__versionLine___BG1s6", Ro = "VersionInfo-module__commit___t0UtV", Io = "VersionInfo-module__buildDate___MKUGB", Vo = "VersionInfo-module__changelogTitle___bnj-w", Po = "VersionInfo-module__introText___7w45N", Oo = "VersionInfo-module__entries___6gHwp", Fo = "VersionInfo-module__entry___VEyTs", $o = "VersionInfo-module__entryHeader___HTZHe", Do = "VersionInfo-module__entryVersion___7YAYZ", Bo = "VersionInfo-module__entryDate___NSX41", zo = "VersionInfo-module__section___-zx9O", Go = "VersionInfo-module__sectionHeading___NcjpI", Wo = "VersionInfo-module__itemList___W9JnR", de = {
  headerButton: Eo,
  footerLink: Mo,
  notice: jo,
  noticeButton: To,
  dialogMeta: Ho,
  versionLine: Zo,
  commit: Ro,
  buildDate: Io,
  changelogTitle: Vo,
  introText: Po,
  entries: Oo,
  entry: Fo,
  entryHeader: $o,
  entryVersion: Do,
  entryDate: Bo,
  section: zo,
  sectionHeading: Go,
  itemList: Wo
};
function Z0({ placement: a = "footer", appName: e, onClick: l }) {
  return a === "header" ? /* @__PURE__ */ n.jsxs(
    "button",
    {
      type: "button",
      className: de.headerButton,
      onClick: l,
      "aria-label": "Vis versjonsinformasjon og endringslogg",
      children: [
        /* @__PURE__ */ n.jsx(Ba, { size: 14, weight: "regular", "aria-hidden": "true" }),
        /* @__PURE__ */ n.jsxs("span", { children: [
          "v",
          __APP_VERSION__
        ] })
      ]
    }
  ) : /* @__PURE__ */ n.jsx(
    "button",
    {
      type: "button",
      className: de.footerLink,
      onClick: l,
      "aria-label": `Vis versjonsinformasjon og endringslogg${e ? ` for ${e}` : ""}`,
      children: e ? `${e} v${__APP_VERSION__}` : `v${__APP_VERSION__}`
    }
  );
}
const Ko = /^##\s*\[?([^\]\s]+)\]?\s*[–-]\s*(.+?)\s*$/, qo = /^###\s+(.+?)\s*$/, Yo = /^[-*]\s+(.+?)\s*$/;
function Jo(a) {
  const e = [];
  let l = null, r = null;
  for (const c of a.split(/\r?\n/)) {
    const o = c.trim(), b = o.match(Ko);
    if (b) {
      l = { version: b[1], date: b[2], sections: [] }, e.push(l), r = null;
      continue;
    }
    if (!l)
      continue;
    const i = o.match(qo);
    if (i) {
      r = { heading: i[1], items: [] }, l.sections.push(r);
      continue;
    }
    const d = o.match(Yo);
    d && r && r.items.push(d[1]);
  }
  return e;
}
function Xo(a) {
  return a.split(/\*\*(.+?)\*\*/).map((l, r) => r % 2 === 1 ? /* @__PURE__ */ n.jsx("strong", { children: l }, r) : l);
}
function Qo(a, e) {
  const l = new Date(a);
  return Number.isNaN(l.getTime()) ? a : e === "long" ? l.toLocaleDateString("nb-NO", { day: "numeric", month: "long", year: "numeric" }) : l.toLocaleDateString("nb-NO", { day: "2-digit", month: "2-digit", year: "numeric" });
}
function R0({
  open: a,
  onClose: e,
  appName: l,
  changelogMarkdown: r,
  introText: c,
  showCommit: o = !0,
  buildDateLabel: b = "Bygget",
  buildDateFormat: i = "short"
}) {
  const d = Jo(r);
  return /* @__PURE__ */ n.jsxs(Il, { open: a, onClose: e, title: `Om ${l}`, children: [
    /* @__PURE__ */ n.jsxs("div", { className: de.dialogMeta, children: [
      /* @__PURE__ */ n.jsxs("div", { className: de.versionLine, children: [
        /* @__PURE__ */ n.jsxs("strong", { children: [
          "Versjon ",
          __APP_VERSION__
        ] }),
        o && /* @__PURE__ */ n.jsxs("span", { className: de.commit, children: [
          "(",
          __APP_COMMIT__,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ n.jsxs("div", { className: de.buildDate, children: [
        b,
        " ",
        Qo(__APP_BUILD_DATE__, i)
      ] })
    ] }),
    /* @__PURE__ */ n.jsx("h3", { className: de.changelogTitle, children: "Endringslogg" }),
    c && /* @__PURE__ */ n.jsx("p", { className: de.introText, children: c }),
    d.length === 0 ? c ? null : /* @__PURE__ */ n.jsx("p", { children: "Ingen endringer registrert ennå." }) : /* @__PURE__ */ n.jsx("ol", { className: de.entries, children: d.map((m) => /* @__PURE__ */ n.jsxs("li", { className: de.entry, children: [
      /* @__PURE__ */ n.jsxs("header", { className: de.entryHeader, children: [
        /* @__PURE__ */ n.jsx("span", { className: de.entryVersion, children: m.version }),
        /* @__PURE__ */ n.jsx("span", { className: de.entryDate, children: m.date })
      ] }),
      m.sections.map((g) => /* @__PURE__ */ n.jsxs("div", { className: de.section, children: [
        /* @__PURE__ */ n.jsx("h4", { className: de.sectionHeading, children: g.heading }),
        /* @__PURE__ */ n.jsx("ul", { className: de.itemList, children: g.items.map((h, f) => /* @__PURE__ */ n.jsx("li", { children: Xo(h) }, f)) })
      ] }, g.heading))
    ] }, m.version)) })
  ] });
}
function I0({ onOpenChangelog: a, onDismiss: e }) {
  return /* @__PURE__ */ n.jsxs(As, { variant: "info", className: de.notice, onDismiss: e, children: [
    "Ny versjon (",
    __APP_VERSION__,
    ") er rullet ut.",
    " ",
    /* @__PURE__ */ n.jsx("button", { type: "button", className: de.noticeButton, onClick: a, children: "Se hva som er nytt" })
  ] });
}
function V0(a) {
  const [e, l] = x(!1);
  return O(() => {
    try {
      const c = window.localStorage.getItem(a);
      c && c !== __APP_VERSION__ ? l(!0) : c || window.localStorage.setItem(a, __APP_VERSION__);
    } catch {
    }
  }, [a]), { hasNewVersion: e, dismiss: () => {
    try {
      window.localStorage.setItem(a, __APP_VERSION__);
    } catch {
    }
    l(!1);
  } };
}
const em = "SearchSuggestionLayer-module__popup___ltkFS", am = "SearchSuggestionLayer-module__popupArrow___LHemA", tm = "SearchSuggestionLayer-module__popupArrowFlipped___RvYFW", ja = {
  popup: em,
  popupArrow: am,
  popupArrowFlipped: tm
}, pa = 8, cs = 10, Ct = 28, sm = ({ anchorX: a, anchorY: e, container: l, children: r }) => {
  const c = K(null), [o, b] = x(null);
  return bs(() => {
    if (!c.current)
      return;
    const i = c.current.offsetWidth, d = c.current.offsetHeight, m = l.offsetWidth, g = l.offsetHeight, h = a - i / 2, f = Math.max(pa, Math.min(h, m - i - pa)), u = e - d - Ct < pa, v = u ? Math.min(e + Ct, g - d - pa) : Math.max(pa, e - d - Ct), A = Math.max(cs, Math.min(a - f, i - cs));
    b({ left: f, top: v, arrowLeft: A, flipped: u });
  }, [a, e, l]), /* @__PURE__ */ n.jsxs(
    "div",
    {
      ref: c,
      className: ja.popup,
      style: o ? { left: o.left, top: o.top } : { visibility: "hidden", left: a, top: e },
      children: [
        r,
        /* @__PURE__ */ n.jsx(
          "span",
          {
            className: o?.flipped ? `${ja.popupArrow} ${ja.popupArrowFlipped}` : ja.popupArrow,
            style: { left: o ? o.arrowLeft : void 0 }
          }
        )
      ]
    }
  );
}, Ta = 200;
function lm(a, e) {
  const l = a.map((c) => c.x), r = a.map((c) => c.y);
  return new ln({
    xmin: Math.min(...l) - Ta,
    ymin: Math.min(...r) - Ta,
    xmax: Math.max(...l) + Ta,
    ymax: Math.max(...r) + Ta,
    spatialReference: { wkid: e }
  });
}
function nm(a) {
  const e = String(a + 1), l = 24, r = 3, c = l * r, o = `<svg xmlns="http://www.w3.org/2000/svg" width="${c}" height="${c}" viewBox="0 0 ${c} ${c}">
        <circle cx="${c / 2}" cy="${c / 2}" r="${c / 2 - r}" fill="#0037F8" stroke="white" stroke-width="${2 * r}"/>
        <text x="${c / 2}" y="${c / 2}" text-anchor="middle" dominant-baseline="central" fill="white" font-size="${12 * r}" font-family="sans-serif" font-weight="bold">${e}</text>
    </svg>`;
  return {
    type: "picture-marker",
    url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(o)}`,
    width: l,
    height: l
  };
}
function os(a) {
  const e = String(a + 1), l = 32, r = 3, c = l * r, o = c / 2, b = c / 2 - r, i = b - 4 * r, d = `<svg xmlns="http://www.w3.org/2000/svg" width="${c}" height="${c}" viewBox="0 0 ${c} ${c}">
        <defs>
            <filter id="shadow" x="-30%" y="-30%" width="160%" height="160%">
                <feDropShadow dx="0" dy="${r}" stdDeviation="${2 * r}" flood-color="rgba(0,0,0,0.35)"/>
            </filter>
        </defs>
        <circle cx="${o}" cy="${o}" r="${b}" fill="white" filter="url(#shadow)"/>
        <circle cx="${o}" cy="${o}" r="${i}" fill="#0037F8"/>
        <text x="${o}" y="${o}" text-anchor="middle" dominant-baseline="central" fill="white" font-size="${12 * r}" font-family="sans-serif" font-weight="bold">${e}</text>
    </svg>`;
  return {
    type: "picture-marker",
    url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(d)}`,
    width: l,
    height: l
  };
}
function rm(a) {
  const e = String(a + 1), l = 24, r = 3, c = l * r, o = `<svg xmlns="http://www.w3.org/2000/svg" width="${c}" height="${c}" viewBox="0 0 ${c} ${c}">
        <circle cx="${c / 2}" cy="${c / 2}" r="${c / 2 - r}" fill="#B0B7C3" stroke="white" stroke-width="${2 * r}"/>
        <text x="${c / 2}" y="${c / 2}" text-anchor="middle" dominant-baseline="central" fill="white" font-size="${12 * r}" font-family="sans-serif" font-weight="bold">${e}</text>
    </svg>`;
  return {
    type: "picture-marker",
    url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(o)}`,
    width: l,
    height: l
  };
}
function P0({
  suggestions: a,
  hoveredIndex: e,
  paddingLeft: l = 0,
  onPinHit: r,
  onPinClick: c,
  onPopupDismiss: o,
  onMapClick: b,
  renderPopupContent: i
}) {
  const { graphicsLayer: d, mapView: m } = He(), [g, h] = x(null), f = _e.useRef(g);
  O(() => {
    f.current = g;
  }, [g]);
  const [u, v] = x(null), A = _e.useRef([]), p = _e.useCallback(() => {
    !d || A.current.length === 0 || (A.current.forEach((Z) => d.remove(Z)), A.current = []);
  }, [d]);
  O(() => {
    h(null), v(null);
  }, [a]), O(() => {
    if (m)
      return m.padding = { left: l }, () => {
        m.padding = { left: 0 };
      };
  }, [m, l]), O(() => {
    if (d && (p(), a.length !== 0))
      return a.forEach((Z, T) => {
        let P;
        g !== null ? P = T === g ? os(T) : rm(T) : T === e ? P = os(T) : P = nm(T);
        const E = new nn({
          geometry: new La({ x: Z.x, y: Z.y, spatialReference: { wkid: Z.wkid } }),
          symbol: P,
          attributes: { pinIndex: T }
        });
        d.add(E), A.current.push(E);
      }), () => {
        p();
      };
  }, [a, e, g, d, p]), O(() => {
    if (a.length === 0 || !m)
      return;
    const Z = a.map(
      (T) => new La({ x: T.x, y: T.y, spatialReference: { wkid: T.wkid } })
    );
    m.goTo(lm(Z, a[0].wkid));
  }, [a, m]);
  const S = _e.useRef(r), U = _e.useRef(c), w = _e.useRef(o), V = _e.useRef(b), J = _e.useRef(i);
  O(() => {
    S.current = r;
  }, [r]), O(() => {
    U.current = c;
  }, [c]), O(() => {
    w.current = o;
  }, [o]), O(() => {
    V.current = b;
  }, [b]), O(() => {
    J.current = i;
  }, [i]), O(() => {
    if (!m || !d)
      return;
    const Z = m.on("click", async (T) => {
      const E = (await m.hitTest(T, { include: [d] })).results.find((I) => I.type === "graphic");
      if (E && A.current.includes(E.graphic)) {
        const I = E.graphic.attributes?.pinIndex, F = a[I];
        if (F != null)
          if (S.current?.(), J.current) {
            h(I);
            const q = m.toScreen(
              new La({ x: F.x, y: F.y, spatialReference: { wkid: F.wkid } })
            );
            q && v({ x: q.x, y: q.y });
          } else
            U.current?.(F);
      } else if (f.current !== null && a[f.current]) {
        const I = a[f.current];
        h(null), v(null), w.current?.(I);
      } else
        h(null), v(null), V.current?.();
    });
    return () => Z.remove();
  }, [m, d, a]), O(() => {
    if (!m || g === null)
      return;
    const Z = m.watch("extent", () => {
      const T = a[g];
      if (!T)
        return;
      const P = m.toScreen(
        new La({ x: T.x, y: T.y, spatialReference: { wkid: T.wkid } })
      );
      P && v({ x: P.x, y: P.y });
    });
    return () => Z.remove();
  }, [m, g, a]);
  const M = m?.container instanceof HTMLElement ? m.container : null, X = g !== null ? a[g] : null;
  return !i || !M || !X || !u ? null : vs(
    /* @__PURE__ */ n.jsx(sm, { anchorX: u.x, anchorY: u.y, container: M, children: i(X) }),
    M
  );
}
const cm = "Toaster-module__container___azaFy", om = "Toaster-module__slide-in___zkFuc", mm = {
  container: cm,
  slideIn: om
};
function O0({
  message: a,
  open: e,
  onClose: l,
  variant: r = "info",
  icon: c,
  autoCloseDuration: o = 4e3
}) {
  return e ? vs(
    /* @__PURE__ */ n.jsx("div", { className: mm.container, children: /* @__PURE__ */ n.jsx(
      Ss,
      {
        variant: r,
        icon: c,
        open: e,
        onClose: l,
        autoCloseDuration: o,
        children: a
      }
    ) }),
    document.body
  ) : null;
}
const ll = ms(null), im = "ToastProvider-module__container___89FP-", bm = {
  container: im
}, dm = {
  success: /* @__PURE__ */ n.jsx(ks, { size: 20 }),
  danger: /* @__PURE__ */ n.jsx($s, { size: 20 }),
  warning: /* @__PURE__ */ n.jsx(Fs, { size: 20 }),
  info: /* @__PURE__ */ n.jsx(Ba, { size: 20 })
};
function F0({ children: a }) {
  const [e, l] = x([]), r = ce((o) => {
    l((b) => b.filter((i) => i.id !== o));
  }, []), c = ce((o) => {
    const b = crypto.randomUUID();
    l((i) => [...i, { ...o, id: b }]);
  }, []);
  return /* @__PURE__ */ n.jsxs(ll.Provider, { value: { add: c, remove: r }, children: [
    a,
    /* @__PURE__ */ n.jsx("div", { className: bm.container, "aria-live": "polite", children: e.map((o) => /* @__PURE__ */ n.jsx(
      Ss,
      {
        open: !0,
        variant: o.variant,
        icon: dm[o.variant],
        onClose: () => r(o.id),
        autoCloseDuration: o.duration,
        children: o.message
      },
      o.id
    )) })
  ] });
}
const ym = 5e3;
function $0() {
  const a = rl(ll);
  if (!a)
    throw new Error("useToast must be used inside <ToastProvider>");
  const e = (r, c, o = ym) => {
    a.add({ message: r, variant: c, duration: o });
  };
  return {
    success: (r, c) => e(r, "success", c),
    error: (r, c) => e(r, "danger", c),
    warning: (r, c) => e(r, "warning", c),
    info: (r, c) => e(r, "info", c),
    execute: async (r, c) => {
      try {
        const o = await r();
        return e(c.success, "success"), o;
      } catch (o) {
        const b = c.error ?? (o instanceof Error ? o.message : "Noe gikk galt");
        e(b, "danger");
      }
    }
  };
}
const gm = {
  title: "Applikasjon",
  description: "Kart og datavisning",
  showInfoLabel: "Vis informasjon",
  showInfoTooltip: "Klikk for å vise hjelpeinformasjon",
  themeToggleLabel: "Bytt tema",
  languageToggleLabel: "Bytt språk",
  arcgisOnlineLabel: "ArcGIS Online",
  signoutLabel: "Logg ut",
  userDropdownTooltip: "Brukerinnstillinger",
  toggleMenuLabel: "Åpne/lukk meny"
}, fm = {
  close: "Lukk",
  expand: "Utvid",
  collapse: "Slå sammen"
}, pm = {
  header: gm,
  panel: fm
}, hm = {
  title: "Application",
  description: "Map and data visualization",
  showInfoLabel: "Show information",
  showInfoTooltip: "Click to show help information",
  themeToggleLabel: "Toggle theme",
  languageToggleLabel: "Change language",
  arcgisOnlineLabel: "ArcGIS Online",
  signoutLabel: "Sign out",
  userDropdownTooltip: "User settings",
  toggleMenuLabel: "Toggle menu"
}, um = {
  close: "Close",
  expand: "Expand",
  collapse: "Collapse"
}, Am = {
  header: hm,
  panel: um
}, Sm = "Legg til kartlag", Nm = "Legg til kartlag", wm = "Temakart", Um = "Bakgrunnskart", vm = "Ingen kartlag tilgjengelig", _m = "Ingen temakart tilgjengelig", xm = "Tilbakestill temakart", Lm = "Feil", Cm = "Vi fikk ikke lastet inn kartlagene fra ArcGIS Online. Prøv igjen, eller kontakt kommunens kartavdeling om problemet vedvarer.", km = "Kunne ikke legge til kartlag: {{title}}", Em = "Kunne ikke håndtere kartlaget", Mm = {
  loadingLayer: "Kunne ikke laste kartlag",
  loadingThematicMap: "Kunne ikke laste temakart"
}, jm = {
  layers: "Vis kartlag",
  mapType: "Velg karttype",
  basemap: "Velg bakgrunnskart"
}, Tm = {
  title: Sm,
  layers: Nm,
  thematicMaps: wm,
  basemaps: Um,
  noLayers: vm,
  noThematicMaps: _m,
  resetThematicMap: xm,
  error: Lm,
  errorLoadingLayers: Cm,
  errorAddingLayer: km,
  errorManagingLayer: Em,
  errors: Mm,
  tabs: jm
}, Hm = "Ja", Zm = "Nei", Rm = "Skjul", Im = "Vis", Vm = "Fra", Pm = "Til", Om = {
  ok: "OK",
  cancel: "Avbryt",
  previous: "Forrige",
  next: "Neste"
}, Fm = {
  placeholder: "Søk etter sted eller klikk i kartet..."
}, $m = {
  placeholder: "Søk etter butikk..."
}, Dm = {
  placeholder: "Velg analyseområde...",
  placeholderPlural: "Velg analyseområder...",
  mapExtent: "Kartutsnitt",
  contextDelete: "Slett analyseområdet",
  contextNew: "Lag nytt analyseområde",
  contextEdit: "Rediger analyseområdet"
}, Bm = {
  placeholder: "Søk..."
}, zm = {
  label: "Søk etter adresse eller gårds-/bruksnummer",
  placeholder: "Søk etter adresse eller gnr/bnr…",
  clearLabel: "Tøm søk",
  suggestionsLabel: "Adresseforslag",
  noResults: "Ingen treff",
  resultsHeader: "Resultater"
}, Gm = {
  yes: Hm,
  no: Zm,
  hide: Rm,
  show: Im,
  from: Vm,
  to: Pm,
  buttons: Om,
  locationhistoryselect: Fm,
  storelocationselect: $m,
  analysisareaselect: Dm,
  search: Bm,
  addressSearch: zm
}, Wm = {
  shape: "Form",
  color: "Farge",
  size: "Størrelse",
  rotation: "Rotasjon",
  outlineWidth: "Omriss bredde",
  outlineColor: "Omriss farge",
  preview: "Forhåndsvisning",
  pixels: "piksler"
}, Km = {
  clickToSelectColor: "Klikk for å velge farge",
  openColorPicker: "Åpne fargevelger"
}, qm = {
  title: "Mål på tegningen",
  showMeasurement: "Vis mål"
}, Ym = {
  title: "Tegneverktøy",
  select: "Velg",
  point: "Punkt",
  polyline: "Linje",
  polygon: "Polygon",
  rectangle: "Rektangel",
  circle: "Sirkel",
  clear: "Slett alt"
}, Jm = {
  symbolSettings: Wm,
  colorControl: Km,
  measurement: qm,
  sketchToolbar: Ym
}, Xm = "Layers", Qm = "Layers", ei = "Thematic Maps", ai = "Basemaps", ti = "No layers available", si = "No thematic maps available", li = "Reset thematic map", ni = "Error", ri = "We could not load the layers from ArcGIS Online. Try again, or contact the municipality's map department if the problem persists.", ci = "Could not add layer: {{title}}", oi = "Could not manage layer", mi = {
  loadingLayer: "Could not load layer",
  loadingThematicMap: "Could not load thematic map"
}, ii = {
  layers: "Show layers",
  mapType: "Select map type",
  basemap: "Select basemap"
}, bi = {
  title: Xm,
  layers: Qm,
  thematicMaps: ei,
  basemaps: ai,
  noLayers: ti,
  noThematicMaps: si,
  resetThematicMap: li,
  error: ni,
  errorLoadingLayers: ri,
  errorAddingLayer: ci,
  errorManagingLayer: oi,
  errors: mi,
  tabs: ii
}, di = "Yes", yi = "No", gi = "Hide", fi = "Show", pi = "From", hi = "To", ui = {
  ok: "OK",
  cancel: "Cancel",
  previous: "Previous",
  next: "Next"
}, Ai = {
  placeholder: "Search or click in the map..."
}, Si = {
  placeholder: "Select analysis area...",
  placeholderPlural: "Select analysis areas...",
  mapExtent: "Map extent",
  contextDelete: "Delete analysis area",
  contextNew: "Create new analysis area",
  contextEdit: "Edit analysis area"
}, Ni = {
  placeholder: "Search..."
}, wi = {
  label: "Search for address or cadastral number",
  placeholder: "Search for address or gnr/bnr…",
  clearLabel: "Clear search",
  suggestionsLabel: "Address suggestions",
  noResults: "No results",
  resultsHeader: "Results"
}, Ui = {
  yes: di,
  no: yi,
  hide: gi,
  show: fi,
  from: pi,
  to: hi,
  buttons: ui,
  locationhistoryselect: Ai,
  analysisareaselect: Si,
  search: Ni,
  addressSearch: wi
}, vi = {
  shape: "Shape",
  color: "Color",
  size: "Size",
  rotation: "Rotation",
  outlineWidth: "Outline width",
  outlineColor: "Outline color",
  preview: "Preview",
  pixels: "pixels"
}, _i = {
  clickToSelectColor: "Click to select color",
  openColorPicker: "Open color picker"
}, xi = {
  title: "Measurement",
  showMeasurement: "Show measurement"
}, Li = {
  title: "Sketch Tools",
  select: "Select",
  point: "Point",
  polyline: "Polyline",
  polygon: "Polygon",
  rectangle: "Rectangle",
  circle: "Circle",
  clear: "Clear"
}, Ci = {
  symbolSettings: vi,
  colorControl: _i,
  measurement: xi,
  sketchToolbar: Li
}, D0 = {
  nb: {
    uiComponents: pm,
    common: Gm,
    drawing: Jm,
    kartinnhold: Tm
  },
  en: {
    uiComponents: Am,
    common: Ui,
    drawing: Ci,
    kartinnhold: bi
  }
};
export {
  T0 as AddressSearch,
  R0 as ChangelogDialog,
  k0 as Drawing,
  E0 as DrawingCustom,
  _0 as EsriBasemapGallery,
  U0 as EsriLayerList,
  L0 as EsriLegend,
  x0 as EsriPrint,
  C0 as FlowWrapper,
  u0 as Header,
  v0 as LayerListCustom,
  M0 as LayerSelector,
  A0 as LeftPanel,
  Kc as MapItem,
  I0 as NewVersionNotice,
  N0 as OrigoLeftPanel,
  xs as OrigoPanel,
  w0 as OrigoRightPanel,
  on as PanelToolbar,
  S0 as RightPanel,
  P0 as SearchSuggestionLayer,
  j0 as ThematicMapSelector,
  F0 as ToastProvider,
  O0 as Toaster,
  Z0 as VersionTrigger,
  Lo as addressService,
  g0 as panelReducer,
  Jo as parseChangelog,
  d0 as setActiveLeftPanel,
  y0 as setActiveRightPanel,
  D0 as uiTranslations,
  f0 as useActiveLeftPanel,
  p0 as useActiveRightPanel,
  H0 as useAddressSearch,
  V0 as useNewVersionNotice,
  h0 as usePanelDispatch,
  $0 as useToast
};
//# sourceMappingURL=index.mjs.map
